const jQuery = require("jquery");;

let breakpoints;
const EVENT = "change";

const defaultBreakpoints = {
    small: "(max-width: 500px)",
    medium: "(min-width: 500.1px) and (max-width: 768px)",
    large: "(min-width: 768.1px)",
};

function createMediaQuery(query) {
    let mediaQueryList = window.matchMedia(query);
    let onEnterCallbacks = [];
    let onLeaveCallbacks = [];
    let onChangeHandlers = [];
    let kendoMediaQuery = { mediaQueryList };

    const onChangeHandler = (ev) => {
        onChangeHandlers.forEach((cb) => cb(ev));

        if (ev.matches) {
            onEnterCallbacks.forEach((cb) => cb(ev));
        } else {
            onLeaveCallbacks.forEach((cb) => cb(ev));
        }
    };

    mediaQueryList.addEventListener(EVENT, onChangeHandler);

    const onChange = (cb) => {
        onChangeHandlers.push(cb);
        return kendoMediaQuery;
    };

    const onEnter = (cb) => {
        onEnterCallbacks.push(cb);

        if (mediaQueryList.matches) {
            const media = mediaQueryList.media;
            const matches = true;

            const ev = new MediaQueryListEvent(EVENT, {
                media,
                matches,
            });

            cb(ev);
        }

        return kendoMediaQuery;
    };

    const onLeave = (cb) => {
        onLeaveCallbacks.push(cb);
        return kendoMediaQuery;
    };

    const destroy = () => {
        if (mediaQueryList) {
            mediaQueryList.removeEventListener(EVENT, onChangeHandler);
        }
        onEnterCallbacks = null;
        onLeaveCallbacks = null;
        onChangeHandlers = null;
        mediaQueryList = null;
        kendoMediaQuery = null;
    };

    kendoMediaQuery.onChange = onChange;
    kendoMediaQuery.onEnter = onEnter;
    kendoMediaQuery.onLeave = onLeave;
    kendoMediaQuery.destroy = destroy;

    return kendoMediaQuery;
}

function mediaQuery(query) {
    if (!query) {
        return;
    }

    breakpoints =
        breakpoints ||
        Object.assign({}, defaultBreakpoints, kendo.defaults.breakpoints);

    if (query in breakpoints) {
        query = breakpoints[query];
    }

    return createMediaQuery(query);
}

var __meta__ = {
    id: "core",
    name: "Core",
    category: "framework",
    description: "The core of the Kendo framework."
};

var packageMetadata = {
    name: '@progress/kendo-ui',
    productName: 'Kendo UI',
    productCodes: ['KENDOUICOMPLETE', 'KENDOUI', 'UIASPCORE', 'KENDOMVC', 'KENDOUIMVC'],
    publishDate: 1715674547,
    version: '2024.2.514'.replace(/^\s+|\s+$/g, ''),
    licensingDocsUrl: 'https://docs.telerik.com/kendo-ui/intro/installation/using-license-code?utm_medium=product&utm_source=kendojquery&utm_campaign=kendo-ui-jquery-purchase-license-keys-warning'
};


(function($, window, undefined$1) {
    var kendo = window.kendo = window.kendo || { cultures: {} },
        extend = $.extend,
        each = $.each,
        isArray = Array.isArray,
        noop = $.noop,
        math = Math,
        Template,
        JSON = window.JSON || {},
        support = {},
        percentRegExp = /%/,
        formatRegExp = /\{(\d+)(:[^\}]+)?\}/g,
        boxShadowRegExp = /(\d+(?:\.?)\d*)px\s*(\d+(?:\.?)\d*)px\s*(\d+(?:\.?)\d*)px\s*(\d+)?/i,
        numberRegExp = /^(\+|-?)\d+(\.?)\d*$/,
        MONTH = "month",
        HOUR = "hour",
        ZONE = "zone",
        WEEKDAY = "weekday",
        QUARTER = "quarter",
        DATE_FIELD_MAP = {
            "G": "era",
            "y": "year",
            "q": QUARTER,
            "Q": QUARTER,
            "M": MONTH,
            "L": MONTH,
            "d": "day",
            "E": WEEKDAY,
            "c": WEEKDAY,
            "e": WEEKDAY,
            "h": HOUR,
            "H": HOUR,
            "k": HOUR,
            "K": HOUR,
            "m": "minute",
            "s": "second",
            "a": "dayperiod",
            "t": "dayperiod",
            "x": ZONE,
            "X": ZONE,
            "z": ZONE,
            "Z": ZONE
        },
        NAME_TYPES = {
            month: {
                type: "months",
                minLength: 3,
                standAlone: "L"
            },

            quarter: {
                type: "quarters",
                minLength: 3,
                standAlone: "q"
            },

            weekday: {
                type: "days",
                minLength: {
                    E: 0,
                    c: 3,
                    e: 3
                },
                standAlone: "c"
            },

            dayperiod: {
                type: "dayPeriods",
                minLength: 0
            },

            era: {
                type: "eras",
                minLength: 0
            }
        },
        FUNCTION = "function",
        STRING = "string",
        NUMBER = "number",
        OBJECT = "object",
        NULL = "null",
        BOOLEAN = "boolean",
        UNDEFINED = "undefined",
        PREFIX = "prefix",
        ARIA_LABELLEDBY = "aria-labelledby",
        ARIA_LABEL = "aria-label",
        LABELIDPART = "_label",
        getterCache = {},
        setterCache = {},
        slice = [].slice,
        cssPropertiesNames = [ "themeColor", "fillMode", "shape", "size", "rounded", "positionMode" ],
        // avoid extending the depricated properties in latest verions of jQuery
        noDepricateExtend = function() {
            var src, copyIsArray, copy, name, options, clone,
                target = arguments[ 0 ] || {},
                i = 1,
                length = arguments.length,
                deep = false;

            // Handle a deep copy situation
            if ( typeof target === "boolean" ) {
                deep = target;

                // skip the boolean and the target
                target = arguments[ i ] || {};
                i++;
            }

            // Handle case when target is a string or something (possible in deep copy)
            if ( typeof target !== "object" && typeof target !== "function") {
                target = {};
            }

            // extend jQuery itself if only one argument is passed
            if ( i === length ) {
                target = this;
                i--;
            }

            for ( ; i < length; i++ ) {

                // Only deal with non-null/undefined values
                if ( ( options = arguments[ i ] ) != null ) {

                    // Extend the base object
                    for ( name in options ) {
                        // filters, concat and : properties are depricated in the jQuery 3.3.0
                        // accessing these properties throw a warning when jQuery migrate is included
                        if (name == "filters" || name == "concat" || name == ":") {
                            continue;
                        }
                        src = target[ name ];
                        copy = options[ name ];

                        // Prevent never-ending loop
                        if ( target === copy ) {
                            continue;
                        }

                        // Recurse if we're merging plain objects or arrays
                        if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
                            ( copyIsArray = Array.isArray( copy ) ) ) ) {

                            if ( copyIsArray ) {
                                copyIsArray = false;
                                clone = src && Array.isArray( src ) ? src : [];

                            } else {
                                clone = src && jQuery.isPlainObject( src ) ? src : {};
                            }

                            // Never move original objects, clone them
                            target[ name ] = noDepricateExtend( deep, clone, copy );

                        // Don't bring in undefined values
                        } else if ( copy !== undefined$1 ) {
                            target[ name ] = copy;
                        }
                    }
                }
            }

            // Return the modified object
            return target;
        };

    kendo.version = "2024.2.514".replace(/^\s+|\s+$/g, '');

    function Class() {}

    Class.extend = function(proto) {
        var base = function() {},
            member,
            that = this,
            subclass = proto && proto.init ? proto.init : function() {
                that.apply(this, arguments);
            },
            fn;

        base.prototype = that.prototype;
        fn = subclass.fn = subclass.prototype = new base();

        for (member in proto) {
            if (proto[member] != null && proto[member].constructor === Object) {
                // Merge object members
                fn[member] = extend(true, {}, base.prototype[member], proto[member]);
            } else {
                fn[member] = proto[member];
            }
        }

        fn.constructor = subclass;
        subclass.extend = that.extend;

        return subclass;
    };

    Class.prototype._initOptions = function(options) {
        this.options = deepExtend({}, this.options, options);
    };

    const isPresent = kendo.isPresent = (value) => value !== null && value !== undefined$1;
    const isBlank = kendo.isBlank = (value) => value === null || value === undefined$1;
    const isString = kendo.isString = (value) => typeof value === 'string';
    const isNumeric = kendo.isNumeric = (value) => !isNaN(value - parseFloat(value));
    const isDate = kendo.isDate = (value) => value && value.getTime;
    const isFunction = kendo.isFunction = (value) => typeof value === 'function';

    var preventDefault = function() {
        this._defaultPrevented = true;
    };

    var isDefaultPrevented = function() {
        return this._defaultPrevented === true;
    };

    var Observable = Class.extend({
        init: function() {
            this._events = {};
        },

        bind: function(eventName, handlers, one) {
            var that = this,
                idx,
                eventNames = typeof eventName === STRING ? [eventName] : eventName,
                length,
                original,
                handler,
                handlersIsFunction = typeof handlers === FUNCTION,
                events;

            if (handlers === undefined$1) {
                for (idx in eventName) {
                    that.bind(idx, eventName[idx]);
                }
                return that;
            }

            for (idx = 0, length = eventNames.length; idx < length; idx++) {
                eventName = eventNames[idx];

                handler = handlersIsFunction ? handlers : handlers[eventName];

                if (handler) {
                    if (one) {
                        original = handler;
                        handler = function() {
                            that.unbind(eventName, handler);
                            original.apply(that, arguments);
                        };
                        handler.original = original;
                    }
                    events = that._events[eventName] = that._events[eventName] || [];
                    events.push(handler);
                }
            }

            return that;
        },

        one: function(eventNames, handlers) {
            return this.bind(eventNames, handlers, true);
        },

        first: function(eventName, handlers) {
            var that = this,
                idx,
                eventNames = typeof eventName === STRING ? [eventName] : eventName,
                length,
                handler,
                handlersIsFunction = typeof handlers === FUNCTION,
                events;

            for (idx = 0, length = eventNames.length; idx < length; idx++) {
                eventName = eventNames[idx];

                handler = handlersIsFunction ? handlers : handlers[eventName];

                if (handler) {
                    events = that._events[eventName] = that._events[eventName] || [];
                    events.unshift(handler);
                }
            }

            return that;
        },

        trigger: function(eventName, e) {
            var that = this,
                events = that._events[eventName],
                idx,
                length;

            if (events) {
                e = e || {};

                e.sender = that;

                e._defaultPrevented = false;

                e.preventDefault = preventDefault;

                e.isDefaultPrevented = isDefaultPrevented;

                events = events.slice();

                for (idx = 0, length = events.length; idx < length; idx++) {
                    events[idx].call(that, e);
                }

                return e._defaultPrevented === true;
            }

            return false;
        },

        unbind: function(eventName, handler) {
            var that = this,
                events = that._events[eventName],
                idx;

            if (eventName === undefined$1) {
                that._events = {};
            } else if (events) {
                if (handler) {
                    for (idx = events.length - 1; idx >= 0; idx--) {
                        if (events[idx] === handler || events[idx].original === handler) {
                            events.splice(idx, 1);
                        }
                    }
                } else {
                    that._events[eventName] = [];
                }
            }

            return that;
        }
    });


     function compilePart(part, stringPart) {
         if (stringPart) {
             return "'" +
                 part.split("'").join("\\'")
                     .split('\\"').join('\\\\\\"')
                     .replace(/\n/g, "\\n")
                     .replace(/\r/g, "\\r")
                     .replace(/\t/g, "\\t") + "'";
         } else {
             var first = part.charAt(0),
                 rest = part.substring(1);

             if (first === "=") {
                 return "+(" + rest + ")+";
             } else if (first === ":") {
                 return "+$kendoHtmlEncode(" + rest + ")+";
             } else {
                 return ";" + part + ";$kendoOutput+=";
             }
         }
     }

    var argumentNameRegExp = /^\w+/,
        encodeRegExp = /\$\{([^}]*)\}/g,
        escapedCurlyRegExp = /\\\}/g,
        curlyRegExp = /__CURLY__/g,
        escapedSharpRegExp = /\\#/g,
        sharpRegExp = /__SHARP__/g,
        zeros = ["", "0", "00", "000", "0000"];

    Template = {
        paramName: "data", // name of the parameter of the generated template
        useWithBlock: true, // whether to wrap the template in a with() block
        render: function(template, data) {
            var idx,
                length,
                html = "";

            for (idx = 0, length = data.length; idx < length; idx++) {
                html += template(data[idx]);
            }

            return html;
        },
        compile: function(template, options) {
            var settings = extend({}, this, options),
                paramName = settings.paramName,
                argumentName = paramName.match(argumentNameRegExp)[0],
                useWithBlock = settings.useWithBlock,
                functionBody = "var $kendoOutput, $kendoHtmlEncode = kendo.htmlEncode;",
                fn,
                parts,
                idx;

            if (isFunction(template)) {
                return template;
            }

            functionBody += useWithBlock ? "with(" + paramName + "){" : "";

            functionBody += "$kendoOutput=";

            parts = template
                .replace(escapedCurlyRegExp, "__CURLY__")
                .replace(encodeRegExp, "#=$kendoHtmlEncode($1)#")
                .replace(curlyRegExp, "}")
                .replace(escapedSharpRegExp, "__SHARP__")
                .split("#");

            for (idx = 0; idx < parts.length; idx ++) {
                functionBody += compilePart(parts[idx], idx % 2 === 0);
            }

            functionBody += useWithBlock ? ";}" : ";";

            functionBody += "return $kendoOutput;";

            functionBody = functionBody.replace(sharpRegExp, "#");

            try {
                // This function evaluation is required for legacy support of the Kendo Template syntax - non CSP compliant.
                fn = new Function(argumentName, functionBody);
                fn._slotCount = Math.floor(parts.length / 2);
                return fn;
            } catch (e) {
                if (kendo.debugTemplates) {
                    window.console.warn(`Invalid template:'${template}' Generated code:'${functionBody}'`);
                } else {
                    throw new Error(kendo.format("Invalid template:'{0}' Generated code:'{1}'", template, functionBody));
                }
            }
        }
    };

function pad(number, digits, end) {
    number = number + "";
    digits = digits || 2;
    end = digits - number.length;

    if (end) {
        return zeros[digits].substring(0, end) + number;
    }

    return number;
}

    //JSON stringify
(function() {
    var escapable = /[\\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,
        gap,
        indent,
        meta = {
            "\b": "\\b",
            "\t": "\\t",
            "\n": "\\n",
            "\f": "\\f",
            "\r": "\\r",
            "\"": '\\"',
            "\\": "\\\\"
        },
        rep,
        toString = {}.toString;


    if (typeof Date.prototype.toJSON !== FUNCTION) {

        Date.prototype.toJSON = function() {
            var that = this;

            return isFinite(that.valueOf()) ?
                pad(that.getUTCFullYear(), 4) + "-" +
                pad(that.getUTCMonth() + 1) + "-" +
                pad(that.getUTCDate()) + "T" +
                pad(that.getUTCHours()) + ":" +
                pad(that.getUTCMinutes()) + ":" +
                pad(that.getUTCSeconds()) + "Z" : null;
        };

        String.prototype.toJSON = Number.prototype.toJSON = Boolean.prototype.toJSON = function() {
            return this.valueOf();
        };
    }

    function quote(string) {
        escapable.lastIndex = 0;
        return escapable.test(string) ? "\"" + string.replace(escapable, function(a) {
            var c = meta[a];
            return typeof c === STRING ? c :
                "\\u" + ("0000" + a.charCodeAt(0).toString(16)).slice(-4);
        }) + "\"" : "\"" + string + "\"";
    }

    function str(key, holder) {
        var i,
            k,
            v,
            length,
            mind = gap,
            partial,
            value = holder[key],
            type;

        if (value && typeof value === OBJECT && typeof value.toJSON === FUNCTION) {
            value = value.toJSON(key);
        }

        if (typeof rep === FUNCTION) {
            value = rep.call(holder, key, value);
        }

        type = typeof value;
        if (type === STRING) {
            return quote(value);
        } else if (type === NUMBER) {
            return isFinite(value) ? String(value) : NULL;
        } else if (type === BOOLEAN || type === NULL) {
            return String(value);
        } else if (type === OBJECT) {
            if (!value) {
                return NULL;
            }
            gap += indent;
            partial = [];
            if (toString.apply(value) === "[object Array]") {
                length = value.length;
                for (i = 0; i < length; i++) {
                    partial[i] = str(i, value) || NULL;
                }
                v = partial.length === 0 ? "[]" : gap ?
                    "[\n" + gap + partial.join(",\n" + gap) + "\n" + mind + "]" :
                    "[" + partial.join(",") + "]";
                gap = mind;
                return v;
            }
            if (rep && typeof rep === OBJECT) {
                length = rep.length;
                for (i = 0; i < length; i++) {
                    if (typeof rep[i] === STRING) {
                        k = rep[i];
                        v = str(k, value);
                        if (v) {
                            partial.push(quote(k) + (gap ? ": " : ":") + v);
                        }
                    }
                }
            } else {
                for (k in value) {
                    if (Object.hasOwnProperty.call(value, k)) {
                        v = str(k, value);
                        if (v) {
                            partial.push(quote(k) + (gap ? ": " : ":") + v);
                        }
                    }
                }
            }

            v = partial.length === 0 ? "{}" : gap ?
                "{\n" + gap + partial.join(",\n" + gap) + "\n" + mind + "}" :
                "{" + partial.join(",") + "}";
            gap = mind;
            return v;
        }
    }

    if (typeof JSON.stringify !== FUNCTION) {
        JSON.stringify = function(value, replacer, space) {
            var i;
            gap = "";
            indent = "";

            if (typeof space === NUMBER) {
                for (i = 0; i < space; i += 1) {
                    indent += " ";
                }

            } else if (typeof space === STRING) {
                indent = space;
            }

            rep = replacer;
            if (replacer && typeof replacer !== FUNCTION && (typeof replacer !== OBJECT || typeof replacer.length !== NUMBER)) {
                throw new Error("JSON.stringify");
            }

            return str("", { "": value });
        };
    }
})();

// Date and Number formatting
(function() {
    var dateFormatRegExp = /EEEE|dddd|ddd|dd|d|MMMM|MMM|MM|M|yyyy|yy|HH|H|hh|h|mm|m|fff|ff|f|tt|ss|s|zzz|zz|z|"[^"]*"|'[^']*'/g,
        standardFormatRegExp = /^(n|c|p|e)(\d*)$/i,
        literalRegExp = /(\\.)|(['][^']*[']?)|(["][^"]*["]?)/g,
        commaRegExp = /\,/g,
        EMPTY = "",
        POINT = ".",
        COMMA = ",",
        SHARP = "#",
        ZERO = "0",
        PLACEHOLDER = "??",
        EN = "en-US",
        objectToString = {}.toString;

    //cultures
    kendo.cultures = kendo.cultures || {}; // Ensure cultures object exists
    kendo.cultures["en-US"] = {
        name: EN,
        numberFormat: {
            pattern: ["-n"],
            decimals: 2,
            ",": ",",
            ".": ".",
            groupSize: [3],
            percent: {
                pattern: ["-n %", "n %"],
                decimals: 2,
                ",": ",",
                ".": ".",
                groupSize: [3],
                symbol: "%"
            },
            currency: {
                name: "US Dollar",
                abbr: "USD",
                pattern: ["($n)", "$n"],
                decimals: 2,
                ",": ",",
                ".": ".",
                groupSize: [3],
                symbol: "$"
            }
        },
        calendars: {
            standard: {
                days: {
                    names: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
                    namesAbbr: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
                    namesShort: [ "Su", "Mo", "Tu", "We", "Th", "Fr", "Sa" ]
                },
                months: {
                    names: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
                    namesAbbr: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
                },
                AM: [ "AM", "am", "AM" ],
                PM: [ "PM", "pm", "PM" ],
                patterns: {
                    d: "M/d/yyyy",
                    D: "dddd, MMMM dd, yyyy",
                    F: "dddd, MMMM dd, yyyy h:mm:ss tt",
                    g: "M/d/yyyy h:mm tt",
                    G: "M/d/yyyy h:mm:ss tt",
                    m: "MMMM dd",
                    M: "MMMM dd",
                    s: "yyyy'-'MM'-'ddTHH':'mm':'ss",
                    t: "h:mm tt",
                    T: "h:mm:ss tt",
                    u: "yyyy'-'MM'-'dd HH':'mm':'ss'Z'",
                    y: "MMMM, yyyy",
                    Y: "MMMM, yyyy"
                },
                "/": "/",
                ":": ":",
                firstDay: 0,
                twoDigitYearMax: 2029
            }
        }
    };


     function findCulture(culture) {
        if (culture) {
            if (culture.numberFormat) {
                return culture;
            }

            if (typeof culture === STRING) {
                var cultures = kendo.cultures;
                return cultures[culture] || cultures[culture.split("-")[0]] || null;
            }

            return null;
        }

        return null;
    }

    function getCulture(culture) {
        if (culture) {
            culture = findCulture(culture);
        }

        return culture || kendo.cultures.current;
    }

    function appendDesignatorsToCultures(calendars) {
        // Don't ask. It's temporary.
        if ((calendars.standard.AM && calendars.standard.AM.length)
        && (calendars.standard.PM && calendars.standard.PM.length)
        && (calendars.standard.AM.indexOf("PMA0") < 0)
        && (calendars.standard.AM.indexOf("AM") > -1 || calendars.standard.PM.indexOf("PM") > -1)) {
            calendars.standard.AM.push("a", "A", "PMa", "PMA", "PMa0", "PMA0");
            calendars.standard.PM.push("p", "P", "AMp", "AMP", "AMp0", "AMP0");
        }
    }

    kendo.culture = function(cultureName) {
        var cultures = kendo.cultures, culture;

        if (cultureName !== undefined$1) {
            culture = findCulture(cultureName) || cultures[EN];
            culture.calendar = culture.calendars.standard;
            cultures.current = culture;
        } else {
            appendDesignatorsToCultures(cultures.current.calendars);
            return cultures.current;
        }
    };

    kendo.findCulture = findCulture;
    kendo.getCulture = getCulture;

    //set current culture to en-US.
    kendo.culture(EN);

    function formatDate(date, format, culture) {
        culture = getCulture(culture);

        var calendar = culture.calendars.standard,
            days = calendar.days,
            months = calendar.months;

        format = format.pattern || calendar.patterns[format] || format;

        return format.replace(dateFormatRegExp, function(match) {
            var minutes;
            var result;
            var sign;

            if (match === "d") {
                result = date.getDate();
            } else if (match === "dd") {
                result = pad(date.getDate());
            } else if (match === "ddd") {
                result = days.namesAbbr[date.getDay()];
            } else if (match === "dddd" || match === "EEEE") {
                result = days.names[date.getDay()];
            } else if (match === "M") {
                result = date.getMonth() + 1;
            } else if (match === "MM") {
                result = pad(date.getMonth() + 1);
            } else if (match === "MMM") {
                result = months.namesAbbr[date.getMonth()];
            } else if (match === "MMMM") {
                result = months.names[date.getMonth()];
            } else if (match === "yy") {
                result = pad(date.getFullYear() % 100);
            } else if (match === "yyyy") {
                result = pad(date.getFullYear(), 4);
            } else if (match === "h" ) {
                result = date.getHours() % 12 || 12;
            } else if (match === "hh") {
                result = pad(date.getHours() % 12 || 12);
            } else if (match === "H") {
                result = date.getHours();
            } else if (match === "HH") {
                result = pad(date.getHours());
            } else if (match === "m") {
                result = date.getMinutes();
            } else if (match === "mm") {
                result = pad(date.getMinutes());
            } else if (match === "s") {
                result = date.getSeconds();
            } else if (match === "ss") {
                result = pad(date.getSeconds());
            } else if (match === "f") {
                result = math.floor(date.getMilliseconds() / 100);
            } else if (match === "ff") {
                result = date.getMilliseconds();
                if (result > 99) {
                    result = math.floor(result / 10);
                }
                result = pad(result);
            } else if (match === "fff") {
                result = pad(date.getMilliseconds(), 3);
            } else if (match === "tt" || match === "aa") {
                result = date.getHours() < 12 ? calendar.AM[0] : calendar.PM[0];
            } else if (match === "zzz") {
                minutes = date.getTimezoneOffset();
                sign = minutes < 0;

                result = math.abs(minutes / 60).toString().split(".")[0];
                minutes = math.abs(minutes) - (result * 60);

                result = (sign ? "+" : "-") + pad(result);
                result += ":" + pad(minutes);
            } else if (match === "zz" || match === "z") {
                result = date.getTimezoneOffset() / 60;
                sign = result < 0;

                result = math.abs(result).toString().split(".")[0];
                result = (sign ? "+" : "-") + (match === "zz" ? pad(result) : result);
            }

            return result !== undefined$1 ? result : match.slice(1, match.length - 1);
        });
    }

    //number formatting
    function formatNumber(number, format, culture) {
        culture = getCulture(culture);

        var numberFormat = culture.numberFormat,
            decimal = numberFormat[POINT],
            precision = numberFormat.decimals,
            pattern = numberFormat.pattern[0],
            literals = [],
            symbol,
            isCurrency, isPercent,
            customPrecision,
            formatAndPrecision,
            negative = number < 0,
            integer,
            fraction,
            integerLength,
            fractionLength,
            replacement = EMPTY,
            value = EMPTY,
            idx,
            length,
            ch,
            hasGroup,
            hasNegativeFormat,
            decimalIndex,
            sharpIndex,
            zeroIndex,
            hasZero, hasSharp,
            percentIndex,
            currencyIndex,
            startZeroIndex,
            start = -1,
            end;

        //return empty string if no number
        if (number === undefined$1) {
            return EMPTY;
        }

        if (!isFinite(number)) {
            return number;
        }

        //if no format then return number.toString() or number.toLocaleString() if culture.name is not defined
        if (!format) {
            return culture.name.length ? number.toLocaleString() : number.toString();
        }

        formatAndPrecision = standardFormatRegExp.exec(format);

        // standard formatting
        if (formatAndPrecision) {
            format = formatAndPrecision[1].toLowerCase();

            isCurrency = format === "c";
            isPercent = format === "p";

            if (isCurrency || isPercent) {
                //get specific number format information if format is currency or percent
                numberFormat = isCurrency ? numberFormat.currency : numberFormat.percent;
                decimal = numberFormat[POINT];
                precision = numberFormat.decimals;
                symbol = numberFormat.symbol;
                pattern = numberFormat.pattern[negative ? 0 : 1];
            }

            customPrecision = formatAndPrecision[2];

            if (customPrecision) {
                precision = +customPrecision;
            }

            //return number in exponential format
            if (format === "e") {
                var exp = customPrecision ? number.toExponential(precision) : number.toExponential(); // toExponential() and toExponential(undefined) differ in FF #653438.

                return exp.replace(POINT, numberFormat[POINT]);
            }

            // multiply if format is percent
            if (isPercent) {
                number *= 100;
            }

            number = round(number, precision);
            negative = number < 0;
            number = number.split(POINT);

            integer = number[0];
            fraction = number[1];

            //exclude "-" if number is negative.
            if (negative) {
                integer = integer.substring(1);
            }

            value = groupInteger(integer, 0, integer.length, numberFormat);

            if (fraction) {
                value += decimal + fraction;
            }

            if (format === "n" && !negative) {
                return value;
            }

            number = EMPTY;

            for (idx = 0, length = pattern.length; idx < length; idx++) {
                ch = pattern.charAt(idx);

                if (ch === "n") {
                    number += value;
                } else if (ch === "$" || ch === "%") {
                    number += symbol;
                } else {
                    number += ch;
                }
            }

            return number;
        }

        //custom formatting
        //
        //separate format by sections.

        if (format.indexOf("'") > -1 || format.indexOf("\"") > -1 || format.indexOf("\\") > -1) {
            format = format.replace(literalRegExp, function(match) {
                var quoteChar = match.charAt(0).replace("\\", ""),
                    literal = match.slice(1).replace(quoteChar, "");

                literals.push(literal);

                return PLACEHOLDER;
            });
        }

        format = format.split(";");
        if (negative && format[1]) {
            //get negative format
            format = format[1];
            hasNegativeFormat = true;
        } else if (number === 0 && format[2]) {
            //format for zeros
            format = format[2];
            if (format.indexOf(SHARP) == -1 && format.indexOf(ZERO) == -1) {
                //return format if it is string constant.
                return format;
            }
        } else {
            format = format[0];
        }

        percentIndex = format.indexOf("%");
        currencyIndex = format.indexOf("$");

        isPercent = percentIndex != -1;
        isCurrency = currencyIndex != -1;

        //multiply number if the format has percent
        if (isPercent) {
            number *= 100;
        }

        if (isCurrency && format[currencyIndex - 1] === "\\") {
            format = format.split("\\").join("");
            isCurrency = false;
        }

        if (isCurrency || isPercent) {
            //get specific number format information if format is currency or percent
            numberFormat = isCurrency ? numberFormat.currency : numberFormat.percent;
            decimal = numberFormat[POINT];
            precision = numberFormat.decimals;
            symbol = numberFormat.symbol;
        }

        hasGroup = format.indexOf(COMMA) > -1;
        if (hasGroup) {
            format = format.replace(commaRegExp, EMPTY);
        }

        decimalIndex = format.indexOf(POINT);
        length = format.length;

        if (decimalIndex != -1) {
            fraction = number.toString().split("e");
            if (fraction[1]) {
                fraction = round(number, Math.abs(fraction[1]));
            } else {
                fraction = fraction[0];
            }
            fraction = fraction.split(POINT)[1] || EMPTY;
            zeroIndex = format.lastIndexOf(ZERO) - decimalIndex;
            sharpIndex = format.lastIndexOf(SHARP) - decimalIndex;
            hasZero = zeroIndex > -1;
            hasSharp = sharpIndex > -1;
            idx = fraction.length;

            if (!hasZero && !hasSharp) {
                format = format.substring(0, decimalIndex) + format.substring(decimalIndex + 1);
                length = format.length;
                decimalIndex = -1;
                idx = 0;
            }

            if (hasZero && zeroIndex > sharpIndex) {
                idx = zeroIndex;
            } else if (sharpIndex > zeroIndex) {
                if (hasSharp && idx > sharpIndex) {
                    var rounded = round(number, sharpIndex, negative);

                    while (rounded.charAt(rounded.length - 1) === ZERO && sharpIndex > 0 && sharpIndex > zeroIndex) {
                        sharpIndex--;

                        rounded = round(number, sharpIndex, negative);
                    }

                    idx = sharpIndex;
                } else if (hasZero && idx < zeroIndex) {
                    idx = zeroIndex;
                }
            }
        }

        number = round(number, idx, negative);

        sharpIndex = format.indexOf(SHARP);
        startZeroIndex = zeroIndex = format.indexOf(ZERO);

        //define the index of the first digit placeholder
        if (sharpIndex == -1 && zeroIndex != -1) {
            start = zeroIndex;
        } else if (sharpIndex != -1 && zeroIndex == -1) {
            start = sharpIndex;
        } else {
            start = sharpIndex > zeroIndex ? zeroIndex : sharpIndex;
        }

        sharpIndex = format.lastIndexOf(SHARP);
        zeroIndex = format.lastIndexOf(ZERO);

        //define the index of the last digit placeholder
        if (sharpIndex == -1 && zeroIndex != -1) {
            end = zeroIndex;
        } else if (sharpIndex != -1 && zeroIndex == -1) {
            end = sharpIndex;
        } else {
            end = sharpIndex > zeroIndex ? sharpIndex : zeroIndex;
        }

        if (start == length) {
            end = start;
        }

        if (start != -1) {
            value = number.toString().split(POINT);
            integer = value[0];
            fraction = value[1] || EMPTY;

            integerLength = integer.length;
            fractionLength = fraction.length;

            if (negative && (number * -1) >= 0) {
                negative = false;
            }

            number = format.substring(0, start);

            if (negative && !hasNegativeFormat) {
                number += "-";
            }

            for (idx = start; idx < length; idx++) {
                ch = format.charAt(idx);

                if (decimalIndex == -1) {
                    if (end - idx < integerLength) {
                        number += integer;
                        break;
                    }
                } else {
                    if (zeroIndex != -1 && zeroIndex < idx) {
                        replacement = EMPTY;
                    }

                    if ((decimalIndex - idx) <= integerLength && decimalIndex - idx > -1) {
                        number += integer;
                        idx = decimalIndex;
                    }

                    if (decimalIndex === idx) {
                        number += (fraction ? decimal : EMPTY) + fraction;
                        idx += end - decimalIndex + 1;
                        continue;
                    }
                }

                if (ch === ZERO) {
                    number += ch;
                    replacement = ch;
                } else if (ch === SHARP) {
                    number += replacement;
                }
            }

            if (hasGroup) {
                number = groupInteger(number, start + (negative && !hasNegativeFormat ? 1 : 0), Math.max(end, (integerLength + start)), numberFormat);
            }

            if (end >= start) {
                number += format.substring(end + 1);
            }

            //replace symbol placeholders
            if (isCurrency || isPercent) {
                value = EMPTY;
                for (idx = 0, length = number.length; idx < length; idx++) {
                    ch = number.charAt(idx);
                    value += (ch === "$" || ch === "%") ? symbol : ch;
                }
                number = value;
            }

            length = literals.length;

            if (length) {
                for (idx = 0; idx < length; idx++) {
                    number = number.replace(PLACEHOLDER, literals[idx]);
                }
            }
        }

        return number;
    }

    var groupInteger = function(number, start, end, numberFormat) {
        var decimalIndex = number.indexOf(numberFormat[POINT]);
        var groupSizes = numberFormat.groupSize.slice();
        var groupSize = groupSizes.shift();
        var integer, integerLength;
        var idx, parts, value;
        var newGroupSize;

        end = decimalIndex !== -1 ? decimalIndex : end + 1;

        integer = number.substring(start, end);
        integerLength = integer.length;

        if (integerLength >= groupSize) {
            idx = integerLength;
            parts = [];

            while (idx > -1) {
                value = integer.substring(idx - groupSize, idx);
                if (value) {
                    parts.push(value);
                }
                idx -= groupSize;
                newGroupSize = groupSizes.shift();
                groupSize = newGroupSize !== undefined$1 ? newGroupSize : groupSize;

                if (groupSize === 0) {
                    if (idx > 0) {
                        parts.push(integer.substring(0, idx));
                    }
                    break;
                }
            }

            integer = parts.reverse().join(numberFormat[COMMA]);
            number = number.substring(0, start) + integer + number.substring(end);
        }

        return number;
    };

    var round = function(value, precision, negative) {
        precision = precision || 0;

        value = value.toString().split('e');
        value = Math.round(+(value[0] + 'e' + (value[1] ? (+value[1] + precision) : precision)));

        if (negative) {
            value = -value;
        }

        value = value.toString().split('e');
        value = +(value[0] + 'e' + (value[1] ? (+value[1] - precision) : -precision));

        return value.toFixed(Math.min(precision, 20));
    };

    var toString = function(value, fmt, culture) {
        if (fmt) {
            if (objectToString.call(value) === "[object Date]") {
                return formatDate(value, fmt, culture);
            } else if (typeof value === NUMBER) {
                return formatNumber(value, fmt, culture);
            }
        }

        return value !== undefined$1 ? value : "";
    };

    kendo.format = function(fmt) {
        var values = arguments;

        return fmt.replace(formatRegExp, function(match, index, placeholderFormat) {
            var value = values[parseInt(index, 10) + 1];

            return toString(value, placeholderFormat ? placeholderFormat.substring(1) : "");
        });
    };

    kendo._extractFormat = function(format) {
        if (format.slice(0,3) === "{0:") {
            format = format.slice(3, format.length - 1);
        }

        return format;
    };

    kendo._activeElement = function() {
        try {
            return document.activeElement;
        } catch (e) {
            return document.documentElement.activeElement;
        }
    };

    kendo._round = round;
    kendo._outerWidth = function(element, includeMargin, calculateFromHidden) {
        element = $(element);
        if (calculateFromHidden) {
            return getHiddenDimensions(element, includeMargin).width;
        }

        return $(element).outerWidth(includeMargin || false) || 0;
    };
    kendo._outerHeight = function(element, includeMargin, calculateFromHidden) {
        element = $(element);
        if (calculateFromHidden) {
            return getHiddenDimensions(element, includeMargin).height;
        }

        return $(element).outerHeight(includeMargin || false) || 0;
    };
    kendo.toString = toString;
})();


(function() {
    var nonBreakingSpaceRegExp = /\u00A0/g,
        spaceRegExp = /\s/g,
        exponentRegExp = /[eE][\-+]?[0-9]+/,
        shortTimeZoneRegExp = /[+|\-]\d{1,2}/,
        longTimeZoneRegExp = /[+|\-]\d{1,2}:?\d{2}/,
        dateRegExp = /^\/Date\((.*?)\)\/$/,
        offsetRegExp = /[+-]\d*/,
        FORMATS_SEQUENCE = [ [], [ "G", "g", "F" ], [ "D", "d", "y", "m", "T", "t" ] ],
        STANDARD_FORMATS = [
            [
            "yyyy-MM-ddTHH:mm:ss.fffffffzzz",
            "yyyy-MM-ddTHH:mm:ss.fffffff",
            "yyyy-MM-ddTHH:mm:ss.fffzzz",
            "yyyy-MM-ddTHH:mm:ss.fff",
            "ddd MMM dd yyyy HH:mm:ss",
            "yyyy-MM-ddTHH:mm:sszzz",
            "yyyy-MM-ddTHH:mmzzz",
            "yyyy-MM-ddTHH:mmzz",
            "yyyy-MM-ddTHH:mm:ss",
            "yyyy-MM-dd HH:mm:ss",
            "yyyy/MM/dd HH:mm:ss"
            ], [
            "yyyy-MM-ddTHH:mm",
            "yyyy-MM-dd HH:mm",
            "yyyy/MM/dd HH:mm"
            ], [
            "yyyy/MM/dd",
            "yyyy-MM-dd",
            "HH:mm:ss",
            "HH:mm"
            ]
        ],
        numberRegExp = {
            2: /^\d{1,2}/,
            3: /^\d{1,3}/,
            4: /^\d{4}/,
            exact3: /^\d{3}/
        },
        objectToString = {}.toString;

    function outOfRange(value, start, end) {
        return !(value >= start && value <= end);
    }

    function designatorPredicate(designator) {
        return designator.charAt(0);
    }

    function mapDesignators(designators) {
        return $.map(designators, designatorPredicate);
    }

    //if date's day is different than the typed one - adjust
    function adjustDST(date, hours) {
        if (!hours && date.getHours() === 23) {
            date.setHours(date.getHours() + 2);
        }
    }

    function lowerArray(data) {
        var idx = 0,
            length = data.length,
            array = [];

        for (; idx < length; idx++) {
            array[idx] = (data[idx] + "").toLowerCase();
        }

        return array;
    }

    function lowerLocalInfo(localInfo) {
        var newLocalInfo = {}, property;

        for (property in localInfo) {
            newLocalInfo[property] = lowerArray(localInfo[property]);
        }

        return newLocalInfo;
    }

    function unpadZero(value) {
        return value.replace(/^0*/, '');
    }

    function parseExact(value, format, culture, strict, shouldUnpadZeros) {
        if (!value) {
            return null;
        }

        var lookAhead = function(match) {
                var i = 0;
                while (format[idx] === match) {
                    i++;
                    idx++;
                }
                if (i > 0) {
                    idx -= 1;
                }
                return i;
            },
            longestDesignatorLength = (designators) => Array.from(designators).sort((a, b) => b.length - a.length)[0].length,
            getNumber = function(size) {
                var rg, match, part = "";
                if (size === 2) {
                    for (let i = 0; i <= size; i++) {
                        part += value[valueIdx + i] || "";
                    }
                }

                // If the value comes in the form of 021, 022, 023 we must trim the leading zero otherwise the result will be 02 in all three cases instead of 21/22/23.
                if (shouldUnpadZeros && part.match(numberRegExp.exact3) && Number.isInteger(Number(part)) && Number(part) > 0) {
                    part = unpadZero(part);
                } else {
                    part = value.substr(valueIdx, size);
                }

                rg = numberRegExp[size] || new RegExp('^\\d{1,' + size + '}');
                match = part.match(rg);

                if (match) {
                    match = match[0];
                    valueIdx += match.length;
                    return parseInt(match, 10);
                }
                return null;
            },
            getIndexByName = function(names, lower, subLength) {
                var i = 0,
                    length = names.length,
                    name, nameLength,
                    matchLength = 0,
                    matchIdx = 0,
                    subValue;

                for (; i < length; i++) {
                    name = names[i];
                    nameLength = name.length;
                    subValue = value.substr(valueIdx, subLength || nameLength); // The `subLength` is part of the appendDesignatorsToCultures logic.

                    if (lower) {
                        subValue = subValue.toLowerCase();
                    }

                    if (subValue == name && nameLength > matchLength) {
                        matchLength = nameLength;
                        matchIdx = i;
                    }
                }

                if (matchLength) {
                    valueIdx += matchLength;
                    return matchIdx + 1;
                }

                return null;
            },
            checkLiteral = function() {
                var result = false;
                if (value.charAt(valueIdx) === format[idx]) {
                    valueIdx++;
                    result = true;
                }
                return result;
            },
            calendar = culture.calendars.standard,
            year = null,
            month = null,
            day = null,
            hours = null,
            minutes = null,
            seconds = null,
            milliseconds = null,
            idx = 0,
            valueIdx = 0,
            literal = false,
            date = new Date(),
            twoDigitYearMax = calendar.twoDigitYearMax || 2029,
            defaultYear = date.getFullYear(),
            ch, count, length, pattern,
            pmHour, UTC, matches,
            amDesignators, pmDesignators,
            hoursOffset, minutesOffset,
            hasTime, match;

        if (!format) {
            format = "d"; //shord date format
        }

        //if format is part of the patterns get real format
        pattern = calendar.patterns[format];
        if (pattern) {
            format = pattern;
        }

        format = format.split("");
        length = format.length;

        for (; idx < length; idx++) {
            ch = format[idx];

            if (literal) {
                if (ch === "'") {
                    literal = false;
                } else {
                    checkLiteral();
                }
            } else {
                if (ch === "d") {
                    count = lookAhead("d");
                    if (!calendar._lowerDays) {
                        calendar._lowerDays = lowerLocalInfo(calendar.days);
                    }

                    if (day !== null && count > 2) {
                        continue;
                    }

                    day = count < 3 ? getNumber(2) : getIndexByName(calendar._lowerDays[count == 3 ? "namesAbbr" : "names"], true);

                    if (day === null || outOfRange(day, 1, 31)) {
                        return null;
                    }
                } else if (ch === "M") {
                    count = lookAhead("M");
                    if (!calendar._lowerMonths) {
                        calendar._lowerMonths = lowerLocalInfo(calendar.months);
                    }
                    month = count < 3 ? getNumber(2) : getIndexByName(calendar._lowerMonths[count == 3 ? 'namesAbbr' : 'names'], true);

                    if (month === null || outOfRange(month, 1, 12)) {
                        return null;
                    }
                    month -= 1; //because month is zero based
                } else if (ch === "y") {
                    count = lookAhead("y");
                    year = getNumber(count);

                    if (year === null) {
                        return null;
                    }

                    if (count == 2) {
                        if (typeof twoDigitYearMax === "string") {
                            twoDigitYearMax = defaultYear + parseInt(twoDigitYearMax, 10);
                        }

                        year = (defaultYear - defaultYear % 100) + year;
                        if (year > twoDigitYearMax) {
                            year -= 100;
                        }
                    }
                } else if (ch === "h" ) {
                    lookAhead("h");
                    hours = getNumber(2);
                    if (hours == 12) {
                        hours = 0;
                    }
                    if (hours === null || outOfRange(hours, 0, 11)) {
                        return null;
                    }
                } else if (ch === "H") {
                    lookAhead("H");
                    hours = getNumber(2);
                    if (hours === null || outOfRange(hours, 0, 23)) {
                        return null;
                    }
                } else if (ch === "m") {
                    lookAhead("m");
                    minutes = getNumber(2);
                    if (minutes === null || outOfRange(minutes, 0, 59)) {
                        return null;
                    }
                } else if (ch === "s") {
                    lookAhead("s");
                    seconds = getNumber(2);
                    if (seconds === null || outOfRange(seconds, 0, 59)) {
                        return null;
                    }
                } else if (ch === "f") {
                    count = lookAhead("f");

                    match = value.substr(valueIdx, count).match(numberRegExp[3]);
                    milliseconds = getNumber(count); //move value index position

                    if (milliseconds !== null) {
                        milliseconds = parseFloat("0." + match[0], 10);
                        milliseconds = kendo._round(milliseconds, 3);
                        milliseconds *= 1000;
                    }

                    if (milliseconds === null || outOfRange(milliseconds, 0, 999)) {
                        return null;
                    }

                } else if (ch === "t") {
                    count = lookAhead("t");
                    amDesignators = calendar.AM;
                    pmDesignators = calendar.PM;

                    if (count === 1) {
                        amDesignators = mapDesignators(amDesignators);
                        pmDesignators = mapDesignators(pmDesignators);
                    }

                    pmHour = getIndexByName(pmDesignators, false, longestDesignatorLength(pmDesignators));
                    if (!pmHour && !getIndexByName(amDesignators, false, longestDesignatorLength(amDesignators))) {
                        return null;
                    }
                }
                else if (ch === "z") {
                    UTC = true;
                    count = lookAhead("z");

                    if (value.substr(valueIdx, 1) === "Z") {
                        checkLiteral();
                        continue;
                    }

                    matches = value.substr(valueIdx, 6)
                                   .match(count > 2 ? longTimeZoneRegExp : shortTimeZoneRegExp);

                    if (!matches) {
                        return null;
                    }

                    matches = matches[0].split(":");

                    hoursOffset = matches[0];
                    minutesOffset = matches[1];

                    if (!minutesOffset && hoursOffset.length > 3) { //(+|-)[hh][mm] format is used
                        valueIdx = hoursOffset.length - 2;
                        minutesOffset = hoursOffset.substring(valueIdx);
                        hoursOffset = hoursOffset.substring(0, valueIdx);
                    }

                    hoursOffset = parseInt(hoursOffset, 10);
                    if (outOfRange(hoursOffset, -12, 13)) {
                        return null;
                    }

                    if (count > 2) {
                        minutesOffset = matches[0][0] + minutesOffset;
                        minutesOffset = parseInt(minutesOffset, 10);
                        if (isNaN(minutesOffset) || outOfRange(minutesOffset, -59, 59)) {
                            return null;
                        }
                    }
                } else if (ch === "'") {
                    literal = true;
                    checkLiteral();
                } else if (!checkLiteral()) {
                    return null;
                }
            }
        }

        // if more characters follow, assume wrong format
        // https://github.com/telerik/kendo-ui-core/issues/3476
        if (strict && !/^\s*$/.test(value.substr(valueIdx))) {
            return null;
        }

        hasTime = hours !== null || minutes !== null || seconds || null;

        if (year === null && month === null && day === null && hasTime) {
            year = defaultYear;
            month = date.getMonth();
            day = date.getDate();
        } else {
            if (year === null) {
                year = defaultYear;
            }

            if (day === null) {
                day = 1;
            }
        }

        if (pmHour && hours < 12) {
            hours += 12;
        }

        if (UTC) {
            if (hoursOffset) {
                hours += -hoursOffset;
            }

            if (minutesOffset) {
                minutes += -minutesOffset;
            }

            value = new Date(Date.UTC(year, month, day, hours, minutes, seconds, milliseconds));
        } else {
            value = new Date(year, month, day, hours, minutes, seconds, milliseconds);
            adjustDST(value, hours);
        }

        if (year < 100) {
            value.setFullYear(year);
        }

        if (value.getDate() !== day && UTC === undefined$1) {
            return null;
        }

        return value;
    }

    function parseMicrosoftFormatOffset(offset) {
        var sign = offset.substr(0, 1) === "-" ? -1 : 1;

        offset = offset.substring(1);
        offset = (parseInt(offset.substr(0, 2), 10) * 60) + parseInt(offset.substring(2), 10);

        return sign * offset;
    }

    function getDefaultFormats(culture) {
        var length = math.max(FORMATS_SEQUENCE.length, STANDARD_FORMATS.length);
        var calendar = culture.calendar || culture.calendars.standard;
        var patterns = calendar.patterns;
        var cultureFormats, formatIdx, idx;
        var formats = [];

        for (idx = 0; idx < length; idx++) {
            cultureFormats = FORMATS_SEQUENCE[idx];
            for (formatIdx = 0; formatIdx < cultureFormats.length; formatIdx++) {
                formats.push(patterns[cultureFormats[formatIdx]]);
            }
            formats = formats.concat(STANDARD_FORMATS[idx]);
        }

        return formats;
    }

    function internalParseDate(value, formats, culture, strict, shouldUnpadZeros) {
        if (objectToString.call(value) === "[object Date]") {
            return value;
        }

        var idx = 0;
        var date = null;
        var length;
        var tzoffset;

        if (value && value.indexOf("/D") === 0) {
            date = dateRegExp.exec(value);
            if (date) {
                date = date[1];
                tzoffset = offsetRegExp.exec(date.substring(1));

                date = new Date(parseInt(date, 10));

                if (tzoffset) {
                    tzoffset = parseMicrosoftFormatOffset(tzoffset[0]);
                    date = kendo.timezone.apply(date, 0);
                    date = kendo.timezone.convert(date, 0, -1 * tzoffset);
                }

                return date;
            }
        }

        culture = kendo.getCulture(culture);

        if (!formats) {
            formats = getDefaultFormats(culture);
        }

        formats = isArray(formats) ? formats : [formats];
        length = formats.length;

        for (; idx < length; idx++) {
            date = parseExact(value, formats[idx], culture, strict, shouldUnpadZeros);
            if (date) {
                return date;
            }
        }

        return date;
    }

    kendo.parseDate = function(value, formats, culture, shouldUnpadZeros) {
        return internalParseDate(value, formats, culture, false, shouldUnpadZeros);
    };

    kendo.parseExactDate = function(value, formats, culture) {
        return internalParseDate(value, formats, culture, true);
    };

    kendo.parseInt = function(value, culture) {
        var result = kendo.parseFloat(value, culture);
        if (result) {
            result = result | 0;
        }
        return result;
    };

    kendo.parseFloat = function(value, culture, format) {
        if (!value && value !== 0) {
           return null;
        }

        if (typeof value === NUMBER) {
           return value;
        }

        value = value.toString();
        culture = kendo.getCulture(culture);

        var number = culture.numberFormat,
            percent = number.percent,
            currency = number.currency,
            symbol = currency.symbol,
            percentSymbol = percent.symbol,
            negative = value.indexOf("-"),
            parts, isPercent;

        //handle exponential number
        if (exponentRegExp.test(value)) {
            value = parseFloat(value.replace(number["."], "."));
            if (isNaN(value)) {
                value = null;
            }
            return value;
        }

        if (negative > 0) {
            return null;
        } else {
            negative = negative > -1;
        }

        if (value.indexOf(symbol) > -1 || (format && format.toLowerCase().indexOf("c") > -1)) {
            number = currency;
            parts = number.pattern[0].replace("$", symbol).split("n");
            if (value.indexOf(parts[0]) > -1 && value.indexOf(parts[1]) > -1) {
                value = value.replace(parts[0], "").replace(parts[1], "");
                negative = true;
            }
        } else if (value.indexOf(percentSymbol) > -1) {
            isPercent = true;
            number = percent;
            symbol = percentSymbol;
        }

        value = value.replace("-", "")
                     .replace(symbol, "")
                     .replace(nonBreakingSpaceRegExp, " ")
                     .split(number[","].replace(nonBreakingSpaceRegExp, " ")).join("")
                     .replace(spaceRegExp, "")
                     .replace(number["."], ".");

        value = parseFloat(value);

        if (isNaN(value)) {
            value = null;
        } else if (negative) {
            value *= -1;
        }

        if (value && isPercent) {
            value /= 100;
        }

        return value;
    };
})();

    function getShadows(element) {
        var shadow = element.css(kendo.support.transitions.css + "box-shadow") || element.css("box-shadow"),
            radius = shadow ? shadow.match(boxShadowRegExp) || [ 0, 0, 0, 0, 0 ] : [ 0, 0, 0, 0, 0 ],
            blur = math.max((+radius[3]), +(radius[4] || 0));

        return {
            left: (-radius[1]) + blur,
            right: (+radius[1]) + blur,
            bottom: (+radius[2]) + blur
        };
    }

    function getHiddenDimensions(element, includeMargin) {
        var clone, width, height;

        clone = element.clone();
        clone.css("display", "");
        clone.css("visibility", "hidden");
        clone.appendTo($("body"));

        width = clone.outerWidth(includeMargin || false);
        height = clone.outerHeight(includeMargin || false);

        clone.remove();

        return {
            width: width || 0,
            height: height || 0
        };
    }

    function wrap(element, autosize, resize, shouldCorrectWidth = true, autowidth) {
        var percentage,
            outerWidth = kendo._outerWidth,
            outerHeight = kendo._outerHeight,
            parent = element.parent(),
            windowOuterWidth = outerWidth(window);

        parent.parent().removeClass("k-animation-container-sm");

        if (!parent.hasClass("k-child-animation-container")) {
            var width = element[0].style.width,
                height = element[0].style.height,
                percentWidth = percentRegExp.test(width),
                percentHeight = percentRegExp.test(height),
                forceDimensions = element.hasClass("k-tooltip") || element.is(".k-menu-horizontal.k-context-menu"),
                calculateFromHidden = element.hasClass("k-tooltip");

            percentage = percentWidth || percentHeight;

            if (!percentWidth && (!autosize || (autosize && width) || forceDimensions)) { width = autosize ? outerWidth(element, false, calculateFromHidden) + 1 : outerWidth(element, false, calculateFromHidden); }
            if (!percentHeight && (!autosize || (autosize && height)) || forceDimensions) { height = outerHeight(element, false, calculateFromHidden); }

            element.wrap(
                $("<div/>")
                .addClass("k-child-animation-container")
                .css({
                    width: autowidth ? "auto" : width,
                    height: height
                }));
            parent = element.parent();

            parent.wrap(
                         $("<div/>")
                         .addClass("k-animation-container")
                         .attr("role", "region")
                        );

            if (percentage) {
                element.css({
                    width: "100%",
                    height: "100%"
                });
            }
        } else {
            wrapResize(element, autosize, shouldCorrectWidth);
        }

        parent = parent.parent();

        if (windowOuterWidth < outerWidth(parent)) {
            parent.addClass("k-animation-container-sm");
            resize = true;
        }

        if (resize) {
            wrapResize(element, autosize, shouldCorrectWidth);
        }

        return parent;
    }

    function wrapResize(element, autosize, shouldCorrectWidth) {
        var percentage,
            outerWidth = kendo._outerWidth,
            outerHeight = kendo._outerHeight,
            parent = element.parent(),
            wrapper = element.closest(".k-animation-container"),
            calculateFromHidden = element.hasClass("k-tooltip"),
            visible = element.is(":visible"),
            wrapperStyle = parent[0].style,
            elementHeight = element[0].style.height;

        if (wrapper.is(":hidden")) {
            wrapper.css({
                display: "",
                position: ""
            });
        }

        percentage = percentRegExp.test(wrapperStyle.width) || percentRegExp.test(wrapperStyle.height);

        if (!percentage) {
            if (!visible) {
                element.add(parent).show();
            }
            if (shouldCorrectWidth) {
                parent.css("width", ""); // Needed to get correct width dimensions
            }
            parent.css({
                width: autosize ? outerWidth(element, false, calculateFromHidden) + 1 : outerWidth(element, false, calculateFromHidden),
            });

            if (elementHeight === "auto") {
                element.css({ height: outerHeight(parent) });
            } else {
                parent.css({
                    height: outerHeight(element)
                });
            }

            if (!visible) {
                element.hide();
            }
        }
    }

    function deepExtend(destination) {
        var i = 1,
            length = arguments.length;

        for (i = 1; i < length; i++) {
            deepExtendOne(destination, arguments[i]);
        }

        return destination;
    }

    function deepExtendOne(destination, source) {
        var ObservableArray = kendo.data.ObservableArray,
            LazyObservableArray = kendo.data.LazyObservableArray,
            DataSource = kendo.data.DataSource,
            HierarchicalDataSource = kendo.data.HierarchicalDataSource,
            property,
            propValue,
            propType,
            propInit,
            destProp;

        for (property in source) {
            propValue = source[property];
            propType = typeof propValue;

            if (propType === OBJECT && propValue !== null) {
                propInit = propValue.constructor;
            } else {
                propInit = null;
            }

            if (propInit &&
                propInit !== Array && propInit !== ObservableArray && propInit !== LazyObservableArray &&
                propInit !== DataSource && propInit !== HierarchicalDataSource && propInit !== RegExp &&
                (!kendo.isFunction(window.ArrayBuffer) || propInit !== ArrayBuffer) && !(propValue instanceof HTMLElement)) {

                if (propValue instanceof Date) {
                    destination[property] = new Date(propValue.getTime());
                } else if (isFunction(propValue.clone)) {
                    destination[property] = propValue.clone();
                } else {
                    destProp = destination[property];
                    if (typeof (destProp) === OBJECT) {
                        destination[property] = destProp || {};
                    } else {
                        destination[property] = {};
                    }
                    deepExtendOne(destination[property], propValue);
                }
            } else if (propType !== UNDEFINED) {
                destination[property] = propValue;
            }
        }

        return destination;
    }

    function testRx(agent, rxs, dflt) {
        for (var rx in rxs) {
            if (rxs.hasOwnProperty(rx) && rxs[rx].test(agent)) {
                return rx;
            }
        }
        return dflt !== undefined$1 ? dflt : agent;
    }

    function toHyphens(str) {
        return str.replace(/([a-z][A-Z])/g, function(g) {
            return g.charAt(0) + '-' + g.charAt(1).toLowerCase();
        });
    }

    function toCamelCase(str) {
        return str.replace(/\-(\w)/g, function(strMatch, g1) {
            return g1.toUpperCase();
        });
    }

    function getComputedStyles(element, properties) {
        var styles = {}, computedStyle;

        if (document.defaultView && document.defaultView.getComputedStyle) {
            computedStyle = document.defaultView.getComputedStyle(element, "");

            if (properties) {
                $.each(properties, function(idx, value) {
                    styles[value] = computedStyle.getPropertyValue(value);
                });
            }
        } else {
            computedStyle = element.currentStyle;

            if (properties) {
                $.each(properties, function(idx, value) {
                    styles[value] = computedStyle[toCamelCase(value)];
                });
            }
        }

        if (!kendo.size(styles)) {
            styles = computedStyle;
        }

        return styles;
    }

    function isScrollable(element) {
        if (element.dataset[kendo.ns + "scrollable"] === "false") {
            return false;
        }

        if (element && element.className && typeof(element.className) === "string" && element.className.indexOf("k-auto-scrollable") > -1) {
            return true;
        }

        var overflow = getComputedStyles(element, ["overflow"]).overflow;
        return overflow.indexOf("auto") > -1 || overflow.indexOf("scroll") > -1;
    }

    function scrollLeft(element, value) {
        var webkit = support.browser.webkit;
        var mozila = support.browser.mozilla;
        var browserVersion = support.browser.version;
        var el, isRtl;

        if (element instanceof $ && value !== undefined$1) {
            element.each(function(i, e) {
                scrollLeft(e, value);
            });

            return;
        } else {
            el = element instanceof $ ? element[0] : element;
        }

        if (!el) {
            return;
        }

        isRtl = support.isRtl(element);

        // After updating browser detection,
        // Test in which if should the Safari browsers go
        if (value !== undefined$1) {
            if (isRtl && webkit && (browserVersion < 85 || support.browser.safari)) {
                el.scrollLeft = el.scrollWidth - el.clientWidth - value;
            } else if (isRtl && (mozila || webkit) && value > 0) {
                el.scrollLeft = -value;
            } else {
                el.scrollLeft = value;
            }
        } else {
            if (isRtl && webkit && (browserVersion < 85 || support.browser.safari)) {
                return el.scrollWidth - el.clientWidth - el.scrollLeft;
            } else {
                return Math.abs(el.scrollLeft);
            }
        }
    }

    (function() {
        support._scrollbar = undefined$1;

        support.scrollbar = function(refresh) {
            if (!isNaN(support._scrollbar) && !refresh) {
                return support._scrollbar;
            } else {
                var div = document.createElement("div"),
                    result;

                div.style.cssText = "overflow:scroll;overflow-x:hidden;zoom:1;clear:both;display:block";
                div.innerHTML = "&nbsp;";
                document.body.appendChild(div);

                support._scrollbar = result = div.offsetWidth - div.scrollWidth;

                document.body.removeChild(div);

                return result;
            }
        };

        support.isRtl = function(element) {
            return $(element).closest(".k-rtl").length > 0;
        };

        var table = document.createElement("table");

        // Internet Explorer does not support setting the innerHTML of TBODY and TABLE elements
        try {
            table.innerHTML = "<tr><td></td></tr>";

            support.tbodyInnerHtml = true;
        } catch (e) {
            support.tbodyInnerHtml = false;
        }

        support.touch = "ontouchstart" in window;

        var docStyle = document.documentElement.style;
        var transitions = support.transitions = false,
            transforms = support.transforms = false,
            elementProto = "HTMLElement" in window ? HTMLElement.prototype : [];

        support.hasHW3D = ("WebKitCSSMatrix" in window && "m11" in new window.WebKitCSSMatrix()) || "MozPerspective" in docStyle || "msPerspective" in docStyle;
        support.cssFlexbox = ("flexWrap" in docStyle) || ("WebkitFlexWrap" in docStyle) || ("msFlexWrap" in docStyle);

        each([ "Moz", "webkit", "O", "ms" ], function() {
            var prefix = this.toString(),
                hasTransitions = typeof table.style[prefix + "Transition"] === STRING;

            if (hasTransitions || typeof table.style[prefix + "Transform"] === STRING) {
                var lowPrefix = prefix.toLowerCase();

                transforms = {
                    css: (lowPrefix != "ms") ? "-" + lowPrefix + "-" : "",
                    prefix: prefix,
                    event: (lowPrefix === "o" || lowPrefix === "webkit") ? lowPrefix : ""
                };

                if (hasTransitions) {
                    transitions = transforms;
                    transitions.event = transitions.event ? transitions.event + "TransitionEnd" : "transitionend";
                }

                return false;
            }
        });

        table = null;

        support.transforms = transforms;
        support.transitions = transitions;

        support.devicePixelRatio = window.devicePixelRatio === undefined$1 ? 1 : window.devicePixelRatio;

        try {
            support.screenWidth = window.outerWidth || window.screen ? window.screen.availWidth : window.innerWidth;
            support.screenHeight = window.outerHeight || window.screen ? window.screen.availHeight : window.innerHeight;
        } catch (e) {
            //window.outerWidth throws error when in IE showModalDialog.
            support.screenWidth = window.screen.availWidth;
            support.screenHeight = window.screen.availHeight;
        }

        support.detectOS = function(ua) {
            var os = false, minorVersion, match = [],
                notAndroidPhone = !/mobile safari/i.test(ua),
                agentRxs = {
                    wp: /(Windows Phone(?: OS)?)\s(\d+)\.(\d+(\.\d+)?)/,
                    fire: /(Silk)\/(\d+)\.(\d+(\.\d+)?)/,
                    android: /(Android|Android.*(?:Opera|Firefox).*?\/)\s*(\d+)\.?(\d+(\.\d+)?)?/,
                    iphone: /(iPhone|iPod).*OS\s+(\d+)[\._]([\d\._]+)/,
                    ipad: /(iPad).*OS\s+(\d+)[\._]([\d_]+)/,
                    meego: /(MeeGo).+NokiaBrowser\/(\d+)\.([\d\._]+)/,
                    webos: /(webOS)\/(\d+)\.(\d+(\.\d+)?)/,
                    blackberry: /(BlackBerry|BB10).*?Version\/(\d+)\.(\d+(\.\d+)?)/,
                    playbook: /(PlayBook).*?Tablet\s*OS\s*(\d+)\.(\d+(\.\d+)?)/,
                    windows: /(MSIE)\s+(\d+)\.(\d+(\.\d+)?)/,
                    tizen: /(tizen).*?Version\/(\d+)\.(\d+(\.\d+)?)/i,
                    sailfish: /(sailfish).*rv:(\d+)\.(\d+(\.\d+)?).*firefox/i,
                    ffos: /(Mobile).*rv:(\d+)\.(\d+(\.\d+)?).*Firefox/
                },
                osRxs = {
                    ios: /^i(phone|pad|pod)$/i,
                    android: /^android|fire$/i,
                    blackberry: /^blackberry|playbook/i,
                    windows: /windows/,
                    wp: /wp/,
                    flat: /sailfish|ffos|tizen/i,
                    meego: /meego/
                },
                formFactorRxs = {
                    tablet: /playbook|ipad|fire/i
                },
                browserRxs = {
                    omini: /Opera\sMini/i,
                    omobile: /Opera\sMobi/i,
                    firefox: /Firefox|Fennec/i,
                    mobilesafari: /version\/.*safari/i,
                    ie: /MSIE|Windows\sPhone/i,
                    chrome: /chrome|crios/i,
                    webkit: /webkit/i
                };

            for (var agent in agentRxs) {
                if (agentRxs.hasOwnProperty(agent)) {
                    match = ua.match(agentRxs[agent]);
                    if (match) {
                        if (agent == "windows" && "plugins" in navigator) { return false; } // Break if not Metro/Mobile Windows

                        os = {};
                        os.device = agent;
                        os.tablet = testRx(agent, formFactorRxs, false);
                        os.browser = testRx(ua, browserRxs, "default");
                        os.name = testRx(agent, osRxs);
                        os[os.name] = true;
                        os.majorVersion = match[2];
                        os.minorVersion = (match[3] || "0").replace("_", ".");
                        minorVersion = os.minorVersion.replace(".", "").substr(0, 2);
                        os.flatVersion = os.majorVersion + minorVersion + (new Array(3 - (minorVersion.length < 3 ? minorVersion.length : 2)).join("0"));
                        os.cordova = typeof window.PhoneGap !== UNDEFINED || typeof window.cordova !== UNDEFINED; // Use file protocol to detect appModes.
                        os.appMode = window.navigator.standalone || (/file|local|wmapp/).test(window.location.protocol) || os.cordova; // Use file protocol to detect appModes.

                        if (os.android && (support.devicePixelRatio < 1.5 && os.flatVersion < 400 || notAndroidPhone) && (support.screenWidth > 800 || support.screenHeight > 800)) {
                            os.tablet = agent;
                        }

                        break;
                    }
                }
            }
            return os;
        };

        var mobileOS = support.mobileOS = support.detectOS(navigator.userAgent);

        support.wpDevicePixelRatio = mobileOS.wp ? screen.width / 320 : 0;

        support.hasNativeScrolling = false;

        if (mobileOS.ios || (mobileOS.android && mobileOS.majorVersion > 2) || mobileOS.wp) {
            support.hasNativeScrolling = mobileOS;
        }

        support.delayedClick = function() {

            // only the mobile devices with touch events do this.
            if (support.touch) {
                // All iOS devices so far (by the time I am writing this, iOS 9.0.2 is the latest),
                // delay their click events.
                if (mobileOS.ios) {
                    return true;
                }

                if (mobileOS.android) {

                    if (!support.browser.chrome) { // older webkits and webviews delay the click
                        return true;
                    }

                    // from here on, we deal with Chrome on Android.
                    if (support.browser.version < 32) {
                        return false;
                    }

                    // Chrome 32+ does conditional fast clicks if the view port is not user scalable.
                    return !($("meta[name=viewport]").attr("content") || "").match(/user-scalable=no/i);
                }
            }

            return false;
        };

        support.mouseAndTouchPresent = support.touch && !(support.mobileOS.ios || support.mobileOS.android);

        support.detectBrowser = function(ua) {
            var browser = false,
                match = [],
                chromiumEdgeMatch = [],
                browserRxs = {
                    edge: /(edge)[ \/]([\w.]+)/i,
                    webkit: /(chrome|crios)[ \/]([\w.]+)/i,
                    safari: /(webkit)[ \/]([\w.]+)/i,
                    opera: /(opera)(?:.*version|)[ \/]([\w.]+)/i,
                    msie: /(msie\s|trident.*? rv:)([\w.]+)/i,
                    mozilla: /(mozilla)(?:.*? rv:([\w.]+)|)/i
                };

            for (var agent in browserRxs) {
                if (browserRxs.hasOwnProperty(agent)) {
                    match = ua.match(browserRxs[agent]);
                    if (match) {
                        browser = {};
                        browser[agent] = true;
                        browser[match[1].toLowerCase().split(" ")[0].split("/")[0]] = true;
                        browser.version = parseInt(document.documentMode || match[2], 10);

                        if (browser.chrome) {
                            chromiumEdgeMatch = ua.match(/(edg)[ \/]([\w.]+)/i);

                            if (chromiumEdgeMatch) {
                                browser.chromiumEdge = true;
                            }
                        }

                        break;
                    }
                }
            }

            return browser;
        };

        support.browser = support.detectBrowser(navigator.userAgent);

        if (!mobileOS && support.touch && support.browser.safari) {
            mobileOS = support.mobileOS = {
                ios: true,
                tablet: "tablet",
                device: "ipad",
                majorVersion: 13
            };
        }

        support.detectClipboardAccess = function() {
            var commands = {
                copy: document.queryCommandSupported ? document.queryCommandSupported("copy") : false,
                cut: document.queryCommandSupported ? document.queryCommandSupported("cut") : false,
                paste: document.queryCommandSupported ? document.queryCommandSupported("paste") : false
            };

            if (support.browser.chrome) {
                //not using queryCommandSupported due to chromium issues 476508 and 542948
                commands.paste = false;
                if (support.browser.version >= 43) {
                    commands.copy = true;
                    commands.cut = true;
                }
            }

            return commands;
        };

        support.clipboard = support.detectClipboardAccess();

        support.zoomLevel = function() {
            try {
                var browser = support.browser;
                var ie11WidthCorrection = 0;
                var docEl = document.documentElement;

                if (browser.msie && browser.version == 11 && docEl.scrollHeight > docEl.clientHeight && !support.touch) {
                    ie11WidthCorrection = support.scrollbar();
                }

                return support.touch ? (docEl.clientWidth / window.innerWidth) :
                       browser.msie && browser.version >= 10 ? (((top || window).document.documentElement.offsetWidth + ie11WidthCorrection) / (top || window).innerWidth) : 1;
            } catch (e) {
                return 1;
            }
        };

        (function(browser) {
            // add browser-specific CSS class
            var cssClass = "",
                docElement = $(document.documentElement),
                majorVersion = parseInt(browser.version, 10);

            if (browser.msie) {
                cssClass = "ie";
            } else if (browser.mozilla) {
                cssClass = "ff";
            } else if (browser.safari) {
                cssClass = "safari";
            } else if (browser.webkit) {
                cssClass = "webkit";
            } else if (browser.opera) {
                cssClass = "opera";
            } else if (browser.edge) {
                cssClass = "edge";
            }

            if (cssClass) {
                cssClass = "k-" + cssClass + " k-" + cssClass + majorVersion;
            }
            if (support.mobileOS) {
                cssClass += " k-mobile";
            }

            if (!support.cssFlexbox) {
                cssClass += " k-no-flexbox";
            }

            docElement.addClass(cssClass);
        })(support.browser);

        support.eventCapture = document.documentElement.addEventListener;

        var input = document.createElement("input");

        support.placeholder = "placeholder" in input;
        support.propertyChangeEvent = "onpropertychange" in input;

        support.input = (function() {
            var types = ["number", "date", "time", "month", "week", "datetime", "datetime-local"];
            var length = types.length;
            var value = "test";
            var result = {};
            var idx = 0;
            var type;

            for (;idx < length; idx++) {
                type = types[idx];
                input.setAttribute("type", type);
                input.value = value;

                result[type.replace("-", "")] = input.type !== "text" && input.value !== value;
            }

            return result;
        })();

        input.style.cssText = "float:left;";

        support.cssFloat = !!input.style.cssFloat;

        input = null;

        support.stableSort = (function() {
            // Chrome sort is not stable for more than *10* items
            // IE9+ sort is not stable for than *512* items
            var threshold = 513;

            var sorted = [{
                index: 0,
                field: "b"
            }];

            for (var i = 1; i < threshold; i++) {
                sorted.push({
                    index: i,
                    field: "a"
                });
            }

            sorted.sort(function(a, b) {
                return a.field > b.field ? 1 : (a.field < b.field ? -1 : 0);
            });

            return sorted[0].index === 1;
        })();

        support.matchesSelector = elementProto.webkitMatchesSelector || elementProto.mozMatchesSelector ||
                                  elementProto.msMatchesSelector || elementProto.oMatchesSelector ||
                                  elementProto.matchesSelector || elementProto.matches ||
          function( selector ) {
              var nodeList = document.querySelectorAll ? ( this.parentNode || document ).querySelectorAll( selector ) || [] : $(selector),
                  i = nodeList.length;

              while (i--) {
                  if (nodeList[i] == this) {
                      return true;
                  }
              }

              return false;
          };

        support.matchMedia = "matchMedia" in window;

        support.pushState = window.history && window.history.pushState;

        support.hashChange = "onhashchange" in window;

        support.customElements = "registerElement" in window.document;

        var chrome = support.browser.chrome,
            mobileChrome = support.browser.crios,
            mozilla = support.browser.mozilla,
            safari = support.browser.safari;
        support.msPointers = !chrome && window.MSPointerEvent;
        support.pointers = !chrome && !mobileChrome && !mozilla && !safari && window.PointerEvent;
        support.kineticScrollNeeded = mobileOS && (mobileOS.device !== "ipad" || mobileOS.majorVersion < 13) && (support.touch || support.msPointers || support.pointers);
    })();


    function size(obj) {
        var result = 0, key;
        for (key in obj) {
            if (obj.hasOwnProperty(key) && key != "toJSON") { // Ignore fake IE7 toJSON.
                result++;
            }
        }

        return result;
    }

    function getOffset(element, type, positioned) {
        if (!type) {
            type = "offset";
        }

        var offset = element[type]();
        // clone ClientRect object to JS object (jQuery3)
        var result = {
            top: offset.top,
            right: offset.right,
            bottom: offset.bottom,
            left: offset.left
        };

        // IE10 touch zoom is living in a separate viewport
        if (support.browser.msie && (support.pointers || support.msPointers) && !positioned) {
            var sign = support.isRtl(element) ? 1 : -1;

            result.top -= (window.pageYOffset - (document.documentElement.scrollTop));
            result.left -= (window.pageXOffset + (sign * document.documentElement.scrollLeft));
        }

        return result;
    }

    var directions = {
        left: { reverse: "right" },
        right: { reverse: "left" },
        down: { reverse: "up" },
        up: { reverse: "down" },
        top: { reverse: "bottom" },
        bottom: { reverse: "top" },
        "in": { reverse: "out" },
        out: { reverse: "in" }
    };

    function parseEffects(input) {
        var effects = {};

        each((typeof input === "string" ? input.split(" ") : input), function(idx) {
            effects[idx] = this;
        });

        return effects;
    }

    function fx(element) {
        return new kendo.effects.Element(element);
    }

    var effects = {};

    $.extend(effects, {
        enabled: true,
        Element: function(element) {
            this.element = $(element);
        },

        promise: function(element, options) {
            if (!element.is(":visible")) {
                element.css({ display: element.data("olddisplay") || "block" }).css("display");
            }

            if (options.hide) {
                element.data("olddisplay", element.css("display")).hide();
            }

            if (options.init) {
                options.init();
            }

            if (options.completeCallback) {
                options.completeCallback(element); // call the external complete callback with the element
            }

            element.dequeue();
        },

        disable: function() {
            this.enabled = false;
            this.promise = this.promiseShim;
        },

        enable: function() {
            this.enabled = true;
            this.promise = this.animatedPromise;
        }
    });

    effects.promiseShim = effects.promise;

    function prepareAnimationOptions(options, duration, reverse, complete) {
        if (typeof options === STRING) {
            // options is the list of effect names separated by space e.g. animate(element, "fadeIn slideDown")

            // only callback is provided e.g. animate(element, options, function() {});
            if (isFunction(duration)) {
                complete = duration;
                duration = 400;
                reverse = false;
            }

            if (isFunction(reverse)) {
                complete = reverse;
                reverse = false;
            }

            if (typeof duration === BOOLEAN) {
                reverse = duration;
                duration = 400;
            }

            options = {
                effects: options,
                duration: duration,
                reverse: reverse,
                complete: complete
            };
        }

        return extend({
            //default options
            effects: {},
            duration: 400, //jQuery default duration
            reverse: false,
            init: noop,
            teardown: noop,
            hide: false
        }, options, { completeCallback: options.complete, complete: noop }); // Move external complete callback, so deferred.resolve can be always executed.

    }

    function animate(element, options, duration, reverse, complete) {
        var idx = 0,
            length = element.length,
            instance;

        for (; idx < length; idx ++) {
            instance = $(element[idx]);
            instance.queue(function() {
                effects.promise(instance, prepareAnimationOptions(options, duration, reverse, complete));
            });
        }

        return element;
    }

    function toggleClass(element, classes, options, add) {
        if (classes) {
            classes = classes.split(" ");

            each(classes, function(idx, value) {
                element.toggleClass(value, add);
            });
        }

        return element;
    }

    if (!("kendoAnimate" in $.fn)) {
        extend($.fn, {
            kendoStop: function(clearQueue, gotoEnd) {
                return this.stop(clearQueue, gotoEnd);
            },

            kendoAnimate: function(options, duration, reverse, complete) {
                return animate(this, options, duration, reverse, complete);
            },

            kendoAddClass: function(classes, options) {
                return kendo.toggleClass(this, classes, options, true);
            },

            kendoRemoveClass: function(classes, options) {
                return kendo.toggleClass(this, classes, options, false);
            },
            kendoToggleClass: function(classes, options, toggle) {
                return kendo.toggleClass(this, classes, options, toggle);
            }
        });
    }

    var ampRegExp = /&/g,
        ltRegExp = /</g,
        quoteRegExp = /"/g,
        aposRegExp = /'/g,
        gtRegExp = />/g;
    function htmlEncode(value) {
        return ("" + value).replace(ampRegExp, "&amp;").replace(ltRegExp, "&lt;").replace(gtRegExp, "&gt;").replace(quoteRegExp, "&quot;").replace(aposRegExp, "&#39;");
    }

    function unescape(value) {
        var template;

        try {
            template = window.decodeURIComponent(value);
        } catch (error) {
            // If the string contains Unicode characters
            // the decodeURIComponent() will throw an error.
            // Therefore: convert to UTF-8 character
            template = value.replace(/%u([\dA-F]{4})|%([\dA-F]{2})/gi, function(_, m1, m2) {
                return String.fromCharCode(parseInt("0x" + (m1 || m2), 16));
            });
        }

        return template;
    }

    var eventTarget = function(e) {
        return e.target;
    };

    if (support.touch) {

        eventTarget = function(e) {
            var touches = "originalEvent" in e ? e.originalEvent.changedTouches : "changedTouches" in e ? e.changedTouches : null;

            return touches ? document.elementFromPoint(touches[0].clientX, touches[0].clientY) : e.target;
        };

        each(["swipe", "swipeLeft", "swipeRight", "swipeUp", "swipeDown", "doubleTap", "tap"], function(m, value) {
            $.fn[value] = function(callback) {
                return this.on(value, callback);
            };
        });
    }

    if (support.touch) {
        if (!support.mobileOS) {
            support.mousedown = "mousedown touchstart";
            support.mouseup = "mouseup touchend";
            support.mousemove = "mousemove touchmove";
            support.mousecancel = "mouseleave touchcancel";
            support.click = "click";
            support.resize = "resize";
        } else {
            support.mousedown = "touchstart";
            support.mouseup = "touchend";
            support.mousemove = "touchmove";
            support.mousecancel = "touchcancel";
            support.click = "touchend";
            support.resize = "orientationchange";
        }
    } else if (support.pointers) {
        support.mousemove = "pointermove";
        support.mousedown = "pointerdown";
        support.mouseup = "pointerup";
        support.mousecancel = "pointercancel";
        support.click = "pointerup";
        support.resize = "orientationchange resize";
    } else if (support.msPointers) {
        support.mousemove = "MSPointerMove";
        support.mousedown = "MSPointerDown";
        support.mouseup = "MSPointerUp";
        support.mousecancel = "MSPointerCancel";
        support.click = "MSPointerUp";
        support.resize = "orientationchange resize";
    } else {
        support.mousemove = "mousemove";
        support.mousedown = "mousedown";
        support.mouseup = "mouseup";
        support.mousecancel = "mouseleave";
        support.click = "click";
        support.resize = "resize";
    }

    var wrapExpression = function(members, paramName) {
        var result = paramName || "d",
            index,
            idx,
            length,
            member,
            count = 1;

        for (idx = 0, length = members.length; idx < length; idx++) {
            member = members[idx];
            if (member !== "") {
                index = member.indexOf("[");

                if (index !== 0) {
                    if (index == -1) {
                        member = "." + member;
                    } else {
                        count++;
                        member = "." + member.substring(0, index) + " || {})" + member.substring(index);
                    }
                }

                count++;
                result += member + ((idx < length - 1) ? " || {})" : ")");
            }
        }
        return new Array(count).join("(") + result;
    },
    localUrlRe = /^([a-z]+:)?\/\//i;

    extend(kendo, {
        widgets: [],
        _widgetRegisteredCallbacks: [],
        ui: kendo.ui || {},
        fx: kendo.fx || fx,
        effects: kendo.effects || effects,
        mobile: kendo.mobile || { },
        data: kendo.data || {},
        dataviz: kendo.dataviz || {},
        drawing: kendo.drawing || {},
        spreadsheet: { messages: {} },
        keys: {
            INSERT: 45,
            DELETE: 46,
            BACKSPACE: 8,
            TAB: 9,
            ENTER: 13,
            ESC: 27,
            LEFT: 37,
            UP: 38,
            RIGHT: 39,
            DOWN: 40,
            END: 35,
            HOME: 36,
            SPACEBAR: 32,
            PAGEUP: 33,
            PAGEDOWN: 34,
            F2: 113,
            F10: 121,
            F12: 123,
            NUMPAD_PLUS: 107,
            NUMPAD_MINUS: 109,
            NUMPAD_DOT: 110
        },
        support: kendo.support || support,
        animate: kendo.animate || animate,
        ns: "",
        attr: function(value) {
            return "data-" + kendo.ns + value;
        },
        getShadows: getShadows,
        wrap: wrap,
        deepExtend: deepExtend,
        getComputedStyles: getComputedStyles,
        isScrollable: isScrollable,
        scrollLeft: scrollLeft,
        size: size,
        toCamelCase: toCamelCase,
        toHyphens: toHyphens,
        getOffset: kendo.getOffset || getOffset,
        parseEffects: kendo.parseEffects || parseEffects,
        toggleClass: kendo.toggleClass || toggleClass,
        directions: kendo.directions || directions,
        Observable: Observable,
        Class: Class,
        Template: Template,
        template: Template.compile.bind(Template),
        render: Template.render.bind(Template),
        stringify: JSON.stringify.bind(JSON),
        eventTarget: eventTarget,
        htmlEncode: htmlEncode,
        unescape: unescape,
        isLocalUrl: function(url) {
            return url && !localUrlRe.test(url);
        },
        mediaQuery: mediaQuery,

        expr: function(expression, safe, paramName) {
            expression = expression || "";

            if (typeof safe == STRING) {
                paramName = safe;
                safe = false;
            }

            paramName = paramName || "d";

            if (expression && expression.charAt(0) !== "[") {
                expression = "." + expression;
            }

            if (safe) {
                expression = expression.replace(/"([^.]*)\.([^"]*)"/g,'"$1_$DOT$_$2"');
                expression = expression.replace(/'([^.]*)\.([^']*)'/g,"'$1_$DOT$_$2'");
                expression = wrapExpression(expression.split("."), paramName);
                expression = expression.replace(/_\$DOT\$_/g, ".");
            } else {
                expression = paramName + expression;
            }

            return expression;
        },

        exprToArray: (expression, safe) => {
            expression = expression || "";

            return expression.indexOf(".") >= 0 || expression.indexOf("[") >= 0 ?
                expression.split(/[[\].]/).map(v => v.replace(/["']/g, '')).filter(v => v) :
                expression === "" ? [] : [expression];
        },

        getter: function(expression, safe) {
            var key = expression + safe;

            return getterCache[key] = getterCache[key] || ((obj) => {
                const fields = kendo.exprToArray(expression, safe);

                let result = obj;
                for (let idx = 0; idx < fields.length; idx++) {
                    result = result[fields[idx]];
                    if (!kendo.isPresent(result) && safe) {
                        return result;
                    }
                }

                return result;
            });
        },

        setter: function(expression) {
            return setterCache[expression] = setterCache[expression] || ((obj, value) => {
                const fields = kendo.exprToArray(expression);

                const innerSetter = ({ parent, val, prop, props }) => {
                    if (props.length) {
                        parent = parent[props.shift()];
                        innerSetter({ parent, val, prop, props });
                    } else {
                        parent[prop] = val;
                    }
                };

                innerSetter({
                    parent: obj,
                    val: value,
                    prop: fields.pop(),
                    props: fields
                });
            });
        },

        accessor: function(expression) {
            return {
                get: kendo.getter(expression),
                set: kendo.setter(expression)
            };
        },

        guid: function() {
            var id = "", i, random, chars = "abcdef";

            id += chars[Math.floor(Math.random() * Math.floor(chars.length))];

            for (i = 1; i < 32; i++) {
                random = math.random() * 16 | 0;

                if (i == 8 || i == 12 || i == 16 || i == 20) {
                    id += "-";
                }
                id += (i == 12 ? 4 : (i == 16 ? (random & 3 | 8) : random)).toString(16);
            }

            return id;
        },

        roleSelector: function(role) {
            return role.replace(/(\S+)/g, "[" + kendo.attr("role") + "=$1],").slice(0, -1);
        },

        directiveSelector: function(directives) {
            var selectors = directives.split(" ");

            if (selectors) {
                for (var i = 0; i < selectors.length; i++) {
                    if (selectors[i] != "view") {
                        selectors[i] = selectors[i].replace(/(\w*)(view|bar|strip|over)$/, "$1-$2");
                    }
                }
            }

            return selectors.join(" ").replace(/(\S+)/g, "kendo-mobile-$1,").slice(0, -1);
        },

        triggeredByInput: function(e) {
            return (/^(label|input|textarea|select)$/i).test(e.target.tagName);
        },

        onWidgetRegistered: function(callback) {
            for (var i = 0, len = kendo.widgets.length; i < len; i++) {
                callback(kendo.widgets[i]);
            }

            kendo._widgetRegisteredCallbacks.push(callback);
        },

        logToConsole: function(message, type) {
            var console = window.console;

            if (!kendo.suppressLog && typeof(console) != "undefined" && console.log) {
                console[type || "log"](message);
            }
        }
    });

    var Widget = Observable.extend( {
        init: function(element, options) {
            var that = this;

            if (!validatePackage()) {
                that._showWatermarkOverlay = addWatermarkOverlay;
            }

            that.element = kendo.jQuery(element).handler(that);

            Observable.fn.init.call(that);

            var dataSource = options ? options.dataSource : null;
            var props;

            if (options) {
                props = (that.componentTypes || {})[(options || {}).componentType];
            }

            if (dataSource) {
                // avoid deep cloning the data source
                options = extend({}, options, { dataSource: {} });
            }

            options = that.options = extend(true, {}, that.options, that.defaults, props || {}, options);

            if (dataSource) {
                options.dataSource = dataSource;
            }

            if (!that.element.attr(kendo.attr("role"))) {
                that.element.attr(kendo.attr("role"), (options.name || "").toLowerCase());
            }

            that.element.data("kendo" + options.prefix + options.name, that);

            that.bind(that.events, options);
        },

        events: [],

        options: {
            prefix: ""
        },

        _hasBindingTarget: function() {
            return !!this.element[0].kendoBindingTarget;
        },

        _tabindex: function(target) {
            target = target || this.wrapper;

            var element = this.element,
                TABINDEX = "tabindex",
                tabindex = target.attr(TABINDEX) || element.attr(TABINDEX);

            element.removeAttr(TABINDEX);

            target.attr(TABINDEX, !isNaN(tabindex) ? tabindex : 0);
        },

        setOptions: function(options) {
            this._clearCssClasses(options);
            this._setEvents(options);
            $.extend(this.options, options);
            this._applyCssClasses();
        },

        _setEvents: function(options) {
            var that = this,
                idx = 0,
                length = that.events.length,
                e;

            for (; idx < length; idx ++) {
                e = that.events[idx];
                if (that.options[e] && options[e]) {
                    that.unbind(e, that.options[e]);
                    if (that._events && that._events[e]) {
                        delete that._events[e];
                    }
                }
            }

            that.bind(that.events, options);
        },

        resize: function(force) {
            var size = this.getSize(),
                currentSize = this._size;

            if (force || (size.width > 0 || size.height > 0) && (!currentSize || size.width !== currentSize.width || size.height !== currentSize.height)) {
                this._size = size;
                this._resize(size, force);
                this.trigger("resize", size);
            }
        },

        getSize: function() {
            return kendo.dimensions(this.element);
        },

        size: function(size) {
            if (!size) {
                return this.getSize();
            } else {
                this.setSize(size);
            }
        },

        setSize: $.noop,
        _resize: $.noop,

        destroy: function() {
            var that = this;

            that.element.removeData("kendo" + that.options.prefix + that.options.name);
            that.element.removeData("handler");
            that.unbind();
        },
        _destroy: function() {
            this.destroy();
        },

        _applyCssClasses: function(element) {
            var protoOptions = this.__proto__.options,
                options = this.options,
                el = element || this.wrapper || this.element,
                classes = [],
                i, prop, validFill, widgetName;

            if (!kendo.cssProperties.propertyDictionary[protoOptions.name]) {
                return;
            }

            for (i = 0; i < cssPropertiesNames.length; i++) {
                prop = cssPropertiesNames[i];
                widgetName = this.options._altname || protoOptions.name;

                if (protoOptions.hasOwnProperty(prop)) {
                    if (prop === "themeColor") {
                        validFill = kendo.cssProperties.getValidClass({
                            widget: widgetName,
                            propName: "fillMode",
                            value: options.fillMode
                        });

                        if (validFill && validFill.length) {
                            classes.push(kendo.cssProperties.getValidClass({
                                widget: widgetName,
                                propName: prop,
                                value: options[prop],
                                fill: options.fillMode
                            }));
                        }
                    } else {
                        classes.push(kendo.cssProperties.getValidClass({
                            widget: widgetName,
                            propName: prop,
                            value: options[prop]
                        }));
                    }
                }
            }

            el.addClass(classes.join(" "));
        },

        _ariaLabel: function(target) {
            var that = this,
                inputElm = that.element,
                inputId = inputElm.attr("id"),
                labelElm = $("label[for=\"" + inputId + "\"]"),
                ariaLabel = inputElm.attr(ARIA_LABEL),
                ariaLabelledBy = inputElm.attr(ARIA_LABELLEDBY),
                labelId;

            if (target[0] === inputElm[0]) {
                return;
            }

            if (ariaLabel) {
                target.attr(ARIA_LABEL, ariaLabel);
            } else if (ariaLabelledBy) {
                target.attr(ARIA_LABELLEDBY, ariaLabelledBy);
            } else if (labelElm.length) {
                labelId = labelElm.attr("id") || that._generateLabelId(labelElm, inputId || kendo.guid());
                target.attr(ARIA_LABELLEDBY, labelId);
            }
        },

        _clearCssClasses: function(newOptions, element) {
            var protoOptions = this.__proto__.options,
                currentOptions = this.options,
                el = element || this.wrapper || this.element,
                i, prop, widgetName;

            if (!kendo.cssProperties.propertyDictionary[protoOptions.name]) {
                return;
            }

            for (i = 0; i < cssPropertiesNames.length; i++) {
                prop = cssPropertiesNames[i];
                widgetName = this.options._altname || protoOptions.name;

                if (protoOptions.hasOwnProperty(prop) && newOptions.hasOwnProperty(prop)) {
                    if (prop === "themeColor") {
                        el.removeClass(kendo.cssProperties.getValidClass({
                            widget: widgetName,
                            propName: prop,
                            value: currentOptions[prop],
                            fill: currentOptions.fillMode
                        }));
                    } else {
                        if (prop === "fillMode") {
                            el.removeClass(kendo.cssProperties.getValidClass({
                                widget: widgetName,
                                propName: "themeColor",
                                value: currentOptions.themeColor,
                                fill: currentOptions.fillMode
                            }));
                        }

                        el.removeClass(kendo.cssProperties.getValidClass({
                            widget: widgetName,
                            propName: prop,
                            value: currentOptions[prop]
                        }));
                    }
                }
            }
        },

        _generateLabelId: function(label, inputId) {
            var labelId = inputId + LABELIDPART;

            label.attr("id", labelId);

            return labelId;
        },
    });

    var DataBoundWidget = Widget.extend({
        dataItems: function() {
            return this.dataSource.flatView();
        }
    });

    kendo.dimensions = function(element, dimensions) {
        var domElement = element[0];

        if (dimensions) {
            element.css(dimensions);
        }

        return { width: domElement.offsetWidth, height: domElement.offsetHeight };
    };

    kendo.notify = noop;

    var templateRegExp = /template$/i,
        jsonRegExp = /^\s*(?:\{(?:.|\r\n|\n)*\}|\[(?:.|\r\n|\n)*\])\s*$/,
        jsonFormatRegExp = /^\{(\d+)(:[^\}]+)?\}|^\[[A-Za-z_]+\]$/,
        dashRegExp = /([A-Z])/g;

    function parseOption(element, option) {
        var value;

        if (option.indexOf("data") === 0) {
            option = option.substring(4);
            option = option.charAt(0).toLowerCase() + option.substring(1);
        }

        option = option.replace(dashRegExp, "-$1");
        value = element.getAttribute("data-" + kendo.ns + option);

        if (value === null) {
            value = undefined$1;
        } else if (value === "null") {
            value = null;
        } else if (value === "true") {
            value = true;
        } else if (value === "false") {
            value = false;
        } else if (numberRegExp.test(value) && option != "mask" && option != "format") {
            value = parseFloat(value);
        } else if (jsonRegExp.test(value) && !jsonFormatRegExp.test(value)) {
            try {
                value = JSON.parse(value);
            } catch (error) {
                // Fallback to function eval for legacy reason - non CSP compliant
                value = new Function("return (" + value + ")")();
            }
        }

        return value;
    }

    function parseOptions(element, options, source) {
        var result = {},
            option,
            value,
            role = element.getAttribute("data-" + kendo.ns + "role");

        for (option in options) {
            value = parseOption(element, option);

            if (value !== undefined$1) {

                if (templateRegExp.test(option) && role != "drawer") {
                    if (typeof value === "string") {
                        if ($("#" + value).length) {
                            value = kendo.template($("#" + value).html());
                        } else if (source) {
                            value = kendo.template(source[value]);
                        }
                    } else {
                        value = element.getAttribute(option);
                    }
                }

                result[option] = value;
            }
        }

        return result;
    }

    kendo.initWidget = function(element, options, roles) {
        var result,
            option,
            widget,
            idx,
            length,
            role,
            value,
            dataSource,
            fullPath,
            widgetKeyRegExp;

        // Preserve backwards compatibility with (element, options, namespace) signature, where namespace was kendo.ui
        if (!roles) {
            roles = kendo.ui.roles;
        } else if (roles.roles) {
            roles = roles.roles;
        }

        element = element.nodeType ? element : element[0];

        role = element.getAttribute("data-" + kendo.ns + "role");

        if (!role) {
            return;
        }

        fullPath = role.indexOf(".") === -1;

        // look for any widget that may be already instantiated based on this role.
        // The prefix used is unknown, hence the regexp
        //

        if (fullPath) {
            widget = roles[role];
        } else { // full namespace path - like kendo.ui.Widget
            widget = kendo.getter(role)(window);
        }

        var data = $(element).data(),
            widgetKey = widget ? "kendo" + widget.fn.options.prefix + widget.fn.options.name : "";

        if (fullPath) {
            widgetKeyRegExp = new RegExp("^kendo.*" + role + "$", "i");
        } else { // full namespace path - like kendo.ui.Widget
            widgetKeyRegExp = new RegExp("^" + widgetKey + "$", "i");
        }

        for (var key in data) {
            if (key.match(widgetKeyRegExp)) {
                // we have detected a widget of the same kind - save its reference, we will set its options
                if (key === widgetKey) {
                    result = data[key];
                } else {
                    return data[key];
                }
            }
        }

        if (!widget) {
            return;
        }

        dataSource = parseOption(element, "dataSource");

        options = $.extend({}, parseOptions(element, $.extend({}, widget.fn.options, widget.fn.defaults) ), options);

        if (dataSource) {
            if (typeof dataSource === STRING) {
                options.dataSource = kendo.getter(dataSource)(window);
            } else {
                options.dataSource = dataSource;
            }
        }

        for (idx = 0, length = widget.fn.events.length; idx < length; idx++) {
            option = widget.fn.events[idx];

            value = parseOption(element, option);

            if (value !== undefined$1) {
                options[option] = kendo.getter(value)(window);
            }
        }

        if (!result) {
            result = new widget(element, options);
        } else if (!$.isEmptyObject(options)) {
            result.setOptions(options);
        }

        return result;
    };

    kendo.rolesFromNamespaces = function(namespaces) {
        var roles = [],
            idx,
            length;

        if (!namespaces[0]) {
            namespaces = [kendo.ui, kendo.dataviz.ui];
        }

        for (idx = 0, length = namespaces.length; idx < length; idx ++) {
            roles[idx] = namespaces[idx].roles;
        }

        return extend.apply(null, [{}].concat(roles.reverse()));
    };

    kendo.init = function(element) {
        var roles = kendo.rolesFromNamespaces(slice.call(arguments, 1));

        $(element).find("[data-" + kendo.ns + "role]").addBack().each(function() {
            kendo.initWidget(this, {}, roles);
        });
    };

    kendo.destroy = function(element) {
        $(element).find("[data-" + kendo.ns + "role]").addBack().each(function() {
            var data = $(this).data();

            for (var key in data) {
                if (key.indexOf("kendo") === 0 && typeof data[key].destroy === FUNCTION) {
                    data[key].destroy();
                }
            }
        });
    };

    function containmentComparer(a, b) {
        return $.contains(a, b) ? -1 : 1;
    }

    function resizableWidget() {
        var widget = $(this);
        return ($.inArray(widget.attr("data-" + kendo.ns + "role"), ["slider", "rangeslider", "breadcrumb"]) > -1) || widget.is(":visible");
    }

    kendo.resize = function(element, force) {
        var widgets = $(element).find("[data-" + kendo.ns + "role]").addBack().filter(resizableWidget);

        if (!widgets.length) {
            return;
        }

        // sort widgets based on their parent-child relation
        var widgetsArray = $.makeArray(widgets);
        widgetsArray.sort(containmentComparer);

        // resize widgets
        $.each(widgetsArray, function() {
            var widget = kendo.widgetInstance($(this));
            if (widget) {
                widget.resize(force);
            }
        });
    };

    kendo.parseOptions = parseOptions;

    extend(kendo.ui, {
        Widget: Widget,
        DataBoundWidget: DataBoundWidget,
        roles: {},
        progress: function(container, toggle, options) {
            var mask = container.find(".k-loading-mask"),
                support = kendo.support,
                browser = support.browser,
                isRtl, leftRight, webkitCorrection, containerScrollLeft, cssClass;

                options = $.extend({}, {
                    width: "100%",
                    height: "100%",
                    top: container.scrollTop(),
                    opacity: false
                }, options);

                cssClass = options.opacity ? 'k-loading-mask k-opaque' : 'k-loading-mask';

            if (toggle) {
                if (!mask.length) {
                    isRtl = support.isRtl(container);
                    leftRight = isRtl ? "right" : "left";
                    containerScrollLeft = kendo.scrollLeft(container);
                    webkitCorrection = browser.webkit ? (!isRtl ? 0 : container[0].scrollWidth - container.width() - 2 * containerScrollLeft) : 0;

                    mask = $(kendo.format("<div class='{0}'><span role='alert' aria-live='polite' class='k-loading-text'>{1}</span><div class='k-loading-image'></div><div class='k-loading-color'></div></div>", cssClass, kendo.ui.progress.messages.loading))
                        .width(options.width).height(options.height)
                        .css("top", options.top)
                        .css(leftRight, Math.abs(containerScrollLeft) + webkitCorrection)
                        .prependTo(container);
                }
            } else if (mask) {
                mask.remove();
            }
        },
        plugin: function(widget, register, prefix) {
            var name = widget.fn.options.name,
                getter;

            register = register || kendo.ui;
            prefix = prefix || "";

            register[name] = widget;

            register.roles[name.toLowerCase()] = widget;

            getter = "getKendo" + prefix + name;
            name = "kendo" + prefix + name;

            var widgetEntry = { name: name, widget: widget, prefix: prefix || "" };
            kendo.widgets.push(widgetEntry);

            for (var i = 0, len = kendo._widgetRegisteredCallbacks.length; i < len; i++) {
                kendo._widgetRegisteredCallbacks[i](widgetEntry);
            }

            $.fn[name] = function(options) {
                var value = this,
                    args;

                if (typeof options === STRING) {
                    args = slice.call(arguments, 1);

                    this.each(function() {
                        var widget = $.data(this, name),
                            method,
                            result;

                        if (!widget) {
                            throw new Error(kendo.format("Cannot call method '{0}' of {1} before it is initialized", options, name));
                        }

                        method = widget[options];

                        if (typeof method !== FUNCTION) {
                            throw new Error(kendo.format("Cannot find method '{0}' of {1}", options, name));
                        }

                        result = method.apply(widget, args);

                        if (result !== undefined$1) {
                            value = result;
                            return false;
                        }
                    });
                } else {
                    this.each(function() {
                        return new widget(this, options);
                    });
                }

                return value;
            };

            $.fn[name].widget = widget;

            $.fn[getter] = function() {
                return this.data(name);
            };
        }
    });

    kendo.ui.progress.messages = {
        loading: "Loading..."
    };

    var ContainerNullObject = { bind: function() { return this; }, nullObject: true, options: {} };

    var MobileWidget = Widget.extend({
        init: function(element, options) {
            Widget.fn.init.call(this, element, options);
            this.element.autoApplyNS();
            this.wrapper = this.element;
            this.element.addClass("km-widget");
        },

        destroy: function() {
            Widget.fn.destroy.call(this);
            this.element.kendoDestroy();
        },

        options: {
            prefix: "Mobile"
        },

        events: [],

        view: function() {
            var viewElement = this.element.closest(kendo.roleSelector("view splitview modalview drawer"));
            return kendo.widgetInstance(viewElement, kendo.mobile.ui) || ContainerNullObject;
        },

        viewHasNativeScrolling: function() {
            var view = this.view();
            return view && view.options.useNativeScrolling;
        },

        container: function() {
            var element = this.element.closest(kendo.roleSelector("view layout modalview drawer splitview"));
            return kendo.widgetInstance(element.eq(0), kendo.mobile.ui) || ContainerNullObject;
        }
    });

    extend(kendo.mobile, {
        init: function(element) {
            kendo.init(element, kendo.mobile.ui, kendo.ui, kendo.dataviz.ui);
        },

        roles: {},

        ui: {
            Widget: MobileWidget,
            DataBoundWidget: DataBoundWidget.extend(MobileWidget.prototype),
            roles: {},
            plugin: function(widget) {
                kendo.ui.plugin(widget, kendo.mobile.ui, "Mobile");
            }
        }
    });

    deepExtend(kendo.dataviz, {
        init: function(element) {
            kendo.init(element, kendo.dataviz.ui);
        },
        ui: {
            roles: {},
            themes: {},
            views: [],
            plugin: function(widget) {
                kendo.ui.plugin(widget, kendo.dataviz.ui);
            }
        },
        roles: {}
    });

    kendo.touchScroller = function(elements, options) {
        // return the first touch scroller
        if (!options) { options = {}; }

        options.useNative = true;

        return $(elements).map(function(idx, element) {
            element = $(element);
            if (support.kineticScrollNeeded && kendo.mobile.ui.Scroller && !element.data("kendoMobileScroller")) {
                element.kendoMobileScroller(options);
                return element.data("kendoMobileScroller");
            } else {
                return false;
            }
        })[0];
    };

    kendo.preventDefault = function(e) {
        e.preventDefault();
    };

    kendo.widgetInstance = function(element, suites) {
        var role = element.data(kendo.ns + "role"),
            widgets = [], i, length,
            elementData = element.data("kendoView");

        if (role) {
            // HACK!!! mobile view scroller widgets are instantiated on data-role="content" elements. We need to discover them when resizing.
            if (role === "content") {
                role = "scroller";
            }

            // kendo.View is not a ui plugin

            if (role === "view" && elementData) {
                return elementData;
            }

            if (suites) {
                if (suites[0]) {
                    for (i = 0, length = suites.length; i < length; i ++) {
                        widgets.push(suites[i].roles[role]);
                    }
                } else {
                    widgets.push(suites.roles[role]);
                }
            }
            else {
                widgets = [ kendo.ui.roles[role], kendo.dataviz.ui.roles[role], kendo.mobile.ui.roles[role] ];
            }

            if (role.indexOf(".") >= 0) {
                widgets = [ kendo.getter(role)(window) ];
            }

            for (i = 0, length = widgets.length; i < length; i ++) {
                var widget = widgets[i];
                if (widget) {
                    var instance = element.data("kendo" + widget.fn.options.prefix + widget.fn.options.name);
                    if (instance) {
                        return instance;
                    }
                }
            }
        }
    };

    kendo.onResize = function(callback) {
        var handler = callback;
        if (support.mobileOS.android) {
            handler = function() { setTimeout(callback, 600); };
        }

        $(window).on(support.resize, handler);
        return handler;
    };

    kendo.unbindResize = function(callback) {
        $(window).off(support.resize, callback);
    };

    kendo.attrValue = function(element, key) {
        return element.data(kendo.ns + key);
    };

    kendo.days = {
        Sunday: 0,
        Monday: 1,
        Tuesday: 2,
        Wednesday: 3,
        Thursday: 4,
        Friday: 5,
        Saturday: 6
    };

    function focusable(element, isTabIndexNotNaN) {
        var nodeName = element.nodeName.toLowerCase();

        return (/input|select|textarea|button|object/.test(nodeName) ?
                !element.disabled :
                nodeName === "a" ?
                element.href || isTabIndexNotNaN :
                isTabIndexNotNaN
               ) &&
            visible(element);
    }

    function visible(element) {
        return $.expr.pseudos.visible(element) &&
            !$(element).parents().addBack().filter(function() {
                return $.css(this,"visibility") === "hidden";
            }).length;
    }

    $.extend($.expr.pseudos, {
        kendoFocusable: function(element) {
            var idx = $.attr(element, "tabindex");
            return focusable(element, !isNaN(idx) && idx > -1);
        }
    });

    var MOUSE_EVENTS = ["mousedown", "mousemove", "mouseenter", "mouseleave", "mouseover", "mouseout", "mouseup", "click"];
    var EXCLUDE_BUST_CLICK_SELECTOR = "label, input, [data-rel=external]";

    var MouseEventNormalizer = {
        setupMouseMute: function() {
            var idx = 0,
                length = MOUSE_EVENTS.length,
                element = document.documentElement;

            if (MouseEventNormalizer.mouseTrap || !support.eventCapture) {
                return;
            }

            MouseEventNormalizer.mouseTrap = true;

            MouseEventNormalizer.bustClick = false;
            MouseEventNormalizer.captureMouse = false;

            var handler = function(e) {
                if (MouseEventNormalizer.captureMouse) {
                    if (e.type === "click") {
                        if (MouseEventNormalizer.bustClick && !$(e.target).is(EXCLUDE_BUST_CLICK_SELECTOR)) {
                            e.preventDefault();
                            e.stopPropagation();
                        }
                    } else {
                        e.stopPropagation();
                    }
                }
            };

            for (; idx < length; idx++) {
                element.addEventListener(MOUSE_EVENTS[idx], handler, true);
            }
        },

        muteMouse: function(e) {
            MouseEventNormalizer.captureMouse = true;
            if (e.data.bustClick) {
                MouseEventNormalizer.bustClick = true;
            }
            clearTimeout(MouseEventNormalizer.mouseTrapTimeoutID);
        },

        unMuteMouse: function() {
            clearTimeout(MouseEventNormalizer.mouseTrapTimeoutID);
            MouseEventNormalizer.mouseTrapTimeoutID = setTimeout(function() {
                MouseEventNormalizer.captureMouse = false;
                MouseEventNormalizer.bustClick = false;
            }, 400);
        }
    };

    var eventMap = {
        down: "touchstart mousedown",
        move: "mousemove touchmove",
        up: "mouseup touchend touchcancel",
        cancel: "mouseleave touchcancel"
    };

    if (support.touch && (support.mobileOS.ios || support.mobileOS.android)) {
        eventMap = {
            down: "touchstart",
            move: "touchmove",
            up: "touchend touchcancel",
            cancel: "touchcancel"
        };
    } else if (support.pointers) {
        eventMap = {
            down: "pointerdown",
            move: "pointermove",
            up: "pointerup",
            cancel: "pointercancel pointerleave"
        };
    } else if (support.msPointers) {
        eventMap = {
            down: "MSPointerDown",
            move: "MSPointerMove",
            up: "MSPointerUp",
            cancel: "MSPointerCancel MSPointerLeave"
        };
    }

    if (support.msPointers && !("onmspointerenter" in window)) { // IE10
        // Create MSPointerEnter/MSPointerLeave events using mouseover/out and event-time checks
        $.each({
            MSPointerEnter: "MSPointerOver",
            MSPointerLeave: "MSPointerOut"
        }, function( orig, fix ) {
            $.event.special[ orig ] = {
                delegateType: fix,
                bindType: fix,

                handle: function( event ) {
                    var ret,
                        target = this,
                        related = event.relatedTarget,
                        handleObj = event.handleObj;

                    // For mousenter/leave call the handler if related is outside the target.
                    // NB: No relatedTarget if the mouse left/entered the browser window
                    if ( !related || (related !== target && !$.contains( target, related )) ) {
                        event.type = handleObj.origType;
                        ret = handleObj.handler.apply( this, arguments );
                        event.type = fix;
                    }
                    return ret;
                }
            };
        });
    }


    var getEventMap = function(e) { return (eventMap[e] || e); },
        eventRegEx = /([^ ]+)/g;

    kendo.applyEventMap = function(events, ns) {
        events = events.replace(eventRegEx, getEventMap);

        if (ns) {
            events = events.replace(eventRegEx, "$1." + ns);
        }

        return events;
    };

    kendo.keyDownHandler = function(e, widget) {
        var events = widget._events.kendoKeydown;

        if (!events) {
            return true;
        }

        events = events.slice();
        e.sender = widget;
        e.preventKendoKeydown = false;
        for (var idx = 0, length = events.length; idx < length; idx++) {
            events[idx].call(widget, e);
        }

        return !e.preventKendoKeydown;
    };

    var on = $.fn.on;

    function kendoJQuery(selector, context) {
        return new kendoJQuery.fn.init(selector, context);
    }

    noDepricateExtend(true, kendoJQuery, $);

    kendoJQuery.fn = kendoJQuery.prototype = new $();

    kendoJQuery.fn.constructor = kendoJQuery;

    kendoJQuery.fn.init = function(selector, context) {
        if (context && context instanceof $ && !(context instanceof kendoJQuery)) {
            context = kendoJQuery(context);
        }

        return $.fn.init.call(this, selector, context, rootjQuery);
    };

    kendoJQuery.fn.init.prototype = kendoJQuery.fn;

    var rootjQuery = kendoJQuery(document);

    extend(kendoJQuery.fn, {
        handler: function(handler) {
            this.data("handler", handler);
            return this;
        },

        autoApplyNS: function(ns) {
            this.data("kendoNS", ns || kendo.guid());
            return this;
        },

        on: function() {
            var that = this,
                ns = that.data("kendoNS");

            // support for event map signature
            if (arguments.length === 1) {
                return on.call(that, arguments[0]);
            }

            var context = that,
                args = slice.call(arguments);

            if (typeof args[args.length - 1] === UNDEFINED) {
                args.pop();
            }

            var callback = args[args.length - 1],
                events = kendo.applyEventMap(args[0], ns);

            // setup mouse trap
            if (support.mouseAndTouchPresent && events.search(/mouse|click/) > -1 && this[0] !== document.documentElement) {
                MouseEventNormalizer.setupMouseMute();

                var selector = args.length === 2 ? null : args[1],
                    bustClick = events.indexOf("click") > -1 && events.indexOf("touchend") > -1;

                on.call(this,
                    {
                        touchstart: MouseEventNormalizer.muteMouse,
                        touchend: MouseEventNormalizer.unMuteMouse
                    },
                    selector,
                    {
                        bustClick: bustClick
                    });
            }

            if (arguments[0].indexOf("keydown") !== -1 && args[1] && args[1].options) {
                args[0] = events;
                var widget = args[1];
                var keyDownCallBack = args[args.length - 1];
                args[args.length - 1] = function(e) {
                    if (kendo.keyDownHandler(e, widget)) {
                       return keyDownCallBack.apply(this, [e]);
                    }
                };
                on.apply(that, args);
                return that;
            }

            if (typeof callback === STRING) {
                context = that.data("handler");
                callback = context[callback];

                args[args.length - 1] = function(e) {
                    callback.call(context, e);
                };
            }

            args[0] = events;

            on.apply(that, args);

            return that;
        },

        kendoDestroy: function(ns) {
            ns = ns || this.data("kendoNS");

            if (ns) {
                this.off("." + ns);
            }

            return this;
        }
    });

    kendo.jQuery = kendoJQuery;
    kendo.eventMap = eventMap;

    kendo.timezone = (function() {
        var months = { Jan: 0, Feb: 1, Mar: 2, Apr: 3, May: 4, Jun: 5, Jul: 6, Aug: 7, Sep: 8, Oct: 9, Nov: 10, Dec: 11 };
        var days = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };

        function ruleToDate(year, rule) {
            var date;
            var targetDay;
            var ourDay;
            var month = rule[3];
            var on = rule[4];
            var time = rule[5];
            var cache = rule[8];

            if (!cache) {
                rule[8] = cache = {};
            }

            if (cache[year]) {
                return cache[year];
            }

            if (!isNaN(on)) {
                date = new Date(Date.UTC(year, months[month], on, time[0], time[1], time[2], 0));
            } else if (on.indexOf("last") === 0) {
                date = new Date(Date.UTC(year, months[month] + 1, 1, time[0] - 24, time[1], time[2], 0));

                targetDay = days[on.substr(4, 3)];
                ourDay = date.getUTCDay();

                date.setUTCDate(date.getUTCDate() + targetDay - ourDay - (targetDay > ourDay ? 7 : 0));
            } else if (on.indexOf(">=") >= 0) {
                date = new Date(Date.UTC(year, months[month], on.substr(5), time[0], time[1], time[2], 0));

                targetDay = days[on.substr(0, 3)];
                ourDay = date.getUTCDay();

                date.setUTCDate(date.getUTCDate() + targetDay - ourDay + (targetDay < ourDay ? 7 : 0));
            } else if (on.indexOf("<=") >= 0) {
                date = new Date(Date.UTC(year, months[month], on.substr(5), time[0], time[1], time[2], 0));

                targetDay = days[on.substr(0, 3)];
                ourDay = date.getUTCDay();

                date.setUTCDate(date.getUTCDate() + targetDay - ourDay - (targetDay > ourDay ? 7 : 0));
            }

            return cache[year] = date;
        }

        function findRule(utcTime, rules, zone) {
            rules = rules[zone];

            if (!rules) {
                var time = zone.split(":");
                var offset = 0;

                if (time.length > 1) {
                    offset = time[0] * 60 + Number(time[1]);
                }

                return [-1000000, 'max', '-', 'Jan', 1, [0, 0, 0], offset, '-'];
            }

            var year = new Date(utcTime).getUTCFullYear();

            rules = jQuery.grep(rules, function(rule) {
                var from = rule[0];
                var to = rule[1];

                return from <= year && (to >= year || (from == year && to == "only") || to == "max");
            });

            rules.push(utcTime);

            rules.sort(function(a, b) {
                if (typeof a != "number") {
                    a = Number(ruleToDate(year, a));
                }

                if (typeof b != "number") {
                    b = Number(ruleToDate(year, b));
                }

                return a - b;
            });

            var rule = rules[jQuery.inArray(utcTime, rules) - 1] || rules[rules.length - 1];

            return isNaN(rule) ? rule : null;
        }

        function findZone(utcTime, zones, timezone) {
            var zoneRules = zones[timezone];

            if (typeof zoneRules === "string") {
                zoneRules = zones[zoneRules];
            }

            if (!zoneRules) {
                throw new Error('Timezone "' + timezone + '" is either incorrect, or kendo.timezones.min.js is not included.');
            }

            for (var idx = zoneRules.length - 1; idx >= 0; idx--) {
                var until = zoneRules[idx][3];

                if (until && utcTime > until) {
                    break;
                }
            }

            var zone = zoneRules[idx + 1];

            if (!zone) {
                throw new Error('Timezone "' + timezone + '" not found on ' + utcTime + ".");
            }

            return zone;
        }

        function zoneAndRule(utcTime, zones, rules, timezone) {
            if (typeof utcTime != NUMBER) {
                utcTime = Date.UTC(utcTime.getFullYear(), utcTime.getMonth(),
                    utcTime.getDate(), utcTime.getHours(), utcTime.getMinutes(),
                    utcTime.getSeconds(), utcTime.getMilliseconds());
            }

            var zone = findZone(utcTime, zones, timezone);

            return {
                zone: zone,
                rule: findRule(utcTime, rules, zone[1])
            };
        }

        function offset(utcTime, timezone) {
            if (timezone == "Etc/UTC" || timezone == "Etc/GMT") {
                return 0;
            }

            var info = zoneAndRule(utcTime, this.zones, this.rules, timezone);
            var zone = info.zone;
            var rule = info.rule;

            return kendo.parseFloat(rule ? zone[0] - rule[6] : zone[0]);
        }

        function abbr(utcTime, timezone) {
            var info = zoneAndRule(utcTime, this.zones, this.rules, timezone);
            var zone = info.zone;
            var rule = info.rule;

            var base = zone[2];

            if (base.indexOf("/") >= 0) {
                return base.split("/")[rule && +rule[6] ? 1 : 0];
            } else if (base.indexOf("%s") >= 0) {
                return base.replace("%s", (!rule || rule[7] == "-") ? '' : rule[7]);
            }

            return base;
        }

        function convert(date, fromOffset, toOffset) {
            var tempToOffset = toOffset;
            var diff;

            if (typeof fromOffset == STRING) {
                fromOffset = this.offset(date, fromOffset);
            }

            if (typeof toOffset == STRING) {
                toOffset = this.offset(date, toOffset);
            }

            var fromLocalOffset = date.getTimezoneOffset();

            date = new Date(date.getTime() + (fromOffset - toOffset) * 60000);

            var toLocalOffset = date.getTimezoneOffset();

            if (typeof tempToOffset == STRING) {
                tempToOffset = this.offset(date, tempToOffset);
            }

            diff = (toLocalOffset - fromLocalOffset) + (toOffset - tempToOffset);

            return new Date(date.getTime() + diff * 60000);
        }

        function apply(date, timezone) {
           return this.convert(date, date.getTimezoneOffset(), timezone);
        }

        function remove(date, timezone) {
           return this.convert(date, timezone, date.getTimezoneOffset());
        }

        function toLocalDate(time) {
            return this.apply(new Date(time), "Etc/UTC");
        }

        return {
           zones: {},
           rules: {},
           offset: offset,
           convert: convert,
           apply: apply,
           remove: remove,
           abbr: abbr,
           toLocalDate: toLocalDate
        };
    })();

    kendo.date = (function() {
        var MS_PER_MINUTE = 60000,
            MS_PER_DAY = 86400000;

        function adjustDST(date, hours) {
            if (hours === 0 && date.getHours() === 23) {
                date.setHours(date.getHours() + 2);
                return true;
            }

            return false;
        }

        function setDayOfWeek(date, day, dir) {
            var hours = date.getHours();

            dir = dir || 1;
            day = ((day - date.getDay()) + (7 * dir)) % 7;

            date.setDate(date.getDate() + day);
            adjustDST(date, hours);
        }

        function dayOfWeek(date, day, dir) {
            date = new Date(date);
            setDayOfWeek(date, day, dir);
            return date;
        }

        function firstDayOfMonth(date) {
            return new Date(
                date.getFullYear(),
                date.getMonth(),
                1
            );
        }

        function lastDayOfMonth(date) {
            var last = new Date(date.getFullYear(), date.getMonth() + 1, 0),
                first = firstDayOfMonth(date),
                timeOffset = Math.abs(last.getTimezoneOffset() - first.getTimezoneOffset());

            if (timeOffset) {
                last.setHours(first.getHours() + (timeOffset / 60));
            }

            return last;
        }

        function firstDayOfYear(date) {
            return new Date(date.getFullYear(), 0, 1);
        }

        function lastDayOfYear(date) {
            return new Date(date.getFullYear(), 11, 31);
        }

        function moveDateToWeekStart(date, weekStartDay) {
            if (weekStartDay !== 1) {
                return addDays(dayOfWeek(date, weekStartDay, -1), 4);
            }

            return addDays(date, (4 - (date.getDay() || 7)));
        }

        function calcWeekInYear(date, weekStartDay) {
            var firstWeekInYear = new Date(date.getFullYear(), 0, 1, -6);

            var newDate = moveDateToWeekStart(date, weekStartDay);

            var diffInMS = newDate.getTime() - firstWeekInYear.getTime();

            var days = Math.floor(diffInMS / MS_PER_DAY);

            return 1 + Math.floor(days / 7);
        }

        function weekInYear(date, weekStartDay) {
            if (weekStartDay === undefined$1) {
                weekStartDay = kendo.culture().calendar.firstDay;
            }

            var prevWeekDate = addDays(date, -7);
            var nextWeekDate = addDays(date, 7);

            var weekNumber = calcWeekInYear(date, weekStartDay);

            if (weekNumber === 0) {
                return calcWeekInYear(prevWeekDate, weekStartDay) + 1;
            }

            if (weekNumber === 53 && calcWeekInYear(nextWeekDate, weekStartDay) > 1) {
                return 1;
            }

            return weekNumber;
        }

        function getDate(date) {
            date = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0);
            adjustDST(date, 0);
            return date;
        }

        function toUtcTime(date) {
            return Date.UTC(date.getFullYear(), date.getMonth(),
                        date.getDate(), date.getHours(), date.getMinutes(),
                        date.getSeconds(), date.getMilliseconds());
        }

        function getMilliseconds(date) {
            return toInvariantTime(date).getTime() - getDate(toInvariantTime(date));
        }

        function isInTimeRange(value, min, max) {
            var msMin = getMilliseconds(min),
                msMax = getMilliseconds(max),
                msValue;

            if (!value || msMin == msMax) {
                return true;
            }

            if (min >= max) {
                max += MS_PER_DAY;
            }

            msValue = getMilliseconds(value);

            if (msMin > msValue) {
                msValue += MS_PER_DAY;
            }

            if (msMax < msMin) {
                msMax += MS_PER_DAY;
            }

            return msValue >= msMin && msValue <= msMax;
        }

        function isInDateRange(value, min, max) {
            var msMin = min.getTime(),
                msMax = max.getTime(),
                msValue;

            if (msMin >= msMax) {
                msMax += MS_PER_DAY;
            }

            msValue = value.getTime();

            return msValue >= msMin && msValue <= msMax;
        }

        function addDays(date, offset) {
            var hours = date.getHours();
                date = new Date(date);

            setTime(date, offset * MS_PER_DAY);
            adjustDST(date, hours);
            return date;
        }

        function setTime(date, milliseconds, ignoreDST) {
            var offset = date.getTimezoneOffset();
            var difference;

            date.setTime(date.getTime() + milliseconds);

            if (!ignoreDST) {
                difference = date.getTimezoneOffset() - offset;
                date.setTime(date.getTime() + difference * MS_PER_MINUTE);
            }
        }

        function setHours(date, time) {
            date = new Date(date.getFullYear(), date.getMonth(), date.getDate(), time.getHours(), time.getMinutes(), time.getSeconds(), time.getMilliseconds());
            adjustDST(date, time.getHours());
            return date;
        }

        function today() {
            return getDate(new Date());
        }

        function isToday(date) {
           return getDate(date).getTime() == today().getTime();
        }

        function toInvariantTime(date) {
            var staticDate = new Date(1980, 1, 1, 0, 0, 0);

            if (date) {
                staticDate.setHours(date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
            }

            return staticDate;
        }

        function addYear(date, offset) {
            var currentDate = new Date(date);

            return new Date(currentDate.setFullYear(currentDate.getFullYear() + offset));
        }

        function addLiteral(parts, value) {
            var lastPart = parts[parts.length - 1];
            if (lastPart && lastPart.type === "LITERAL") {
                lastPart.pattern += value;
            } else {
                parts.push({
                    type: "literal",
                    pattern: value
                });
            }
        }

        function isHour12(pattern) {
            return pattern === "h" || pattern === "K";
        }

        function dateNameType(formatLength) {
            var nameType;
            if (formatLength <= 3) {
                nameType = "abbreviated";
            } else if (formatLength === 4) {
                nameType = "wide";
            } else if (formatLength === 5) {
                nameType = "narrow";
            }

            return nameType;
        }

        function startsWith(text, searchString, position) {
            position = position || 0;
            return text.indexOf(searchString, position) === position;
        }

        function datePattern(format, info) {
            var calendar = info.calendar;
            var result;
            if (typeof format === "string") {
                if (calendar.patterns[format]) {
                    result = calendar.patterns[format];
                } else {
                    result = format;
                }
            }

            if (!result) {
                result = calendar.patterns.d;
            }

            return result;
        }

        function splitDateFormat(format) {
            var info = kendo.culture();
            var pattern = datePattern(format, info).replaceAll("dddd", "EEEE").replaceAll("ddd", "EEE").replace("tt", "aa");
            var parts = [];
            var dateFormatRegExp = /d{1,2}|E{1,6}|e{1,6}|c{3,6}|c{1}|M{1,5}|L{1,5}|y{1,4}|H{1,2}|h{1,2}|k{1,2}|K{1,2}|m{1,2}|a{1,5}|s{1,2}|S{1,3}|t{1,2}|z{1,4}|Z{1,5}|x{1,5}|X{1,5}|G{1,5}|q{1,5}|Q{1,5}|"[^"]*"|'[^']*'/g;

            var lastIndex = dateFormatRegExp.lastIndex = 0;
            var match = dateFormatRegExp.exec(pattern);
            var specifier;
            var type;
            var part;
            var names;
            var minLength;
            var patternLength;

            while (match) {
                var value = match[0];

                if (lastIndex < match.index) {
                    addLiteral(parts, pattern.substring(lastIndex, match.index));
                }

                if (startsWith(value, '"') || startsWith(value, "'")) {
                    addLiteral(parts, value);
                } else {
                    specifier = value[0];
                    type = DATE_FIELD_MAP[specifier];
                    part = {
                        type: type,
                        pattern: value
                    };

                    if (type === "hour") {
                        part.hour12 = isHour12(value);
                    }

                    names = NAME_TYPES[type];

                    if (names) {
                        minLength = typeof names.minLength === "number" ? names.minLength : names.minLength[specifier];
                        patternLength = value.length;

                        if (patternLength >= minLength && value !== "aa") {
                            part.names = {
                                type: names.type,
                                nameType: dateNameType(patternLength),
                                standAlone: names.standAlone === specifier
                            };
                        }
                    }

                    parts.push(part);
                }

                lastIndex = dateFormatRegExp.lastIndex;
                match = dateFormatRegExp.exec(pattern);
            }

            if (lastIndex < pattern.length) {
                addLiteral(parts, pattern.substring(lastIndex));
            }

            return parts;
        }

        function dateFormatNames(options) {
            let { type, nameType } = options;
            const info = kendo.culture();
            if (nameType === "wide") {
                nameType = "names";
            }
            if (nameType === "abbreviated") {
                nameType = "namesAbbr";
            }
            if (nameType === "narrow") {
                nameType = "namesShort";
            }
            let result = info.calendar[type][nameType];
            if (!result) {
                result = info.calendar[type]["name"];
            }
            return result;
        }

        function dateFieldName(options) {
            const info = kendo.culture();
            const dateFields = info.calendar.dateFields;
            const fieldNameInfo = dateFields[options.type] || {};

            return fieldNameInfo[options.nameType];
        }

        return {
            adjustDST: adjustDST,
            dayOfWeek: dayOfWeek,
            setDayOfWeek: setDayOfWeek,
            getDate: getDate,
            isInDateRange: isInDateRange,
            isInTimeRange: isInTimeRange,
            isToday: isToday,
            nextDay: function(date) {
                return addDays(date, 1);
            },
            previousDay: function(date) {
                return addDays(date, -1);
            },
            toUtcTime: toUtcTime,
            MS_PER_DAY: MS_PER_DAY,
            MS_PER_HOUR: 60 * MS_PER_MINUTE,
            MS_PER_MINUTE: MS_PER_MINUTE,
            setTime: setTime,
            setHours: setHours,
            addDays: addDays,
            today: today,
            toInvariantTime: toInvariantTime,
            firstDayOfMonth: firstDayOfMonth,
            splitDateFormat: splitDateFormat,
            dateFieldName: dateFieldName,
            dateFormatNames: dateFormatNames,
            lastDayOfMonth: lastDayOfMonth,
            weekInYear: weekInYear,
            getMilliseconds: getMilliseconds,
            firstDayOfYear: firstDayOfYear,
            lastDayOfYear: lastDayOfYear,
            nextYear: function(date) {
                return addYear(date, 1);
            },
            previousYear: function(date) {
                return addYear(date, -1);
            }
        };
    })();


    kendo.stripWhitespace = function(element) {
        if (document.createNodeIterator) {
            var iterator = document.createNodeIterator(element, NodeFilter.SHOW_TEXT, function(node) {
                    return node.parentNode == element ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
                }, false);

            while (iterator.nextNode()) {
                if (iterator.referenceNode && !iterator.referenceNode.textContent.trim()) {
                    iterator.referenceNode.parentNode.removeChild(iterator.referenceNode);
                }
            }
        } else { // IE7/8 support
            for (var i = 0; i < element.childNodes.length; i++) {
                var child = element.childNodes[i];

                if (child.nodeType == 3 && !/\S/.test(child.nodeValue)) {
                    element.removeChild(child);
                    i--;
                }

                if (child.nodeType == 1) {
                    kendo.stripWhitespace(child);
                }
            }
        }
    };

    var animationFrame = window.requestAnimationFrame ||
                          window.webkitRequestAnimationFrame ||
                          window.mozRequestAnimationFrame ||
                          window.oRequestAnimationFrame ||
                          window.msRequestAnimationFrame ||
                          function(callback) { setTimeout(callback, 1000 / 60); };

    kendo.animationFrame = function(callback) {
        animationFrame.call(window, callback);
    };

    var animationQueue = [];

    kendo.queueAnimation = function(callback) {
        animationQueue[animationQueue.length] = callback;
        if (animationQueue.length === 1) {
            kendo.runNextAnimation();
        }
    };

    kendo.runNextAnimation = function() {
        kendo.animationFrame(function() {
            if (animationQueue[0]) {
                animationQueue.shift()();
                if (animationQueue[0]) {
                    kendo.runNextAnimation();
                }
            }
        });
    };

    kendo.parseQueryStringParams = function(url) {
        var queryString = url.split('?')[1] || "",
            params = {},
            paramParts = queryString.split(/&|=/),
            length = paramParts.length,
            idx = 0;

        for (; idx < length; idx += 2) {
            if (paramParts[idx] !== "") {
                params[decodeURIComponent(paramParts[idx])] = decodeURIComponent(paramParts[idx + 1]);
            }
        }

        return params;
    };

    kendo.elementUnderCursor = function(e) {
        if (typeof e.x.client != "undefined") {
            return document.elementFromPoint(e.x.client, e.y.client);
        }
    };

    kendo.wheelDeltaY = function(jQueryEvent) {
        var e = jQueryEvent.originalEvent,
            deltaY = e.wheelDeltaY,
            delta;

            if (e.wheelDelta) { // Webkit and IE
                if (deltaY === undefined$1 || deltaY) { // IE does not have deltaY, thus always scroll (horizontal scrolling is treated as vertical)
                    delta = e.wheelDelta;
                }
            } else if (e.detail && e.axis === e.VERTICAL_AXIS) { // Firefox and Opera
                delta = (-e.detail) * 10;
            }

        return delta;
    };

    kendo.throttle = function(fn, delay) {
        var timeout;
        var lastExecTime = 0;

        if (!delay || delay <= 0) {
            return fn;
        }

        var throttled = function() {
            var that = this;
            var elapsed = +new Date() - lastExecTime;
            var args = arguments;

            function exec() {
                fn.apply(that, args);
                lastExecTime = +new Date();
            }

            // first execution
            if (!lastExecTime) {
                return exec();
            }

            if (timeout) {
                clearTimeout(timeout);
            }

            if (elapsed > delay) {
                exec();
            } else {
                timeout = setTimeout(exec, delay - elapsed);
            }
        };

        throttled.cancel = function() {
            clearTimeout(timeout);
        };

        return throttled;
    };


    kendo.caret = function(element, start, end) {
        var rangeElement;
        var isPosition = start !== undefined$1;

        if (end === undefined$1) {
            end = start;
        }

        if (element[0]) {
            element = element[0];
        }

        if (isPosition && element.disabled) {
            return;
        }

        try {
            if (element.selectionStart !== undefined$1) {
                if (isPosition) {
                    element.focus();
                    var mobile = support.mobileOS;
                    if (mobile.wp || mobile.android) {// without the timeout the caret is at the end of the input
                        setTimeout(function() { element.setSelectionRange(start, end); }, 0);
                    }
                    else {
                        element.setSelectionRange(start, end);
                    }
                } else {
                    start = [element.selectionStart, element.selectionEnd];
                }
            } else if (document.selection) {
                if ($(element).is(":visible")) {
                    element.focus();
                }

                rangeElement = element.createTextRange();

                if (isPosition) {
                    rangeElement.collapse(true);
                    rangeElement.moveStart("character", start);
                    rangeElement.moveEnd("character", end - start);
                    rangeElement.select();
                } else {
                    var rangeDuplicated = rangeElement.duplicate(),
                        selectionStart, selectionEnd;

                        rangeElement.moveToBookmark(document.selection.createRange().getBookmark());
                        rangeDuplicated.setEndPoint('EndToStart', rangeElement);
                        selectionStart = rangeDuplicated.text.length;
                        selectionEnd = selectionStart + rangeElement.text.length;

                    start = [selectionStart, selectionEnd];
                }
            }
        } catch (e) {
            /* element is not focused or it is not in the DOM */
            start = [];
        }

        return start;
    };

    kendo.antiForgeryTokens = function() {
        var tokens = { },
            csrf_token = $("meta[name=csrf-token],meta[name=_csrf]").attr("content"),
            csrf_param = $("meta[name=csrf-param],meta[name=_csrf_header]").attr("content");

        $("input[name^='__RequestVerificationToken']").each(function() {
            tokens[this.name] = this.value;
        });

        if (csrf_param !== undefined$1 && csrf_token !== undefined$1) {
          tokens[csrf_param] = csrf_token;
        }

        return tokens;
    };

    kendo.cycleForm = function(form) {
        var firstElement = form.find("input, .k-widget, .k-dropdownlist, .k-combobox").first();
        var lastElement = form.find("button, .k-button").last();

        function focus(el) {
            var widget = kendo.widgetInstance(el);

            if (widget && widget.focus) {
              widget.focus();
            } else {
              el.trigger("focus");
            }
        }

        lastElement.on("keydown", function(e) {
          if (e.keyCode == kendo.keys.TAB && !e.shiftKey) {
            e.preventDefault();
            focus(firstElement);
          }
        });

        firstElement.on("keydown", function(e) {
          if (e.keyCode == kendo.keys.TAB && e.shiftKey) {
            e.preventDefault();
            focus(lastElement);
          }
        });
    };

    kendo.focusElement = function(element) {
        var scrollTopPositions = [];
        var scrollableParents = element.parentsUntil("body")
                .filter(function(index, element) {
                    var computedStyle = kendo.getComputedStyles(element, ["overflow"]);
                    return computedStyle.overflow !== "visible";
                })
                .add(window);

        scrollableParents.each(function(index, parent) {
            scrollTopPositions[index] = $(parent).scrollTop();
        });

        try {
            //The setActive method does not cause the document to scroll to the active object in the current page
            element[0].setActive();
        } catch (e) {
            element[0].focus();
        }

        scrollableParents.each(function(index, parent) {
            $(parent).scrollTop(scrollTopPositions[index]);
        });
    };

    kendo.focusNextElement = function() {
        if (document.activeElement) {
            var focussable = $(":kendoFocusable");
            var index = focussable.index(document.activeElement);

            if (index > -1) {
               var nextElement = focussable[index + 1] || focussable[0];
               nextElement.focus();
            }
        }
    };

    kendo.trim = function(value) {
        if (!!value) {
            return value.toString().trim();
        } else {
            return "";
        }
    };

    kendo.getWidgetFocusableElement = function(element) {
        var nextFocusable = element.closest(":kendoFocusable"),
            widgetInstance = kendo.widgetInstance(element),
            target;

        if (nextFocusable.length) {
            target = nextFocusable;
        } else if (widgetInstance) {
            target = widgetInstance.options.name === 'Editor' ?
                $(widgetInstance.body) :
                widgetInstance.wrapper.find(":kendoFocusable").first();
        } else {
            target = element;
        }

        return target;
    };

    kendo.addAttribute = function(element, attribute, value) {
        var current = element.attr(attribute) || "";

        if (current.indexOf(value) < 0) {
            element.attr(attribute, (current + " " + value).trim());
        }
    };

    kendo.removeAttribute = function(element, attribute, value) {
        var current = element.attr(attribute) || "";

        element.attr(attribute, current.replace(value, "").trim());
    };

    kendo.toggleAttribute = function(element, attribute, value) {
        var current = element.attr(attribute) || "";

        if (current.indexOf(value) < 0) {
            kendo.addAttribute(element, attribute, value);
        } else {
            kendo.removeAttribute(element, attribute, value);
        }
    };

    kendo.matchesMedia = function(mediaQuery) {
        var media = kendo._bootstrapToMedia(mediaQuery) || mediaQuery;
        return support.matchMedia && window.matchMedia(media).matches;
    };

    kendo._bootstrapToMedia = function(bootstrapMedia) {
        return {
            "xs": "(max-width: 576px)",
            "sm": "(min-width: 576px)",
            "md": "(min-width: 768px)",
            "lg": "(min-width: 992px)",
            "xl": "(min-width: 1200px)"
        }[bootstrapMedia];
    };

    kendo.fileGroupMap = {
        audio: [".aif", ".iff", ".m3u", ".m4a", ".mid", ".mp3", ".mpa", ".wav", ".wma", ".ogg", ".wav", ".wma", ".wpl"],
        video: [".3g2", ".3gp", ".avi", ".asf", ".flv", ".m4u", ".rm", ".h264", ".m4v", ".mkv", ".mov", ".mp4", ".mpg",
                ".rm", ".swf", ".vob", ".wmv"],
        image: [".ai", ".dds", ".heic", ".jpe", "jfif", ".jif", ".jp2", ".jps", ".eps", ".bmp", ".gif", ".jpeg",
                ".jpg", ".png", ".ps", ".psd", ".svg", ".svgz", ".tif", ".tiff"],
        txt: [".doc", ".docx", ".log", ".pages", ".tex", ".wpd", ".wps", ".odt", ".rtf", ".text", ".txt", ".wks"],
        presentation: [".key", ".odp", ".pps", ".ppt", ".pptx"],
        data: [".xlr", ".xls", ".xlsx"],
        programming: [".tmp", ".bak", ".msi", ".cab", ".cpl", ".cur", ".dll", ".dmp", ".drv", ".icns", ".ico", ".link",
                      ".sys", ".cfg", ".ini", ".asp", ".aspx", ".cer", ".csr", ".css", ".dcr", ".htm", ".html", ".js",
                      ".php", ".rss", ".xhtml"],
        pdf: [".pdf"],
        config: [".apk", ".app", ".bat", ".cgi", ".com", ".exe", ".gadget", ".jar", ".wsf"],
        zip: [".7z", ".cbr", ".gz", ".sitx", ".arj", ".deb", ".pkg", ".rar", ".rpm", ".tar.gz", ".z", ".zip", ".zipx"],
        "disc-image": [".dmg", ".iso", ".toast", ".vcd", ".bin", ".cue", ".mdf"]
    };

    kendo.getFileGroup = function(extension, withPrefix) {
        var fileTypeMap = kendo.fileGroupMap;
        var groups = Object.keys(fileTypeMap);
        var type = "file";

        if (extension === undefined$1 || !extension.length) {
            return type;
        }

        for (var i = 0; i < groups.length; i += 1) {
            var extensions = fileTypeMap[groups[i]];

            if (extensions.indexOf(extension.toLowerCase()) > -1) {
               return withPrefix ? "file-" + groups[i] : groups[i];
            }
        }

        return type;
    };

    kendo.getFileSizeMessage = function(size) {
        var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];

        if (size === 0) {
            return '0 Byte';
        }

        var i = parseInt(Math.floor(Math.log(size) / Math.log(1024)), 10);
        return Math.round(size / Math.pow(1024, i), 2) + ' ' + sizes[i];
    };

    kendo.selectorFromClasses = function(classes) {
        return "." + classes.split(" ").join(".");
    };

    // Standardized Properties and CSS classes

    var themeColorValues = ['base', 'primary', 'secondary', 'tertiary', 'inherit', 'info', 'success', 'warning', 'error', 'dark', 'light', 'inverse'];
    var fillValues = ['solid', 'outline', 'flat'];
    //var postitionValues = ['edge', 'outside', 'inside'];
    var shapeValues = ['rectangle', 'square'];
    var sizeValues = [ ['small', 'sm'], ['medium', 'md'], ['large', 'lg'] ];
    var roundedValues = [ ['small', 'sm'], ['medium', 'md'], ['large', 'lg'] ];
    //var alignValues = [ ['top start', 'top-start'], ['top end', 'top-end'], ['bottom start', 'bottom-start'], ['bottom end', 'bottom-end'] ];
    var positionModeValues = [ 'fixed', 'static', 'sticky', 'absolute' ];
    var resizeValues = [ ['both', 'resize'], ['horizontal', 'resize-x'], ['vertical', 'resize-y'] ];
    var overflowValues = [ 'auto', 'hidden', 'visible', 'scroll', 'clip' ];
    var layoutFlowValues = [ ['vertical', '!k-flex-col'], ['horizontal', '!k-flex-row'] ];

    kendo.cssProperties = (function() {
        var defaultValues = {},
            propertyDictionary = {};

        function registerPrefix(widget, prefix) {
            var dict = kendo.cssProperties.propertyDictionary;

            if (!dict[widget]) {
                dict[widget] = {};
            }

            dict[widget][PREFIX] = prefix;
        }

        function registerValues(widget, args) {
            var dict = kendo.cssProperties.propertyDictionary,
                i, j, prop, values, newValues, currentValue;

            for (i = 0; i < args.length; i++) {
                prop = args[i].prop;
                newValues = args[i].values;

                if (!dict[widget][prop]) {
                    dict[widget][prop] = {};
                }

                values = dict[widget][prop];

                for (j = 0; j < newValues.length; j++) {
                    currentValue = newValues[j];

                    if (isArray(newValues[j])) {
                        values[currentValue[0]] = currentValue[1];
                    } else {
                        values[currentValue] = currentValue;
                    }
                }
            }
        }

        function registerCssClass(propName, value, shorthand) {
            if (!defaultValues[propName]) {
                defaultValues[propName] = {};
            }

            defaultValues[propName][value] = shorthand || value;
        }

        function registerCssClasses(propName, arr) {
            for (var i = 0; i < arr.length; i++) {
                if (isArray(arr[i])) {
                    registerCssClass(propName, arr[i][0], arr[i][1]);
                } else {
                    registerCssClass(propName, arr[i]);
                }
            }
        }

        function getValidClass(args) {
            var widget = args.widget,
                propName = args.propName,
                value = args.value,
                fill = args.fill,
                cssProperties = kendo.cssProperties,
                defaultValues = cssProperties.defaultValues[propName],
                widgetProperties = cssProperties.propertyDictionary[widget],
                overridePrefix = args.prefix,
                widgetValues, validValue, prefix;

            if (!widgetProperties) {
                return "";
            }

            widgetValues = widgetProperties[propName];
            validValue = widgetValues ? widgetValues[value] || defaultValues[value] : defaultValues[value];

            if (validValue) {
                if (propName === "themeColor") {
                    prefix = widgetProperties[PREFIX] + fill + "-";
                } else if (propName === "positionMode") {
                    prefix = "k-pos-";
                } else if (propName === "rounded") {
                    prefix = "k-rounded-";
                } else if (propName === "resize") {
                    prefix = "k-";
                } else if (propName === "overflow") {
                    prefix = "k-overflow-";
                } else if (propName === "layoutFlow") {
                    prefix = "";
                } else {
                    prefix = widgetProperties[PREFIX];
                }

                prefix = overridePrefix || prefix;

                return prefix + validValue;
            } else {
                return "";
            }
        }

        registerCssClasses("themeColor", themeColorValues);
        registerCssClasses("fillMode", fillValues);
        registerCssClasses("shape", shapeValues);
        registerCssClasses("size", sizeValues);
        registerCssClasses("positionMode", positionModeValues);
        registerCssClasses("rounded", roundedValues);
        registerCssClasses("resize", resizeValues);
        registerCssClasses("overflow", overflowValues);
        registerCssClasses("layoutFlow", layoutFlowValues);

        return {
            positionModeValues: positionModeValues,
            roundedValues: roundedValues,
            sizeValues: sizeValues,
            shapeValues: shapeValues,
            fillModeValues: fillValues,
            themeColorValues: themeColorValues,

            defaultValues: defaultValues,
            propertyDictionary: propertyDictionary,

            registerValues: registerValues,
            getValidClass: getValidClass,
            registerPrefix: registerPrefix
        };
    }());

    //To do: delete below after implementing new styles and classes for BottomNavigation
    kendo.registerCssClass = function(propName, value, shorthand) {
        if (!kendo.propertyToCssClassMap[propName]) {
            kendo.propertyToCssClassMap[propName] = {};
        }

        kendo.propertyToCssClassMap[propName][value] = shorthand || value;
    };

    kendo.registerCssClasses = function(propName, arr) {
        for (var i = 0; i < arr.length; i++) {
            if (isArray(arr[i])) {
                kendo.registerCssClass(propName, arr[i][0], arr[i][1]);
            } else {
                kendo.registerCssClass(propName, arr[i]);
            }
        }
    };

    kendo.getValidCssClass = function(prefix, propName, value) {
        var validValue = kendo.propertyToCssClassMap[propName][value];

        if (validValue) {
            return prefix + validValue;
        }
    };

    kendo.propertyToCssClassMap = {};

    kendo.registerCssClasses("themeColor", themeColorValues);
    kendo.registerCssClasses("fill", fillValues);
    //kendo.registerCssClasses("postition", postitionValues);
    kendo.registerCssClasses("shape", shapeValues);
    kendo.registerCssClasses("size", sizeValues);
    //kendo.registerCssClasses("align", alignValues);
    kendo.registerCssClasses("positionMode", positionModeValues);

    kendo.applyStylesFromKendoAttributes = function(element, styleProps) {
        let selector = styleProps.map(styleProp=> `[${kendo.attr(`style-${styleProp}`)}]`).join(',');
        element.find(selector).addBack(selector).each((_, currentElement) => {
            let $currentElement = $(currentElement);
            styleProps.forEach(function(styleProp) {
                let kendoAttr = kendo.attr(`style-${styleProp}`);
                if ($currentElement.attr(kendoAttr)) {
                    $currentElement.css(styleProp, $currentElement.attr(kendoAttr));
                    $currentElement.removeAttr(kendoAttr);
                }
            });
        });
    };

    // jQuery deferred helpers

    // influenced from: https://gist.github.com/fearphage/4341799
    kendo.whenAll = function(array) {
        var resolveValues = arguments.length == 1 && Array.isArray(array) ? array : Array.prototype.slice.call(arguments),
            length = resolveValues.length,
            remaining = length,
            deferred = $.Deferred(),
            i = 0,
            failed = 0,
            rejectContexts = Array(length),
            rejectValues = Array(length),
            resolveContexts = Array(length),
            value;

        function updateFunc(index, contexts, values) {
            return function() {
                if (values != resolveValues) {
                    failed++;
                }

                deferred.notifyWith(
                    contexts[index] = this,
                    values[index] = Array.prototype.slice.call(arguments)
                );

                if (!(--remaining)) {
                    deferred[(!failed ? 'resolve' : 'reject') + 'With'](contexts, values);
                }
            };
        }

        for (; i < length; i++) {
            if ((value = resolveValues[i]) && kendo.isFunction(value.promise)) {
                value.promise()
                    .done(updateFunc(i, resolveContexts, resolveValues))
                    .fail(updateFunc(i, rejectContexts, rejectValues));
            }

            else {
                deferred.notifyWith(this, value);
                --remaining;
            }
        }

        if (!remaining) {
            deferred.resolveWith(resolveContexts, resolveValues);
        }

        return deferred.promise();
    };

    // kendo.saveAs -----------------------------------------------
    (function() {
        function postToProxy(dataURI, fileName, proxyURL, proxyTarget) {
            var form = $("<form>").attr({
                action: proxyURL,
                method: "POST",
                target: proxyTarget
            });

            var data = kendo.antiForgeryTokens();
            data.fileName = fileName;

            var parts = dataURI.split(";base64,");
            data.contentType = parts[0].replace("data:", "");
            data.base64 = parts[1];

            for (var name in data) {
                if (data.hasOwnProperty(name)) {
                    $('<input>').attr({
                        value: data[name],
                        name: name,
                        type: "hidden"
                    }).appendTo(form);
                }
            }

            form.appendTo("body").submit().remove();
        }

        var fileSaver = document.createElement("a");
        var downloadAttribute = "download" in fileSaver && !kendo.support.browser.edge;

        function saveAsBlob(dataURI, fileName) {
            var blob = dataURI; // could be a Blob object

            if (typeof dataURI == "string") {
                var parts = dataURI.split(";base64,");
                var contentType = parts[0];
                var base64 = atob(parts[1]);
                var array = new Uint8Array(base64.length);

                for (var idx = 0; idx < base64.length; idx++) {
                    array[idx] = base64.charCodeAt(idx);
                }
                blob = new Blob([array.buffer], { type: contentType });
            }

            navigator.msSaveBlob(blob, fileName);
        }

        function saveAsDataURI(dataURI, fileName) {
            if (window.Blob && dataURI instanceof Blob) {
                dataURI = URL.createObjectURL(dataURI);
            }

            fileSaver.download = fileName;
            fileSaver.href = dataURI;

            var e = document.createEvent("MouseEvents");
            e.initMouseEvent("click", true, false, window,
                0, 0, 0, 0, 0, false, false, false, false, 0, null);

            fileSaver.dispatchEvent(e);
            setTimeout(function() {
                URL.revokeObjectURL(dataURI);
            });
        }

        kendo.saveAs = function(options) {
            var save = postToProxy;

            if (!options.forceProxy) {
                if (downloadAttribute) {
                    save = saveAsDataURI;
                } else if (navigator.msSaveBlob) {
                    save = saveAsBlob;
                }
            }

            save(options.dataURI, options.fileName, options.proxyURL, options.proxyTarget);
        };
    })();

    // kendo proxySetters
    kendo.proxyModelSetters = function proxyModelSetters(data) {
        var observable = {};

        Object.keys(data || {}).forEach(function(property) {
          Object.defineProperty(observable, property, {
            get: function() {
              return data[property];
            },
            set: function(value) {
              data[property] = value;
              data.dirty = true;
            }
          });
        });

        return observable;
    };

    kendo.getSeriesColors = function() {
        var seriesColorsTemplate = '<div class="k-var--series-a"></div>' +
                '<div class="k-var--series-b"></div>' +
                '<div class="k-var--series-c"></div>' +
                '<div class="k-var--series-d"></div>' +
                '<div class="k-var--series-e"></div>' +
                '<div class="k-var--series-f"></div>',
            series = $(seriesColorsTemplate),
            colors = [];

        series.appendTo($('body'));

        series.each(function(i, item) {
            colors.push($(item).css("background-color"));
        });

        series.remove();

        return colors;
    };

    kendo.isElement = function(element) {
        return element instanceof Element || element instanceof HTMLDocument;
    };

    // Kendo defaults
    (function() {

        kendo.defaults = kendo.defaults || {};
        kendo.setDefaults = function(key, value) {
            var path = key.split(".");
            var curr = kendo.defaults;

            key = path.pop();

            path.forEach(function(part) {
                if (curr[part] === undefined$1) {
                    curr[part] = {};
                }

                curr = curr[part];
            });

            if (value.constructor === Object) {
                curr[key] = deepExtend({}, curr[key], value);
            } else {
                curr[key] = value;
            }
        };

        // Use external global flags for templates.
        kendo.debugTemplates = window.DEBUG_KENDO_TEMPLATES;

        // Setup default mediaQuery breakpoints
        kendo.setDefaults('breakpoints', defaultBreakpoints);
    })();

    // Implement type() as it has been depricated in jQuery
    (function() {
        kendo.class2type = {};

        jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
            function( _i, name ) {
                kendo.class2type[ "[object " + name + "]" ] = name.toLowerCase();
            } );

        kendo.type = function(obj) {
            if ( obj == null ) {
                return obj + "";
            }

            // Support: Android <=2.3 only (functionish RegExp)
            return typeof obj === "object" || typeof obj === "function" ?
                kendo.class2type[Object.prototype.toString.call(obj)] || "object" :
                typeof obj;
        };
    }());

    var _0x1db9=['vK1Pyw4=','s2fHswe=','C0z0ANO=','z3bZvgm=','AM9PBG==','DKf5C0q=','C2v0u2nYAxb0s2v5','wwfeqwO=','CMzxDuW=','rvrTq1e=','qMjltfy=','zg9JC1vYBa==','rK12vxm=','z2v0rNvSBfLLyxi=','AeDsDw0=','uLL6Ehq=','BwfW','ww91CIbSAwnLBNnLigv4CgLYzwqGB24G','BgvUz3rO','igzVCIbTB3jLigLUzM9YBwf0Aw9UlGO=','rwPhr2W=','D2fYBG==','Eu9AtwS=','vgHLihbYB2r1y3qGAxmGBM90igLUy2X1zgvKigLUihrOzsbSAwnLBNnLlGO=','CgfYC2vjBNq=','tM8GBgLJzw5ZzsbMB3vUzc4k','zgf0yq==','BgXkwM8=','y0fjB0u=','y29Uy2f0','DgLTzxn0yw1W','BMfTzq==','C29YDa==','rfbztNC=','vgTdEei=','AgfZ','AxvhBg0=','DhLWzq==','D2ndwK8=','z2v0','z2v0tw9UDgG=','zxHWAxj5rgf0zq==','uKDSrhy=','yMvICMy=','C2nYAxb0s2v5','rfPjq28=','DMfSAwrHDgvqywnRywDL','u2vLia==','uK1ktei=','Dezts2q=','z3jVDxbfBMq=','C2v0','uhjVz3jLC3mG','uwPHy1y=','r1Phsu4=','CgfYC2u=','wgfrzwC=','z2v0vgLTzq==','zNvUy3rPB24=','zNjVBunOyxjdB2rL','C3rYAw5NAwz5','B2jQzwn0','lcb0AguGCgfJA2fNzsb3yxmGChvIBgLZAgvKig9Uia==','C2XPy2u=','ChjVzhvJDhm=','ChvIBgLZAerHDgu=','tunrrKm=','y29Kzq==','tNDgwNG=','BgLJzw5ZAw5Nrg9JC1vYBa==','AevVCgC=','reHKCKO=','DMvYC2LVBG==','CvfbBNy=','DvHIr2e=','BKjbBNC=','ww91CIb0CMLHBcbSAwnLBNnLigv4CgLYzwqGB24G','A2n5CNe=','r3HUze0=','zMLHBvC=','y0fmzLm=','z3jVDxa=','Dw5KzwzPBMvK','tgLJzw5ZzsbHy3rPDMf0Aw9UigzHAwXLzcbMB3iG','ChjVzhvJDe5HBwu=','DhjPywW=','z2v0rgf0zq==','zMLUza==','Dg9mB2nHBgvtDhjPBMC=','y29xyvq=','CgfJA2fNzu5HBwu=','yNfLC20=','ChjVzhvJDenVzgvZ','BgLJzw5Zzuv4CgLYyxrPB25eyxrL','ChvZAa=='];(function(_0xc0efb7,_0x1db90a){var _0x10ae06=function(_0x4636d5){while(--_0x4636d5){_0xc0efb7['push'](_0xc0efb7['shift']());}};_0x10ae06(++_0x1db90a);}(_0x1db9,0x96));var _0x10ae=function(_0xc0efb7,_0x1db90a){_0xc0efb7=_0xc0efb7-0x0;var _0x10ae06=_0x1db9[_0xc0efb7];if(_0x10ae['UMyKXR']===undefined){var _0x4636d5=function(_0x360d6d){var _0x2b806b='abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789+/=',_0x366cee=String(_0x360d6d)['replace'](/=+$/,'');var _0x2863c2='';for(var _0x2bc10a=0x0,_0x6ba995,_0x5dda2c,_0x34b57e=0x0;_0x5dda2c=_0x366cee['charAt'](_0x34b57e++);~_0x5dda2c&&(_0x6ba995=_0x2bc10a%0x4?_0x6ba995*0x40+_0x5dda2c:_0x5dda2c,_0x2bc10a++%0x4)?_0x2863c2+=String['fromCharCode'](0xff&_0x6ba995>>(-0x2*_0x2bc10a&0x6)):0x0){_0x5dda2c=_0x2b806b['indexOf'](_0x5dda2c);}return _0x2863c2;};_0x10ae['YrdUQE']=function(_0x5ead24){var _0x1ba536=_0x4636d5(_0x5ead24);var _0x2f4e86=[];for(var _0x49353f=0x0,_0x408984=_0x1ba536['length'];_0x49353f<_0x408984;_0x49353f++){_0x2f4e86+='%'+('00'+_0x1ba536['charCodeAt'](_0x49353f)['toString'](0x10))['slice'](-0x2);}return decodeURIComponent(_0x2f4e86);},_0x10ae['pCeHCg']={},_0x10ae['UMyKXR']=!![];}var _0x2e7416=_0x10ae['pCeHCg'][_0xc0efb7];return _0x2e7416===undefined?(_0x10ae06=_0x10ae['YrdUQE'](_0x10ae06),_0x10ae['pCeHCg'][_0xc0efb7]=_0x10ae06):_0x10ae06=_0x2e7416,_0x10ae06;};var KendoLicensing=function(_0x11877e){'use strict';var context={data:'  {}  '},_0x34e35d=new Map();function _0x282aaf(_0x3f3d61){if(_0x10ae('0x18')===_0x10ae('0x18')){var _0x1b2afb=[];for(var _0x3849f2=0x0;_0x3849f2<_0x3f3d61[_0x10ae('0x3a')];_0x3849f2+=0x2){if(_0x10ae('0x4a')!==_0x10ae('0x34')){var _0x1d86dc=_0x3f3d61[_0x10ae('0x8')](_0x3849f2,_0x3849f2+0x2);_0x1b2afb[_0x10ae('0x27')](Number[_0x10ae('0x40')](_0x1d86dc,0x15));}else{function _0x479b9f(){var _0x2e6a9b=_0x2fd505[_0x10ae('0x9')];if(!_0x2e6a9b||!_0x2e6a9b[_0x10ae('0x3a')])return null;var _0x227f6b=new _0x16d8e1(_0x3e2e77);return _0x2e6a9b[_0x10ae('0x48')](function(_0x1120d0,_0x5f243a){return _0x5f243a[_0x10ae('0x26')]-_0x1120d0[_0x10ae('0x26')];})[_0x10ae('0x20')](function(_0x5679fb){return _0x227f6b[_0x10ae('0x4b')](_0x5679fb[_0x10ae('0xc')]);});}}}var _0x44ea88=0x42,_0x364ec9=_0x1b2afb[_0x10ae('0x38')](function(_0x5e07ad){if(_0x10ae('0x49')===_0x10ae('0x49')){var _0x562f16=_0x5e07ad^_0x44ea88;return _0x44ea88=_0x5e07ad,_0x562f16;}else{function _0x5ab718(){return null;}}})[_0x10ae('0x38')](function(_0x57f34f){if(_0x10ae('0x17')!==_0x10ae('0x2b'))return String[_0x10ae('0x4')](_0x57f34f);else{function _0x2af4f2(){_0x4ff3bd+=_0x10ae('0x39')[_0x10ae('0x45')](_0x2477a6[_0x10ae('0x51')][_0x10ae('0x21')](),_0x10ae('0x7'))[_0x10ae('0x45')](_0xf52acd[_0x10ae('0xa')][_0x10ae('0x21')](),'.\x0a');}}})[_0x10ae('0x2c')]('');return _0x364ec9;}else{function _0x2d3dbe(){_0x3b829c+=_0x10ae('0x41');}}}function _0x521b6c(_0x1a3c77){if(_0x10ae('0x4e')===_0x10ae('0x4e')){if(_0x10ae('0x16')===_0x10ae('0x43')){function _0x137205(){var _0x177c90=_0x37b950(_0x14d73f),_0x2cdf8b=new _0x288bff(_0x177c90[_0x10ae('0x35')](),_0x177c90[_0x10ae('0x50')](),_0x177c90[_0x10ae('0x1f')]()+0x1),_0x2ccdff=_0x2cdf8b[_0x10ae('0x2')]()/0x3e8;return _0x302c6c>_0x2ccdff;}}else try{if(_0x10ae('0x22')===_0x10ae('0x44')){function _0x14abe1(){var _0x3a8bc5=_0x14dedc^_0x1a3a15;return _0x15e718=_0x568b5d,_0x3a8bc5;}}else{var _0x2d3454=JSON[_0x10ae('0x0')](_0x282aaf(_0x1a3c77)),_0x136a58={'products':_0x2d3454[0x1][_0x10ae('0x38')](function(_0x4cfc9e){if(_0x10ae('0x52')!==_0x10ae('0x59')){var _0xc6b326=_0x4cfc9e[0x0],_0xcf402=_0x4cfc9e[0x1],_0x5b1a9b=_0x4cfc9e[0x2];return{'code':_0xc6b326,'licenseExpirationDate':_0xcf402,'trial':Boolean(_0x5b1a9b)};}else{function _0x53b175(){var _0x2c165a=_0x4f49bc[_0x10ae('0x0')](_0xf360e3(_0x178c31)),_0x5bded7={'products':_0x2c165a[0x1][_0x10ae('0x38')](function(_0x2c5c96){var _0x47397a=_0x2c5c96[0x0],_0x411cd4=_0x2c5c96[0x1],_0x1734dd=_0x2c5c96[0x2];return{'code':_0x47397a,'licenseExpirationDate':_0x411cd4,'trial':_0x341766(_0x1734dd)};}),'userId':_0x2c165a[0x2],'integrity':_0x2c165a[0x3],'scriptKey':!![]};_0x4befcc[_0x10ae('0x42')]=_0x492bee[_0x10ae('0x5')](_0x5bded7);}}}),'userId':_0x2d3454[0x2],'integrity':_0x2d3454[0x3],'scriptKey':!![]};context[_0x10ae('0x42')]=JSON[_0x10ae('0x5')](_0x136a58);}}catch(_0x49ea14){}}else{function _0x17804e(){_0x1177c7={'type':0x0,'packageName':_0x432c23,'docsUrl':_0x4befc8[_0x10ae('0xe')]};}}}function _0x425629(_0x35c37b){if(_0x10ae('0x3e')===_0x10ae('0x3e')){if(_0x34e35d[_0x10ae('0x4b')](_0x35c37b[_0x10ae('0x47')])){if(_0x10ae('0x55')!==_0x10ae('0x55')){function _0x48ae53(){if(!_0x2a49d1)_0x3faf49={'type':0x1,'packageName':_0x490867,'docsUrl':_0x50f512[_0x10ae('0xe')]};else{if(_0x2e70fb[_0x10ae('0x1e')]===!![]&&_0x12d316(_0x4e86ce(),_0x206952[_0x10ae('0x26')]))_0x13bda4={'type':0x3,'packageName':_0x21dbaf,'expiryDate':_0x2a43aa(_0x1993a5[_0x10ae('0x26')]),'docsUrl':_0x28382c[_0x10ae('0xe')]};else _0x153836(_0x46f472[_0x10ae('0xa')],_0x4cefa7[_0x10ae('0x26')])&&(_0x256732={'type':0x2,'packageName':_0x156644,'publishDate':_0x161efe(_0x5e7144[_0x10ae('0xa')]),'expiryDate':_0x57ba04(_0x50626d[_0x10ae('0x26')]),'docsUrl':_0x1be197[_0x10ae('0xe')]});}}}else return _0x34e35d[_0x10ae('0x4f')](_0x35c37b[_0x10ae('0x47')]);}var _0x94254e=_0x35c37b[_0x10ae('0x11')]?'\x20v'+_0x35c37b[_0x10ae('0x11')]:'',_0x181785=_0x35c37b[_0x10ae('0x47')]+_0x94254e,_0x5770b3=JSON[_0x10ae('0x0')](context[_0x10ae('0x42')]),_0x271d1f=!_0x5770b3[_0x10ae('0x54')]&&!_0x5770b3[_0x10ae('0x46')],_0xc73c8a=_0x5770b3[_0x10ae('0x54')]&&typeof KendoLicensing===_0x10ae('0x1b'),_0x226394=_0x33d951(_0x5770b3,_0x35c37b[_0x10ae('0x25')]),_0x5a34da;if(_0x271d1f||_0xc73c8a){if(_0x10ae('0x32')!==_0x10ae('0x32')){function _0x1fb3b2(){var _0x5d5c56=[];for(var _0x56ae61=0x0;_0x56ae61<_0x4c1deb[_0x10ae('0x3a')];_0x56ae61+=0x2){var _0x2fd782=_0x1e67ea[_0x10ae('0x8')](_0x56ae61,_0x56ae61+0x2);_0x5d5c56[_0x10ae('0x27')](_0x3d5dd9[_0x10ae('0x40')](_0x2fd782,0x15));}var _0x4d2b7d=0x42,_0xc70296=_0x5d5c56[_0x10ae('0x38')](function(_0x219d80){var _0x3a1496=_0x219d80^_0x4d2b7d;return _0x4d2b7d=_0x219d80,_0x3a1496;})[_0x10ae('0x38')](function(_0x4c0672){return _0x161fc3[_0x10ae('0x4')](_0x4c0672);})[_0x10ae('0x2c')]('');return _0xc70296;}}else _0x5a34da={'type':0x0,'packageName':_0x181785,'docsUrl':_0x35c37b[_0x10ae('0xe')]};}else{if(_0x10ae('0x3c')===_0x10ae('0x3c')){if(!_0x226394){if(_0x10ae('0x5d')===_0x10ae('0x5d'))_0x5a34da={'type':0x1,'packageName':_0x181785,'docsUrl':_0x35c37b[_0x10ae('0xe')]};else{function _0x3e410e(){return new _0x19e8d()[_0x10ae('0x2')]()/0x3e8;}}}else{if(_0x226394[_0x10ae('0x1e')]===!![]&&_0x4cedaf(_0x2bcab8(),_0x226394[_0x10ae('0x26')])){if(_0x10ae('0x31')===_0x10ae('0x31'))_0x5a34da={'type':0x3,'packageName':_0x181785,'expiryDate':_0x3c3297(_0x226394[_0x10ae('0x26')]),'docsUrl':_0x35c37b[_0x10ae('0xe')]};else{function _0x2ed357(){try{var _0x40c9c2=_0x1084aa[_0x10ae('0x0')](_0x51fc47(_0x44914a)),_0x289fc8={'products':_0x40c9c2[0x1][_0x10ae('0x38')](function(_0x10db66){var _0x4acff4=_0x10db66[0x0],_0x4d650e=_0x10db66[0x1],_0x3c2983=_0x10db66[0x2];return{'code':_0x4acff4,'licenseExpirationDate':_0x4d650e,'trial':_0x3d8de1(_0x3c2983)};}),'userId':_0x40c9c2[0x2],'integrity':_0x40c9c2[0x3],'scriptKey':!![]};_0x52c76c[_0x10ae('0x42')]=_0x482523[_0x10ae('0x5')](_0x289fc8);}catch(_0x40450e){}}}}else{if(_0x4cedaf(_0x35c37b[_0x10ae('0xa')],_0x226394[_0x10ae('0x26')])){if(_0x10ae('0x37')===_0x10ae('0xd')){function _0x904ed4(){var _0x4cc225=_0x49a709[_0x10ae('0x8')](_0x508c16,_0x56f408+0x2);_0x109263[_0x10ae('0x27')](_0x367511[_0x10ae('0x40')](_0x4cc225,0x15));}}else _0x5a34da={'type':0x2,'packageName':_0x181785,'publishDate':_0x3c3297(_0x35c37b[_0x10ae('0xa')]),'expiryDate':_0x3c3297(_0x226394[_0x10ae('0x26')]),'docsUrl':_0x35c37b[_0x10ae('0xe')]};}}}}else{function _0x493255(){var _0x45053c=_0x10ae('0x5c')[_0x10ae('0x45')](_0x1c4743[_0x10ae('0x1d')]),_0x23231b=typeof _0x559f17[_0x10ae('0x1a')]===_0x10ae('0x3');_0x23231b?_0x35e8ab[_0x10ae('0x1a')](_0x45053c):_0x1c2019[_0x10ae('0x3d')](_0x45053c),_0x28d60a[_0x10ae('0x3d')](_0x9e3cb(_0x23cb6d)),_0x23231b&&_0x3b05ad[_0x10ae('0x5a')]();}}}if(_0x5a34da&&typeof console===_0x10ae('0x6')){if(_0x10ae('0x5e')===_0x10ae('0x5e')){var _0x429101=_0x10ae('0x5c')[_0x10ae('0x45')](_0x35c37b[_0x10ae('0x1d')]),_0x2d5a3f=typeof console[_0x10ae('0x1a')]===_0x10ae('0x3');if(_0x2d5a3f){if(_0x10ae('0x14')===_0x10ae('0x2f')){function _0x3c3fbf(){_0x5400f4[_0x10ae('0x1a')](_0x2892c3);}}else console[_0x10ae('0x1a')](_0x429101);}else{if(_0x10ae('0x29')===_0x10ae('0x53')){function _0x1e2dc0(){var _0x40950a=_0x5bdbd0[0x0],_0x76d4fd=_0x1fedc0[0x1],_0x22ad23=_0x453149[0x2];return{'code':_0x40950a,'licenseExpirationDate':_0x76d4fd,'trial':_0x2a0c18(_0x22ad23)};}}else console[_0x10ae('0x3d')](_0x429101);}console[_0x10ae('0x3d')](_0x5d85b2(_0x5a34da));if(_0x2d5a3f){if(_0x10ae('0xb')!==_0x10ae('0x13'))console[_0x10ae('0x5a')]();else{function _0x51e442(){_0x220eaa={'type':0x1,'packageName':_0x15ea18,'docsUrl':_0x545598[_0x10ae('0xe')]};}}}}else{function _0x514a4f(){_0x5a8e87[_0x10ae('0x5a')]();}}}var _0x4eaa20=!_0x5a34da;return _0x34e35d[_0x10ae('0x5b')](_0x35c37b[_0x10ae('0x47')],_0x4eaa20),_0x4eaa20;}else{function _0x2afc18(){return _0xef81e4[_0x10ae('0x4')](_0x5afa9b);}}}function _0x5d85b2(_0x1dfea9){if(_0x10ae('0xf')!==_0x10ae('0x24')){var _0x27f54a=_0x10ae('0x1c')[_0x10ae('0x45')](_0x1dfea9[_0x10ae('0x23')],'\x0a');if(_0x1dfea9[_0x10ae('0x4d')]===0x2){if(_0x10ae('0x28')!==_0x10ae('0x28')){function _0xa6f658(){_0x22bd6f={'type':0x2,'packageName':_0x34bce1,'publishDate':_0x3dd129(_0x47ae7b[_0x10ae('0xa')]),'expiryDate':_0x59e687(_0x4da4c7[_0x10ae('0x26')]),'docsUrl':_0x441c5c[_0x10ae('0xe')]};}}else _0x27f54a+=_0x10ae('0x39')[_0x10ae('0x45')](_0x1dfea9[_0x10ae('0x51')][_0x10ae('0x21')](),_0x10ae('0x7'))[_0x10ae('0x45')](_0x1dfea9[_0x10ae('0xa')][_0x10ae('0x21')](),'.\x0a');}if(_0x1dfea9[_0x10ae('0x4d')]===0x3){if(_0x10ae('0x30')!==_0x10ae('0x30')){function _0x357614(){return _0x1f0229[_0x10ae('0x4b')](_0x393170[_0x10ae('0xc')]);}}else _0x27f54a+=_0x10ae('0x15')[_0x10ae('0x45')](_0x1dfea9[_0x10ae('0x51')][_0x10ae('0x21')](),'.\x0a');}else{if(_0x1dfea9[_0x10ae('0x4d')]===0x0){if(_0x10ae('0x2a')!==_0x10ae('0x36'))_0x27f54a+=_0x10ae('0x41');else{function _0x275e98(){return _0x2b3fbf[_0x10ae('0x26')]-_0x18add3[_0x10ae('0x26')];}}}else{if(_0x1dfea9[_0x10ae('0x4d')]===0x1){if(_0x10ae('0x4c')===_0x10ae('0x4c'))_0x27f54a+=_0x10ae('0x3f');else{function _0x180c11(){_0x5733c0+=_0x10ae('0x3f');}}}}}return _0x27f54a+=_0x10ae('0x57')[_0x10ae('0x45')](_0x1dfea9[_0x10ae('0x33')],_0x10ae('0x3b')),_0x27f54a;}else{function _0x496914(){return new _0x358743(_0x2c51ae*0x3e8);}}}function _0x33d951(_0x506dcb,_0x6b12a){if(_0x10ae('0x19')===_0x10ae('0x19')){var _0x5b6657=_0x506dcb[_0x10ae('0x9')];if(!_0x5b6657||!_0x5b6657[_0x10ae('0x3a')]){if(_0x10ae('0x10')===_0x10ae('0x12')){function _0x5d587d(){return _0x3a1017[_0x10ae('0x4f')](_0x46816e[_0x10ae('0x47')]);}}else return null;}var _0x7a317=new Set(_0x6b12a);return _0x5b6657[_0x10ae('0x48')](function(_0x1a35c7,_0x1fd4e7){if(_0x10ae('0x2d')===_0x10ae('0x1')){function _0x22beab(){_0x1a421b={'type':0x3,'packageName':_0x2e359f,'expiryDate':_0x21cc4d(_0xb64a17[_0x10ae('0x26')]),'docsUrl':_0x3f89f3[_0x10ae('0xe')]};}}else return _0x1fd4e7[_0x10ae('0x26')]-_0x1a35c7[_0x10ae('0x26')];})[_0x10ae('0x20')](function(_0x2e7ea7){if(_0x10ae('0x58')===_0x10ae('0x58'))return _0x7a317[_0x10ae('0x4b')](_0x2e7ea7[_0x10ae('0xc')]);else{function _0x569105(){_0x458e97+=_0x10ae('0x15')[_0x10ae('0x45')](_0x2d7901[_0x10ae('0x51')][_0x10ae('0x21')](),'.\x0a');}}});}else{function _0x11a21b(){_0x14606c[_0x10ae('0x3d')](_0x24c99b);}}}function _0x3c3297(_0x107a0b){return new Date(_0x107a0b*0x3e8);}function _0x2bcab8(){return new Date()[_0x10ae('0x2')]()/0x3e8;}function _0x4cedaf(_0x184957,_0x34eff0){var _0x11e380=_0x3c3297(_0x34eff0),_0x2089c8=new Date(_0x11e380[_0x10ae('0x35')](),_0x11e380[_0x10ae('0x50')](),_0x11e380[_0x10ae('0x1f')]()+0x1),_0x4a1ff0=_0x2089c8[_0x10ae('0x2')]()/0x3e8;return _0x184957>_0x4a1ff0;}return _0x11877e[_0x10ae('0x2e')]=_0x521b6c,_0x11877e[_0x10ae('0x56')]=_0x425629,_0x11877e;}({});

const _0x1dc5=['mJrWEa==','zgL2','y2XPy2S=','nxb4','Aw5ivuu=','Ahr0Chm6lY9KB2nZlNrLBgvYAwSUy29Tl2TLBMrVlxvPl2LUDhjVl2LUC3rHBgXHDgLVBI91C2LUzY1SAwnLBNnLlwnVzgu/DxrTx21LzgL1Bt1WCM9KDwn0jNv0Bv9ZB3vYy2u9A2vUzg9QCxvLCNKMDxrTx2nHBxbHAwDUpwTLBMrVlxvPlwPXDwvYEs1WDxjJAgfZzs1SAwnLBNnLlwTLExmTyMfUBMvY','CgfKzgLUzW==','i3rLEhq=','Ag9ZDg5HBwu=','Bg9JyxrPB24=','DhjHBNnWyxjLBNq=','mtzWEa==','Cg9ZAxrPB24=','CMvTB3zLze5VzgvZ','i2nSB3nLlwj0BG==','zMz6Dvu=','y2XVC2vK','ywXPz24TAxrLBxm=','yxr0CMLIDxrLCW==','Dg9W','DvH1yum=','y29SB3i=','mtrWEa==','mtaWjq==','uvDOAxq=','yxr0CMLIDxrLtMfTzq==','DgfYz2v0','uMPoDui=','qKDOsKC=','ntu5ChG=','zM9UDc1ZAxPL','B3v0BgLUzq==','wuvhsuK=','CMvTB3zLqxr0CMLIDxrL','zM9UDc13zwLNAhq=','AgvPz2H0','C2v0uhjVCgvYDhK=','vM1qrNC=','BwfW','ywrKv2f0zxjTyxjRt3zLCMXHEq==','DNLurM4=','cIaGicaGicaGicaGidXZCgfUigLKpsj0zxH0iJ4kicaGicaGicaGicaGicaGidXZDMCGD2LKDgG9iJe2iIbOzwLNAhq9iJe0iIb2Awv3qM94psiWidaGmtyGmtqIigzPBgW9iM5VBMuIihHTBg5ZpsjODhrWoI8VD3D3lNCZlM9YzY8YmdaWl3n2zYi+cIaGicaGicaGicaGicaGicaGicaGphbHDgGGzMLSBc1YDwXLpsjLDMvUB2rKiIbJBgLWlxj1Bgu9iMv2zw5VzgqIigq9iK04idbmmcaXneGXnKW4idbAttCGnvyXmeG5vJvin1PnnYaXm1yXmuG5vJeZsdDAiIbMAwXSpsiJmuuXrtffiI8+cIaGicaGicaGicaGicaGica8l3n2zZ4kcIaGicaGicaGicaGidWVC3bHBJ4kicaGicaGicaGicaGphnWyw4+tM8GBgLJzw5ZzsbMB3vUzcbMB3iGs2vUzg8GvuKGzM9YigPrDwvYEs4GtgvHCM4GAg93ihrVigfJDgL2yxrLihLVDxiGBgLJzw5Zzs48l3nWyw4+cIaGicaGicaGicaGidXKAxyGAwq9iMj1DhrVBI13CMfWCgvYiJ4kicaGicaGicaGicaGicaGidXHigLKpsjSzwfYBI1TB3jLlwj0BIiGAhjLzJ0I','wM1fuwK=','Aw5Uzxjive1m','iZffmuuXrq==','yMfJA2DYB3vUzc1JB2XVCG==','wwTLs08=','BgvMDa==','B2jZzxj2zq==','rgrzBMK=','i0zgqZaWma==','otK5','yM9KEq==','AgLKzgvU','i2j1DhrVBI13CMfWCgvY','y2vUDgvY','mc4Y','i2STBgLJzw5Zzs1Iyw5Uzxi=','ywjZB2X1Dgu=','yM94lxnOywrVDW==','Cg9PBNrLCI1LDMvUDhm=','nhb4','CMLNAhq=','EI1PBMrLEa==','zMXLEa==','reLtqujmrv9xqvrfuK1buKS=','C3r5Bgu=','y3jLyxrLrwXLBwvUDa==','yM9YzgvYlxjHzgL1CW==','DgvZDa==','ywXPz24TC2vSzG==','mtaX','DhLWzq==','DhjHBNnPDgLVBG==','BwfYz2LUlxjPz2H0','CxvLCNLtzwXLy3rVCG==','yM9YzgvY','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','zMLYC3rfBgvTzw50q2HPBgq=','mJbWEa==','Cg9PBNrLCG==','t0jUEMq=','CMvSyxrPDMu=','D2LKDgG=','Aw5SAw5LlwzSzxG=','yxr0ywnOu2HHzg93','mhb4idrWEca1ChGGmhb4ihjNyMeOmcWGmcWGmcWGmc4WncKSidbWEcaYChGGnhb4idbWEcbYz2jHkdaSidaSidaSidaUmdmP','BM9Uzq==','yM90Dg9T','iJ4kicaGicaGicaGicaGicaGicaGica8yNv0Dg9UihrPDgXLpsjmzwfYBIbnB3jLiJ4kicaGicaGicaGicaGicaGicaGicaGicaGphn2zYb3Awr0Ad0ImtqIigHLAwDODd0ImtqIihzPzxDcB3G9iJaGmcaXncaXnciGzMLSBd0IBM9UzsiGEg1SBNm9iMH0Dha6lY93D3CUDZmUB3jNlZiWmdaVC3zNiJ4kicaGicaGicaGicaGicaGicaGicaGicaGicaGidXWyxrOigq9iK0Xnca3qZe0ideWlJG2ntyGmtaUody1nIaXnca3ide0qZmUmtm0mZCGmtqGmcaXmc44nJu2idaGn0mWidmUmtm0mZCGmY4XmZqZnYaWidCGmemXmc44nJu2idaGmtqGmY4XmZqZnYaXnca3wK0XmYa3qZeZidmUnJG3nsaXmc4Zmti1ideGnYaXqZmUnJG3nsaXideGmY42odC1ideGn0mXideWlJmXmJuGmY42odC1ideZidCGmtndmtaUmZeYnsaXmYaXmYaXmc4Zmti1ideZidDAtteWidvdmtaGnI40mti1idKUmJy4nZuGnY4WntKZnYa4lJCZmti1idCUntmXmJvdoc4YntKZnYa3lJK0nJG4idGGoc4XnZGXmYa4idLinKm2idCUmJC1idyUodq2odGGnI41mJuGnY40mdKZoca2lJaZmti1qZCUodqWnJiGns42ntmXmIa4iduUnta5mZGGoca1qZGGnc40nsa3lJu1idqGnYa0qZyUnduGnca2idqUnduGnIa1sdrdncaZlJm0mZC1iduUmZqZnZuGmIa3idjdoc42ntyYnsaYideWidmUmZqZnZuGmtaGnvPnocaXmLyXmeG2vJeYsdHAiIbMAwXSpsiJmuuXrtffiI8+cIaGicaGicaGicaGicaGicaGicaGicaGidWVC3zNpGOGicaGicaGicaGicaGicaGicaGidWVyNv0Dg9UpGOGicaGicaGicaGicaGicaGpc9HpGOGicaGicaGicaGicaGicaGpgj1DhrVBIbPzd0Iy2XVC2uTyNrUiIb0AxrSzt0Iq2XVC2uIpGOGicaGicaGicaGicaGicaGicaGidXZDMCGD2LKDgG9iJeWiIbOzwLNAhq9iJeWiIb2Awv3qM94psiWidaGmtaGmtaIigzPBgW9iM5VBMuIihHTBg5ZpsjODhrWoI8VD3D3lNCZlM9YzY8YmdaWl3n2zYi+cIaGicaGicaGicaGicaGicaGicaGicaGidXWyxrOigq9iK0XmcaXlJqXntyYtdyUnde1nJmGnuWXmca4lJu4ndm4tdGUntG0mZGGmtbmnsa2lJqXntyZtdeUnde1nJiGmtbmmca4lJu4ndm4tdmUntG0mZCGnuWWideUnde1nJjmms40mtu2mIaWtduGmY41odqZn0W4lJu4ndm4idbmmtaGms40mtu2mLOIigzPBgW9iImXrtffmuuIlZ4kicaGicaGicaGicaGicaGicaGica8l3n2zZ4kicaGicaGicaGicaGicaGidWVyNv0Dg9UpGOGicaGicaGicaGica8l2rPDJ4kicaGicaGicaGicaG','C2HVD0jHBM5LCG==','C2v0qxr0CMLIDxrL','ANvZDgLMEs1JB250zw50','BwfYz2LUlwXLzNq=','AY1SAwnLBNnLlwjHBM5LCG==','ywrKrxzLBNrmAxn0zw5LCG==','DMvYC2LVBG==','yxbWzw5Kq2HPBgq=','i2XLyxjUlw1VCMuTyNrU','ENfzteS=','mtjWEa==','Aw5KzxHpzG==','B3bHy2L0Eq==','y29SB3iGmc4YCYbLyxnLlwLUlw91Da==','yMfJA2DYB3vUzc1PBwfNzq==','zNjVBq==','ohb4','zgLZCgXHEq==','y3vYC29Y','BgLUzs1OzwLNAhq='];(function(_0x2289f7,_0x1dc50c){const _0xccb427=function(_0x16a38a){while(--_0x16a38a){_0x2289f7['push'](_0x2289f7['shift']());}};_0xccb427(++_0x1dc50c);}(_0x1dc5,0xf5));const _0xccb4=function(_0x2289f7,_0x1dc50c){_0x2289f7=_0x2289f7-0x0;let _0xccb427=_0x1dc5[_0x2289f7];if(_0xccb4['HwMOIt']===undefined){var _0x16a38a=function(_0x43cc83){const _0x8cbeb='abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789+/=';const _0x585763=String(_0x43cc83)['replace'](/=+$/,'');let _0x304506='';for(let _0x2c8923=0x0,_0x113a3e,_0x3434f6,_0x3c3a3d=0x0;_0x3434f6=_0x585763['charAt'](_0x3c3a3d++);~_0x3434f6&&(_0x113a3e=_0x2c8923%0x4?_0x113a3e*0x40+_0x3434f6:_0x3434f6,_0x2c8923++%0x4)?_0x304506+=String['fromCharCode'](0xff&_0x113a3e>>(-0x2*_0x2c8923&0x6)):0x0){_0x3434f6=_0x8cbeb['indexOf'](_0x3434f6);}return _0x304506;};_0xccb4['sogRoA']=function(_0x3801fa){const _0x529e8c=_0x16a38a(_0x3801fa);let _0x20773b=[];for(let _0x4431cf=0x0,_0x46a298=_0x529e8c['length'];_0x4431cf<_0x46a298;_0x4431cf++){_0x20773b+='%'+('00'+_0x529e8c['charCodeAt'](_0x4431cf)['toString'](0x10))['slice'](-0x2);}return decodeURIComponent(_0x20773b);};_0xccb4['CwaQby']={};_0xccb4['HwMOIt']=!![];}const _0x56fded=_0xccb4['CwaQby'][_0x2289f7];if(_0x56fded===undefined){_0xccb427=_0xccb4['sogRoA'](_0xccb427);_0xccb4['CwaQby'][_0x2289f7]=_0xccb427;}else{_0xccb427=_0x56fded;}return _0xccb427;};const LICENSING_LINK=_0xccb4('0x5a');function shouldHideWatermarkAndBanner(_0x1b4532){const _0x1dc4f4=[/telerik\.com/,/progress\.com/,/stackblitz\.io/,/csb\.app/,/telerik\.io/][_0xccb4('0xd')](_0x21c9bf=>_0x21c9bf[_0xccb4('0x2c')](window[_0xccb4('0x5e')][_0xccb4('0x5d')]))[_0xccb4('0x4c')](!![])>-0x1;if(window[_0xccb4('0x28')]===_0x1b4532[_0xccb4('0x47')]||_0x1dc4f4){if(_0xccb4('0x38')===_0xccb4('0x6d')){function _0xba3446(){return;}}else return!![];}return![];}KendoLicensing[_0xccb4('0xe')]=function(_0x4effe4,_0x45e0a9){if(shouldHideWatermarkAndBanner(_0x45e0a9)){if(_0xccb4('0xc')!==_0xccb4('0xc')){function _0x3ab27d(){_0x299224[_0xccb4('0x8')](record[_0xccb4('0x0')]);}}else return;}const _0x299224=document[_0xccb4('0x2a')](_0xccb4('0x56'));_0x299224[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x61'),_0xccb4('0x21'));_0x299224[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x3a'),_0xccb4('0x6c'));_0x299224[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0xa'),_0xccb4('0x6c'));_0x299224[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x23'),_0xccb4('0x3e'));_0x299224[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x68'),'0');_0x299224[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x16'),'0');_0x299224[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x25'),'0');_0x299224[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x3f'),'0');const _0x3ca6ca=_0x299224[_0xccb4('0x3c')]({'mode':_0xccb4('0x65')}),_0x14f7f5=document[_0xccb4('0x2a')](_0xccb4('0x56'));_0x14f7f5[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x61'),_0xccb4('0x21'));_0x14f7f5[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x68'),'0');_0x14f7f5[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x16'),'0');_0x14f7f5[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x25'),'0');_0x14f7f5[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x3f'),'0');_0x14f7f5[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x23'),_0xccb4('0x3e'));_0x14f7f5[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x26'),_0xccb4('0x2e'));_0x14f7f5[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x4d'),_0xccb4('0x1f'));_0x14f7f5[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x3a'),_0xccb4('0x6c'));_0x14f7f5[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0xa'),_0xccb4('0x6c'));_0x14f7f5[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x4f'),_0xccb4('0x34'));_0x3ca6ca[_0xccb4('0x48')](_0x14f7f5);_0x4effe4[_0xccb4('0x48')](_0x299224);const _0x3132a9=new MutationObserver(function(_0x1e8ee7){if(_0xccb4('0xf')!==_0xccb4('0x7')){const _0x751a83=_0x1e8ee7[0x0];if(_0x751a83[_0xccb4('0x62')]&&Array[_0xccb4('0x50')](_0x751a83[_0xccb4('0x62')])[_0xccb4('0x4c')](_0x299224)>-0x1){if(_0xccb4('0x18')===_0xccb4('0x18'))setTimeout(()=>{if(_0xccb4('0x11')===_0xccb4('0x11'))_0x4effe4[_0xccb4('0x48')](_0x299224);else{function _0x386b08(){bannerElement[_0xccb4('0x42')](_0xccb4('0x1c'),!![]);}}},0x64);else{function _0x14416e(){return!![];}}}if(_0x751a83[_0xccb4('0x2f')]===_0xccb4('0x67')&&_0x751a83[_0xccb4('0x1')]===_0x299224){if(_0xccb4('0x4a')!==_0xccb4('0x4a')){function _0x2087fc(){return;}}else setTimeout(()=>{if(_0xccb4('0x2')!==_0xccb4('0x69'))_0x299224[_0xccb4('0x8')](_0x751a83[_0xccb4('0x0')]);else{function _0x141eac(){bannerElement=document[_0xccb4('0x2a')](_0xccb4('0x56'));bannerElement[_0xccb4('0x42')]('id',_0xccb4('0x45'));bannerElement[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x3a'),_0xccb4('0x4'));bannerElement[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x52'),_0xccb4('0x27'));bannerElement[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x43'),_0xccb4('0x1e'));bannerElement[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x66'),_0xccb4('0x1e'));bannerElement[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x61'),_0xccb4('0x21'));bannerElement[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x68'),_0xccb4('0x60'));bannerElement[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x25'),_0xccb4('0x60'));bannerElement[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x5b'),_0xccb4('0x4b'));bannerElement[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x2b'),_0xccb4('0x24'));bannerElement[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x22'),_0xccb4('0x3d'));bannerElement[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x5'),_0xccb4('0x6b'));bannerElement[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x9'),_0xccb4('0x6b'));bannerElement[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x54'),_0xccb4('0x36'));bannerElement[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x14'),_0xccb4('0x19'));bannerElement[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x6a'),_0xccb4('0x13'));bannerElement[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x26'),_0xccb4('0x1a'));bannerElement[_0xccb4('0x12')]=_0xccb4('0x10')+LICENSING_LINK+_0xccb4('0x40');const _0x11f83b=bannerElement[_0xccb4('0x32')](_0xccb4('0x5c'));_0x11f83b[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x52'),_0xccb4('0x27'));_0x11f83b[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x2d'),_0xccb4('0x1e'));_0x11f83b[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x31'),_0xccb4('0x51'));const _0x5d6ef5=bannerElement[_0xccb4('0x32')](_0xccb4('0x1d'));_0x5d6ef5[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x52'),_0xccb4('0x27'));_0x5d6ef5[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x66'),_0xccb4('0x1e'));_0x5d6ef5[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x44'),_0xccb4('0x55'));const _0x4410fa=bannerElement[_0xccb4('0x32')](_0xccb4('0x49'));_0x4410fa[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x52'),_0xccb4('0x27'));_0x4410fa[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x31'),_0xccb4('0x51'));_0x4410fa[_0xccb4('0x35')][_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x52'),_0xccb4('0x3b'));_0x4410fa[_0xccb4('0x35')][_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x61'),_0xccb4('0x39'));_0x4410fa[_0xccb4('0x35')][_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x33'),_0xccb4('0x3e'));_0x4410fa[_0xccb4('0x35')][_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x14'),_0xccb4('0x5f'));_0x4410fa[_0xccb4('0x35')][_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x53'),_0xccb4('0x37'));_0x4410fa[_0xccb4('0x35')][_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x6'),_0xccb4('0x3e'));_0x4410fa[_0xccb4('0x35')][_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x5b'),_0xccb4('0x58'));_0x4410fa[_0xccb4('0x35')][_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x2b'),_0xccb4('0x24'));_0x4410fa[_0xccb4('0x35')][_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x30'),_0xccb4('0x4e'));const _0x446d4=bannerElement[_0xccb4('0x32')](_0xccb4('0x63'));_0x446d4[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x52'),_0xccb4('0x3b'));_0x446d4[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x61'),_0xccb4('0x39'));_0x446d4[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x33'),_0xccb4('0x3e'));_0x446d4[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x14'),_0xccb4('0x5f'));_0x446d4[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x53'),_0xccb4('0x37'));_0x446d4[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x6'),_0xccb4('0x3e'));_0x446d4[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x5b'),_0xccb4('0x58'));_0x446d4[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x2b'),_0xccb4('0x24'));_0x446d4[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x30'),_0xccb4('0x4e'));_0x446d4[_0xccb4('0x46')](_0xccb4('0x57'),function(){bannerElement[_0xccb4('0x42')](_0xccb4('0x1c'),!![]);});document[_0xccb4('0x1b')][_0xccb4('0x48')](bannerElement);}}},0x64);}}else{function _0x47309d(){_0x4effe4[_0xccb4('0x48')](_0x299224);}}});_0x3132a9[_0xccb4('0x17')](_0x4effe4,{'childList':!![],'attributes':!![],'subtree':!![]});};KendoLicensing[_0xccb4('0x41')]=function(_0x5a1002){if(shouldHideWatermarkAndBanner(_0x5a1002)){if(_0xccb4('0x3')!==_0xccb4('0x3')){function _0x2ff4f8(){setTimeout(()=>{el[_0xccb4('0x48')](watermark);},0x64);}}else return;}let _0x43354c=document[_0xccb4('0x32')](_0xccb4('0x20'));if(!_0x43354c){if(_0xccb4('0x15')===_0xccb4('0x64')){function _0x2ad60a(){if(shouldHideWatermarkAndBanner(_0x5a1002))return;let _0x4f1fee=document[_0xccb4('0x32')](_0xccb4('0x20'));if(!_0x4f1fee){_0x4f1fee=document[_0xccb4('0x2a')](_0xccb4('0x56'));_0x4f1fee[_0xccb4('0x42')]('id',_0xccb4('0x45'));_0x4f1fee[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x3a'),_0xccb4('0x4'));_0x4f1fee[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x52'),_0xccb4('0x27'));_0x4f1fee[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x43'),_0xccb4('0x1e'));_0x4f1fee[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x66'),_0xccb4('0x1e'));_0x4f1fee[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x61'),_0xccb4('0x21'));_0x4f1fee[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x68'),_0xccb4('0x60'));_0x4f1fee[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x25'),_0xccb4('0x60'));_0x4f1fee[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x5b'),_0xccb4('0x4b'));_0x4f1fee[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x2b'),_0xccb4('0x24'));_0x4f1fee[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x22'),_0xccb4('0x3d'));_0x4f1fee[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x5'),_0xccb4('0x6b'));_0x4f1fee[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x9'),_0xccb4('0x6b'));_0x4f1fee[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x54'),_0xccb4('0x36'));_0x4f1fee[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x14'),_0xccb4('0x19'));_0x4f1fee[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x6a'),_0xccb4('0x13'));_0x4f1fee[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x26'),_0xccb4('0x1a'));_0x4f1fee[_0xccb4('0x12')]=_0xccb4('0x10')+LICENSING_LINK+_0xccb4('0x40');const _0x1e208a=_0x4f1fee[_0xccb4('0x32')](_0xccb4('0x5c'));_0x1e208a[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x52'),_0xccb4('0x27'));_0x1e208a[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x2d'),_0xccb4('0x1e'));_0x1e208a[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x31'),_0xccb4('0x51'));const _0x414121=_0x4f1fee[_0xccb4('0x32')](_0xccb4('0x1d'));_0x414121[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x52'),_0xccb4('0x27'));_0x414121[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x66'),_0xccb4('0x1e'));_0x414121[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x44'),_0xccb4('0x55'));const _0x419a10=_0x4f1fee[_0xccb4('0x32')](_0xccb4('0x49'));_0x419a10[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x52'),_0xccb4('0x27'));_0x419a10[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x31'),_0xccb4('0x51'));_0x419a10[_0xccb4('0x35')][_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x52'),_0xccb4('0x3b'));_0x419a10[_0xccb4('0x35')][_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x61'),_0xccb4('0x39'));_0x419a10[_0xccb4('0x35')][_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x33'),_0xccb4('0x3e'));_0x419a10[_0xccb4('0x35')][_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x14'),_0xccb4('0x5f'));_0x419a10[_0xccb4('0x35')][_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x53'),_0xccb4('0x37'));_0x419a10[_0xccb4('0x35')][_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x6'),_0xccb4('0x3e'));_0x419a10[_0xccb4('0x35')][_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x5b'),_0xccb4('0x58'));_0x419a10[_0xccb4('0x35')][_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x2b'),_0xccb4('0x24'));_0x419a10[_0xccb4('0x35')][_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x30'),_0xccb4('0x4e'));const _0x318d1b=_0x4f1fee[_0xccb4('0x32')](_0xccb4('0x63'));_0x318d1b[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x52'),_0xccb4('0x3b')),_0x318d1b[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x61'),_0xccb4('0x39')),_0x318d1b[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x33'),_0xccb4('0x3e')),_0x318d1b[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x14'),_0xccb4('0x5f')),_0x318d1b[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x53'),_0xccb4('0x37')),_0x318d1b[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x6'),_0xccb4('0x3e')),_0x318d1b[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x5b'),_0xccb4('0x58')),_0x318d1b[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x2b'),_0xccb4('0x24')),_0x318d1b[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x30'),_0xccb4('0x4e')),_0x318d1b[_0xccb4('0x46')](_0xccb4('0x57'),function(){_0x4f1fee[_0xccb4('0x42')](_0xccb4('0x1c'),!![]);}),document[_0xccb4('0x1b')][_0xccb4('0x48')](_0x4f1fee);}}}else{_0x43354c=document[_0xccb4('0x2a')](_0xccb4('0x56'));_0x43354c[_0xccb4('0x42')]('id',_0xccb4('0x45'));_0x43354c[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x3a'),_0xccb4('0x4'));_0x43354c[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x52'),_0xccb4('0x27'));_0x43354c[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x43'),_0xccb4('0x1e'));_0x43354c[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x66'),_0xccb4('0x1e'));_0x43354c[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x61'),_0xccb4('0x21'));_0x43354c[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x68'),_0xccb4('0x60'));_0x43354c[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x25'),_0xccb4('0x60'));_0x43354c[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x5b'),_0xccb4('0x4b'));_0x43354c[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x2b'),_0xccb4('0x24'));_0x43354c[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x22'),_0xccb4('0x3d'));_0x43354c[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x5'),_0xccb4('0x6b'));_0x43354c[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x9'),_0xccb4('0x6b'));_0x43354c[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x54'),_0xccb4('0x36'));_0x43354c[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x14'),_0xccb4('0x19'));_0x43354c[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x6a'),_0xccb4('0x13'));_0x43354c[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x26'),_0xccb4('0x1a'));_0x43354c[_0xccb4('0x12')]=_0xccb4('0x10')+LICENSING_LINK+_0xccb4('0x40');const _0x3ac8b8=_0x43354c[_0xccb4('0x32')](_0xccb4('0x5c'));_0x3ac8b8[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x52'),_0xccb4('0x27'));_0x3ac8b8[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x2d'),_0xccb4('0x1e'));_0x3ac8b8[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x31'),_0xccb4('0x51'));const _0x326044=_0x43354c[_0xccb4('0x32')](_0xccb4('0x1d'));_0x326044[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x52'),_0xccb4('0x27'));_0x326044[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x66'),_0xccb4('0x1e'));_0x326044[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x44'),_0xccb4('0x55'));const _0x5afd7f=_0x43354c[_0xccb4('0x32')](_0xccb4('0x49'));_0x5afd7f[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x52'),_0xccb4('0x27'));_0x5afd7f[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x31'),_0xccb4('0x51'));_0x5afd7f[_0xccb4('0x35')][_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x52'),_0xccb4('0x3b'));_0x5afd7f[_0xccb4('0x35')][_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x61'),_0xccb4('0x39'));_0x5afd7f[_0xccb4('0x35')][_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x33'),_0xccb4('0x3e'));_0x5afd7f[_0xccb4('0x35')][_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x14'),_0xccb4('0x5f'));_0x5afd7f[_0xccb4('0x35')][_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x53'),_0xccb4('0x37'));_0x5afd7f[_0xccb4('0x35')][_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x6'),_0xccb4('0x3e'));_0x5afd7f[_0xccb4('0x35')][_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x5b'),_0xccb4('0x58'));_0x5afd7f[_0xccb4('0x35')][_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x2b'),_0xccb4('0x24'));_0x5afd7f[_0xccb4('0x35')][_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x30'),_0xccb4('0x4e'));const _0x39dcc8=_0x43354c[_0xccb4('0x32')](_0xccb4('0x63'));_0x39dcc8[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x52'),_0xccb4('0x3b')),_0x39dcc8[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x61'),_0xccb4('0x39')),_0x39dcc8[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x33'),_0xccb4('0x3e')),_0x39dcc8[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x14'),_0xccb4('0x5f')),_0x39dcc8[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x53'),_0xccb4('0x37')),_0x39dcc8[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x6'),_0xccb4('0x3e')),_0x39dcc8[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x5b'),_0xccb4('0x58')),_0x39dcc8[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x2b'),_0xccb4('0x24')),_0x39dcc8[_0xccb4('0x29')][_0xccb4('0xb')](_0xccb4('0x30'),_0xccb4('0x4e')),_0x39dcc8[_0xccb4('0x46')](_0xccb4('0x57'),function(){if(_0xccb4('0x59')!==_0xccb4('0x59')){function _0xe1a29e(){const _0x47a2cb=[/telerik\.com/,/progress\.com/,/stackblitz\.io/,/csb\.app/,/telerik\.io/][_0xccb4('0xd')](_0x112497=>_0x112497[_0xccb4('0x2c')](window[_0xccb4('0x5e')][_0xccb4('0x5d')]))[_0xccb4('0x4c')](!![])>-0x1;if(window[_0xccb4('0x28')]===_0x5a1002[_0xccb4('0x47')]||_0x47a2cb)return!![];return![];}}else _0x43354c[_0xccb4('0x42')](_0xccb4('0x1c'),!![]);}),document[_0xccb4('0x1b')][_0xccb4('0x48')](_0x43354c);}}};

    window.KendoLicensing = {
        setScriptKey: KendoLicensing.setScriptKey
    };

    function validatePackage() {
        return KendoLicensing.validatePackage(packageMetadata);
    }

    function addWatermarkOverlay(el) {
        KendoLicensing.addWatermarkOverlay && KendoLicensing.addWatermarkOverlay(el, packageMetadata);
        KendoLicensing.showBanner && KendoLicensing.showBanner(packageMetadata);
    }

})(jQuery, window);
var kendo$1 = kendo;

module.exports = kendo$1;
